export default {
	cadAeronave: {
		aviao: 'Avión',
		cadastroDeAeronave: 'Registro de Aeronave',
		ciclosT1: 'Ciclos Volados NF',
		ciclosVoados: 'Ciclos Volados',
		codinome: 'Nombre en clave',
		codinomeTipoIcao: 'Nombre en clave / Tipo ICAO',
		dadosAeroanve: 'Datos de la aeronave',
		dadosMotor: 'Datos del metor',
		dataFabricacao: 'Fecha de Fabricación',
		dataUltima: 'Fecha del último mantenimiento',
		etiqueta: 'Etiqueta',
		fabricante: 'Fabricante',
		helicoptero: 'Helicóptero',
		horasVoadas: 'Horas de Vuelo',
		imei: 'IMEI',
		matricula: 'Registro',
		modelo: 'Modelo',
		modeloMotor: 'Modelo del Motor',
		motor: 'Motor',
		msgAeronaveAtualizada: 'Aeronave insertada con éxito',
		msgAtualizada: 'Aviones actualizado correctamente.',
		msgInserida: 'La inspección ha añadido correctamente.',
		novaAeronave: 'Nueva Aeronave',
		pousos: 'Aterrizajes',
		prefixo: 'Prefijo',
		registro: 'Registro',
		serialNumber: 'Número de série',
		serialNumberMotor: 'Número de série del motor',
		tailNumber: 'Prefijo',
		tipo: 'Tipo',
	},
	calendario: {
		domingo: 'domingo',
		hoje: 'Hoy',
		quartaFeira: 'miércoles',
		quintaFeira: 'jueves',
		segundaFeira: 'lunes',
		sextaFeira: 'viernes',
		sábado: 'sábado',
		terçaFeira: 'martes',
	},
	componentNatureza: {
		cAddItem: 'Ud. sólo puede agregar un ítem',
		cItem: 'No se ha agregado ningún ítem todavía',
		cItemAdicionado: 'Ítems ya agregados',
		cItemJaAdicionado: 'Este ítem ya se agregó',
		cNatureza: 'Naturaleza de la Ocurrencia',
		cTipo: 'Tipo de la Ocurrencia',
	},
	componentRAisp: {
		aisp: 'Aisp',
		risp: 'Risp',
	},
	conversao: {
		ano: 'año',
		anos: 'años',
		ciclo: 'Ciclo',
		ciclos: 'ciclos',
		dia: 'día',
		dias: 'días',
		hora: 'hora',
		horas: 'horas',
		mes: 'mes',
		meses: 'meses',
	},
	cores: {
		amarelo: 'Amarillo',
		azul: 'Azul',
		cinza: ' Gris',
		preto: 'Negro',
		verde: 'Verde',
		vermelho: 'Rojo',
	},
	diasDaSemana: {
		domingo: 'Dom',
		quarta: 'Mie',
		quinta: 'Jue',
		sabado: 'Sab',
		segunda: 'Lun',
		sexta: 'Vie',
		terca: 'Mar',
	},
	diasSemana: {
		domingo: 'D',
		quarta: 'M',
		quinta: 'J',
		sabado: 'S',
		segunda: 'L',
		sexta: 'V',
		terca: 'M',
	},
	diasSemanaAbreviado: {
		0: 'DOM',
		1: 'LUN',
		2: 'MAR',
		3: 'MIE',
		4: 'JUE',
		5: 'VIE',
		6: 'MAR',
	},
	diasSemanaPos: {
		0: 'D',
		1: 'L',
		2: 'M',
		3: 'M',
		4: 'J',
		5: 'V',
		6: 'S',
	},
	gestao: {
		gestaoDe: 'Gestión',
	},
	global: {
		Altura: 'Altura',
		Desativando: 'Desactivando',
		Dias: 'Días',
		Em: 'En',
		JornadaTrabalhoEFolgasProgramadas: 'Horas de trabajo y días libres programados',
		Justificativa: 'Justificación',
		NenhumaNFSEncontrada: 'No se encontró ninguna factura',
		PDFICPBrasil: 'PDF ICP Brasil',
		PermissoesAcessoLayers: 'Permisos de acceso a capa',
		Por: 'Por',
		TipoDeEmbalagem: 'Tipo de embalaje',
		aListaAbaixo: 'La lista a continuación',
		aOS: 'La OS',
		aOrdemInciaEm: 'El orden se iniciará en',
		aPartirDe: 'Desde',
		aQuantidadeFoiAlteradaComSucesso: 'La cantidad se ha modificado correctamente.',
		aRecomendacaoFoiSalvaComSucesso: 'La recomendación se guardó correctamente',
		aSolicitacaoEstaAprovada: 'La solicitud <strong>ESTÁ<strong> aprobada.',
		aSolicitacaoFoiDefinida: 'La solicitud se ha definido para el operador',
		aSolicitacaoNaoAval: 'La solicitud <strong>NO TIENE</strong> el aval de las operaciones.',
		aSolicitacaoNaoTemAprovacao: 'La solicitud <strong>NO ESTÁ<strong> aprobada.',
		aSolicitacaoNaoTemAvalManutencao: 'La solicitud <strong>NO TIENE</strong> el aval del mantenimiento.',
		aSolicitacaoTemAvalManutencao: 'La solicitud <strong>TIENE</strong> el aval del mantenimiento.',
		aSolicitaoTemOaval: 'La solicitud <strong>TIENE</strong> el aval de las operaciones.',
		aTarefaFoiAdicionadaComSucesso: 'La tarea se agregó correctamente',
		aTarefaFoiSalvaComSucesso: 'La tarea se ha guardado correctamente',
		abaixoDe: 'Abajo de',
		abaixoEstaoOsTrechosAgrupados: 'A continuación están los tramos agrupados.',
		abaixoMudancas: 'A continuación se detallan los cambios realizados en esta actualización.',
		abastecedor: 'Proveedor',
		abastecimento: 'Suministrar',
		abastecimentoAeronave: 'Suministro de Aeronaves',
		abastecimentoDeAeronaveFoiDeletadoComSucesso: 'El suministro de aeronaves se eliminó correctamente',
		abastecimentoDeAeronaveFoiSalvoComSucesso: '¡El suministro de aviones se salvó con éxito!',
		abastecimentoDeAeronaveViaApiContrato: 'Suministro de aeronaves a través de API/Contrato',
		abastecimentoDeAeronaveViaUnidadeDeArmazenamento: 'Suministro de aeronaves a través de la Unidad de Almacenamiento',
		abastecimentoOleo: 'Suministro de petróleo (L)',
		aberta: 'Abierto',
		aberto: 'Abierto',
		abertoPor: 'Abierto por:',
		abertura: 'Apertura',
		abrir: 'Abrir',
		aberturaOcular: 'apertura de ojos',
		aborto: 'Aborto provocado',
		abrirChat: 'Conversación abierta',
		acao: 'Acción',
		acaoAdotada: 'Acción tomada',
		acaoCorretiva: 'Acción correctiva',
		acaoPreventiva: 'Acción Preventiva',
		acaoSalva: 'Acción Salva',
		acaoTomada: 'Acción Toma',
		aceitavel: 'Aceptable',
		aceitavelbase: 'Aceptable en función de la mitigación de riesgos. Puede solicitar una decisión a la Dirección',
		aceleracao: 'Aceleración',
		acessar: 'Acceso',
		acessarApp: 'Acceder a App',
		acesso: 'Acceso',
		acessoExcluido: 'Acceso eliminado con éxito',
		acidenteAnimalPeconhento: 'Accidente por animal venenoso',
		acimaDe: 'Encima de',
		acimaDos: 'Por encima de los',
		acionamento: 'Actuación',
		acionamentoAoCorte: 'Accionamiento de Corte',
		acionamentoCorte: 'Actuación - Corte',
		acoes: 'Acciones',
		acoesTomadas: 'Acciones',
		acumulado: 'Acumulado',
		acumuladoAno: 'Acumulado Año',
		acumuladoMes: 'Acumulado Mes',
		acumuladoNoPeriodo: 'Acumulado en el Período',
		adendo: 'Apéndice',
		adicaoOleoLubrificante: '¿Se ha añadido aceite lubricante?',
		adicionado: 'Agregado',
		adicionadoSucesso: 'Agregado exitosamente',
		adicional: 'Adicional',
		adicionar: 'Adicionar',
		adicionarAbastecimento: 'Agregar Suministro',
		adicionarAcao: 'Añadir Acción',
		adicionarAditivo: 'Agregar aditivo',
		adicionarAeronave: 'Añadir Aeronave',
		adicionarAplicabilidade: 'Añadir APLICABILIDAD',
		adicionarBase: 'Añadir la base',
		adicionarCarga: 'Agregar carga',
		adicionarCargaOpcao: 'Esta opción le permite mostrar un botón AGREGAR CARGA en cada tarjeta de trabajo en mantenimiento.',
		adicionarConfiguracao: 'Agregar configuración',
		adicionarContato: 'Agregar contacto',
		adicionarDespacho: 'Añadir al despacho',
		adicionarDias: 'Agregar días',
		adicionarDiscrepancia: 'Añadir Discrepancia',
		adicionarDocumentacao: 'Agregar documentación',
		adicionarEmpenhos: 'Agregar compromisos',
		adicionarEscala: 'agregar escala',
		adicionarExcecao: 'añadir excepción',
		adicionarFrequencia: 'Agregar frecuencia',
		adicionarFuncao: 'Agregar función',
		adicionarGrupo: 'Añadir grupo',
		adicionarInspecao: 'Agregar inspección',
		adicionarInspecoes: 'Agregar Inspecciones',
		adicionarItem: 'Añadir artículo',
		adicionarLayer: 'Agregar capa',
		adicionarMalhas: 'Agregar mallas',
		adicionarNovoParecer: 'Agregar nueva opinión',
		adicionarOcorrencia: 'Añadir Ocurrencia',
		adicionarOrgao: 'Añadir Órgano',
		adicionarOrigem: 'Agregue una fuente',
		adicionarPagamento: 'AGREGAR PAGO',
		adicionarParaTripualante: 'Para añadir un miembro de la tripulación, selecciónelo y haga clic en',
		adicionarParecer: 'Agregar opinión',
		adicionarPassageiro: 'Añadir Pasajeros',
		adicionarPeloMenosUmaInspecao: 'Usted tiene que agregar al menos una inspección.',
		adicionarPeloMenosUmaPessoa: 'Tienes que agregar al menos una persona.',
		adicionarPergunta: 'Añadir pregunta',
		adicionarPeriodicidade: 'AÑADIR PERIODICIDAD',
		adicionarPontos: 'Añadir Puntos',
		adicionarProgramacaoVoo: 'Añadir horario de vuelo',
		adicionarResposta: 'Añadir respuesta',
		adicionarRessalva: 'Añadir salvedad',
		adicionarSemana: 'Agregar semana',
		adicionarSolicitacao: 'Agregar solicitud',
		adicionarTarefa: 'Agregar Tarea',
		adicionarTarefas: 'Agregar Tareas',
		adicionarTipoDeSolicitacao: 'Agregar tipo de solicitud',
		adicionarTermo: 'Agregar Término',
		adicionarTrecho: 'Añadir Tramo',
		adicionarTripulacao: 'Añadir Tripulación',
		adicionarTripulante: 'Agregar tripulación',
		adicionarUmTipoDeAeronave: 'Para agregar un tipo de aeronave seleccione el tipo y haga clic en AGREGAR',
		adicionarUnidade: 'Agregar unidad',
		adicionarUsuarios: 'Agregar usuarios',
		adicionarValorAoContrato: 'Agregar valor al contrato',
		adicionarVoo: 'Agregar Vuelo',
		adicionarVooEspecial: 'Agregar vuelo especial',
		adicioneAditivoEditar: 'Agregar un apéndice para editar',
		adicionePeloMenosUmaTarefaParaCadaGrupoDeInspecoes: 'Agregue al menos una tarea para cada grupo de inspección',
		adicioneUmRegistroDeLeitura: 'Agregue al menos un registro a la tabla de lectura obligatoria',
		aditivo: 'Aditivo',
		aditivoSalvoEContratoAtualizadoComSucesso: 'Aditivo guardado y contrato actualizado con éxito',
		aditivos: 'Adiciones',
		administracaoEscolar: 'Administración Escolar',
		administradorContrato: 'Supervisor / Administrador do Contrato',
		administradorSubstitutoDoContrato: 'Supervisor / Administrador suplente del contrato',
		administrativa: 'Administrativo',
		administrativo: 'Administrativo',
		aerodromo: 'Aeródromo',
		adulto: 'Adulto',
		aerodromoLocalAbastecimento: 'Aeródromo/Lugar de Abastecimiento',
		aeromedico: 'Aeronáutica',
		aeronauta: 'Aeronauta',
		aeronavaArmazenamento: 'avión de almacenamiento de combustible',
		aeronave: 'Aeronave',
		aeronaveAplicavel: 'Aeronaves aplicables',
		aeronaveDestino: 'Destino de la aeronave',
		aeronaveDisponivel: 'Aviones disponibles',
		aeronaveDuplicada: 'Este avión está duplicado.',
		aeronaveIndisponivel: 'Aeronave no disponible',
		aeronaveNaoRetornouAoServico: 'La aeronave no retornó al servicio ya que existe un(s) orden(s) abierto',
		aeronaveNumeroVoo: 'Elija una aeronave para seleccionar números de vuelo.',
		aeronaveNãoEncontrada: 'Aeronave no encontrado',
		aeronaveParada: 'Aeronave detenida',
		aeronaveSelecionada: 'Aeronave seleccionada',
		aeronaveSelecionadas: 'Aeronaves seleccionadas',
		aeronaveTurnoServico: 'Aeronave del turno de servicio',
		aeronavesAsasFixas: 'Aeronaves Asas Fijas',
		aeronavesAsasRotativas: 'Aeronaves Asas Rotativas',
		aeronavesEDisponibilidade: 'Aircraft and Availability',
		aeronavesEmpregadas: 'Aeronaves Empleadas',
		aeronavesOperadasPelo: 'Aeronaves Operadas por el',
		aeroporto: 'Aeropuerto',
		aeroportoFavorito: 'Aeropuerto favorito',
		afastamentoVor: 'Distancia VOR(NM)',
		agrupado: 'Agrupados',
		agruparJornadaAnterior: '¿Grupo con viaje previo?',
		agruparTrecho: 'Agrupar Tramo',
		agruparTrechos: 'Agrupar Tramos',
		aguardandoLeitura: 'Esperando lectura',
		aindaNaoAvaliado: 'Aún no calificado',
		aindaNaoLido: 'Aún no leído',
		ajustes: 'AJUSTES',
		alergia: 'Alergia',
		alerta: 'Alerta',
		alertaCalculoAutomatico1: 'El cálculo automático del tiempo de vuelo no está disponible',
		alertaCalculoAutomatico2: 'Para este avión no se sumaron la velocidad media el consumo ni el tanque.',
		alertaConfigurado: 'Alerta configurada',
		alertas: 'Alertas',
		alinhaTabela: 'Alinear Tabla',
		almoco: 'Almuerzo',
		alocacao: 'Asignación',
		alocacaoExcluidaComSucesso: 'Asignación eliminada exitosamente',
		alocado: 'Asignado',
		alocarVoo: 'Asignar vuelo',
		alta: 'Elevado',
		alteracao: 'Modificación',
		alteracaoLote: 'Cambiar en lote',
		alteracaoParametro: 'cambio de parametro',
		alteracoesEdicao: '¡Los cambios se guardaron y la firma se realizó con éxito!',
		alteradoPor: 'Modificado por',
		alterados: 'Cambió',
		alterandoAQuantidade: 'Cambiando la cantidad',
		alterandoSenha: 'Cambiar la contraseña',
		alterar: 'Cambio',
		alterarAQuantidade: 'Cambiar la cantidad',
		alterarAssinatura: 'Cambiar suscripción',
		alterarAssinaturaNoProximoLogin: 'Cambiar la firma en el siguiente inicio de sesión?',
		alterarDataInicio: 'Cambiar fecha de inicio',
		alterarDatas: 'Cambiar fechas',
		alterarDespacho: 'Modificar el despacho',
		alterarProgramacaoVoo: 'Cambiar horario de vuelo',
		alterarQuantidade: 'Cantidad modificada',
		alterarSenha: 'Cambiar la contraseña',
		alterarSenhaProximoLogin: 'Cambiar la contraseña en el siguiente inicio de sesión?',
		alterarSolicitacao: 'Change request',
		alterarStatus: 'Alterar Estado',
		alternativos: 'Alternativas',
		altitude: 'Altitud',
		altitudeRecuperadaAtraves: 'Altitud recuperada a través de Google Maps',
		altitudeTerreno: 'Altitud Absoluta',
		altitudeVelocidade: 'Altitud y velocidad',
		altura: 'Alto',
		alturaVoo: 'Altura del vuelo',
		aluno: 'Alumno',
		alunos: 'Alumnos',
		ambiente: 'Entorno',
		ambos: 'Ambos',
		anac: 'Anac',
		and: 'y',
		anexeContrato: 'Adjunte el contrato mediante el botón Haga clic para adjuntar',
		anexeUmaImagem: 'Adjuntar una imagen',
		anexo: 'Anexo',
		anexoSolicitacao: 'Solicitud Anexo',
		anexos: 'Archivos adjuntos',
		anisocoricas: 'Anisocórico',
		ano: 'Año',
		anoFabricacao: 'Ano de Produção',
		anoModelo: 'Año Modelo',
		anos: 'Años',
		anual: 'Anual',
		aoCorte: 'para cortar',
		apareceraDespachoAeronaves: 'Aparecerá en el Despacho de Aeronaves hasta la opción Terminar este despacho? se marca como SIM.',
		aparencia: 'Apariencia',
		aplicabilidade: 'Aplicabilidad',
		aplicabilidades: 'Aplicabilidad',
		aplicar: 'Aplicar',
		aplicativoTelaLogin: 'Aplicación de pantalla de inicio de sesión',
		aplicavel: 'Aplicable',
		apoiados: 'Apoyado',
		apos15diasRestantes: 'Quedan 15 días',
		aposSelecionarInspecao: 'Después de seleccionar todas las inspecciones que desee haga clic en Agregar inspecciones.',
		apreciacao: 'Apreciación',
		apreciacaoAnalise: 'Análisis ESO',
		apreciacaoSalva: 'Agradecimiento guardado con éxito',
		apresentacao: 'Presentación',
		aprovacao: 'Aprobación',
		aprovacaoFinal: 'Aprobacíon final',
		aprovado: 'Aprobado',
		aprovados: 'Aprobado',
		aprovar: 'aprobar',
		aprovarEssaSolicitacao: 'Aprobar esta solicitud (Generar orden de misión)?',
		areaCriacao: 'Área de Creación',
		areaMapeamento: 'Área de Mapeo',
		areaMonitoramento: 'Área de Monitoreo',
		armasApreendidas: 'Armas aprehendidas',
		armazenamento: 'Almacenamiento',
		armazenamentoDisponivel: 'Almacenamiento de disponible',
		arquivado: 'Archivado',
		arquivados: 'Archivado',
		arquivo: 'Archivo',
		arquivosAusentesCorrompidos: 'Archivos Ausentes / Corrompidos',
		arrasteParaAumentarInferior: 'Arrastre para aumentar de tamaño en la esquina inferior derecha de la pantalla',
		arrasteParaMover: 'Arrastra para mover elementos de la tabla',
		as: 'para',
		asTarefasForamAdicionadasComSucesso: 'Las tareas se han agregado correctamente',
		asTarefasForamSalvasComSucesso: 'Las tareas se han guardado correctamente',
		asUltimas: 'el último',
		asasFixas: 'Alas fijas',
		asasRotativas: 'Alas rotativas',
		aspectos: 'Aspectos involucrados',
		assento: 'Asiento',
		assinadoDigitalmentePor: 'Firmado digitalmente por',
		assinadoPor: 'Firmado por',
		assinadosPorMim: 'Firmado por mí',
		assinando: 'Firma',
		assinar: 'Signo',
		assinarEFinalizar: 'Suscribirse y Finalizar',
		assinarESalvarTrecho: 'Suscribir y guardar tramo',
		assinarEletronicamente: 'Firmar electrónicamente',
		assinarInspetor: 'Suscribir Inspector',
		assinarManualmente: 'Firmar manualmente',
		assinarMecanico: 'Suscripción mecánica',
		assinarNovamenteTrechos: 'Volver a firmar las secciones ya firmadas',
		assinarTodosOsTrechos: 'Suscribir todos los extractos',
		assinarTodosOsTrechosNaoAssinados: 'Firmar todos los pasajes sin firmar',
		assinarTodosOsTrechosSelecionados: 'Firmar pasajes seleccionados',
		assinarTrecho: 'Suscribirse Extracto',
		assinarTrechoDowload: 'Descarregar secções selecionadas',
		assinatura: 'FIRMA',
		assinaturaAvalicao: 'La firma debe tener 8 dígitos numéricos.',
		assinaturaDigialInspetor: 'Firmado digitalmente por el inspector',
		assinaturaDigital: 'Firma digital',
		assinaturaDigitalMecanico: 'Firmado digitalmente por el mecánico',
		assinaturaDigitalOperador: 'Firmado digitalmente por el operador',
		assinaturaDigitalPilotoComando: 'Firmado digitalmente por el piloto en comando',
		assinaturaEletronica: 'Firma Electrónica',
		assinaturaInvalida: 'Firma no válida.',
		assinaturaMotivo: '¡El motivo se envió correctamente!',
		assinaturaOrdem: 'Firma de la orden de misión',
		assinaturaTemQueTer8: 'La Firma debe tener 8 dígitos numéricos',
		ate: 'para',
		ate15diasRestantes: 'Quedan hasta 15 días',
		atencaoAdd: '¡Atención agregada exitosamente!',
		atencaoEspecial: 'Atención especial',
		atendimento: 'servicio',
		atendimentoAeromedico: 'Servicio aeromédico',
		ativa: 'Activo',
		ativaEDesativaPrivilegios: 'Aquí HABILITAS o DESHABILITAS los privilegios que se mostrarán al cliente.',
		ativar: 'Activar',
		ativarInspecao: 'Activar Inspección',
		ativarInspecoes: 'Para activar esta inspección se requiere una justificación',
		ativarTodas: 'Activar todo',
		ativarTodasInspecoes: 'Para activar todas las inspecciones se requiere una justificación',
		ativarUsuario: 'Activar el Usuario',
		atividade: 'Actividad',
		atividadeConcomitante: 'actividad concomitante',
		atividadeDesagrupadaErro: 'error al desagrupar actividad',
		atividadeDesagrupadaSucesso: 'actividad desagrupada exitosamente',
		atividadeInserida: 'Actividad insertada exitosamente',
		atividadeInseridaErro: 'Error al insertar actividad',
		atividades: 'Actividades',
		atividadesAereas: 'Actividades Aereas',
		atividadesAereasGeral: 'Actividades Aéreas General',
		ativo: 'Activo',
		atravesDaBusca: 'a través de la búsqueda',
		atual: 'Actual',
		atualizaDadosFdm: 'Actualizar datos FDM',
		atualizacao: 'Actualización',
		atualizacaoDeManutencao: 'Actualización de Mantenimiento',
		atualizacaoTempoManual: 'Actualización manual de la hora',
		atualizacoes: 'Actualizaciones',
		atualizado: 'Actualizado',
		atualizadoErro: 'error al actualizar',
		atualizadoPor: 'Actualizado por',
		atualizadoSucesso: 'éxito actualizado',
		atualizando: 'Actualización',
		atualizandoLista: 'Actualizando lista',
		atualizandoModelosAeronaves: 'Actualización de los modelos de las aeronaves',
		atualizandoTempo: 'Actualizando el tiempo',
		atualizar: 'Actualizar',
		atualizarCartao: 'Tarjeta de actualización',
		atualizarCartoes: 'Actualizar tarjetas',
		atualizarFabricanteModelo: 'Actualizar fabricantes/modelos',
		atualizarFabricanteOuModelo: '¿Actualizar fabricante o modelo?',
		atualizarGrupo: 'Grupo de actualización',
		atualizarItem: 'Actualizar elemento',
		atualizarMapa: 'Actualizar Mapa',
		atualizarOrdemDeMissao: 'Actualizar Orden de Misión',
		atualizarOrdemServico: 'Actualizar orden de servicio',
		atualizarRoteiro: 'Actualizar Guión',
		atualizarSolicitacao: 'Actualizar solicitud',
		atualizarTrecho: 'Actualizar Tramo',
		auditoria: 'Auditoría',
		auditoriaDiarioDeBordo: 'Auditoría Diario de Bordo',
		aunqueNoFueCerrado: 'AUNQUE NO FUE CERRADO',
		ausentes: 'Ausente',
		autoLocalizacao: 'Auto Localización',
		autonomia: 'Autonomía',
		autorizacao: 'Autorización',
		aval: 'Endoso',
		avaliacao: 'Evaluación',
		avaliacaoGeral: 'EVALUACION GENERAL',
		avaliacaoPrimaria: 'Evaluación primaria',
		avaliacaoQualitativa: ' Evaluación cualitativa',
		avaliacaoQualitativaAposAAplicacao: ' Evaluación cualitativa después de la aplicación de las recomendaciones',
		avaliacaoQualitativaExecucao: 'Evaluación cualitativa después de la mitigación',
		avaliar: 'Evaluar',
		avaliarDiscrepancia: 'Evaluar la discrepancia',
		avancado: 'Avanzado',
		avancar: 'Siguiente',
		avarias: 'Averías',
		avioesEDisponibilidade: 'Aviones y disponibilidad',
		avisoDeInicializacao: 'Advertencia de inicio',
		baco: 'Bazo',
		bagagemMao: 'Equipaje de Mano',
		bagagemPorao: 'Mantenga el Equipaje',
		bairro: 'Barrio',
		baixa: 'Bajo',
		baixar: 'Descargar',
		bambiBucket: 'Bambi Bucket',
		bancoDeDados: 'Banco de datos',
		base: 'Base',
		baseContratual: 'Base Contratual',
		baseContratualETransferencia: 'Bases contractuales y transferencias',
		baseDeOrigem: 'Base de Origen',
		baseOperacao: 'Base de Operaciones',
		baseOperacional: 'Base Operativa',
		basico: 'Básico',
		bastaClicar: 'Simplemente haga clic en el mapa para agregar un nuevo punto de interés o haga clic en uno en el mapa para editarlo.',
		bateria: 'Batería',
		bateriaBaixa: 'BATERÍA BAJA',
		biblioteca: 'Biblioteca',
		bilhete: 'Boleto',
		bilhetesDeEmbarque: 'Billetes de embarque',
		boletins: 'Boletines',
		bolsaRota: 'bolsa rota',
		botaoAlertaAeronave: 'Botón de alerta de aeronave',
		botaoAssinarProva: 'El botón de firmar sólo estará disponible después de leer el documento adjunto.',
		botoesEGatilhos: 'Botones y disparadores',
		brigadistas: 'bomberos',
		buscar: 'Digite para buscar en la lista a continuación',
		buscarFatura: 'Buscar',
		buscarPorTripulante: 'Buscar por miembro de la tripulación',
		cCarregar: 'CARREGAR',
		cadComissaria: 'Registro de Comisaria',
		cadTipoHabilitacao: 'Registro de tipo de licencia',
		cadTripulacao: 'Registro de Tripulación',
		cadastrar: 'Registrar',
		cadastrarImagens: 'Registrar imágenes',
		cadastrarNovoDespacho: 'Registrar nuevo pedido',
		cadastrarParametroLeiAeronauta: 'Registrar parámetro de derecho aeronáutico',
		cadastrarProcedimento: 'Procedimiento de registro',
		cadastro: 'Registro',
		cadastroAplicabilidade: 'REGISTRO DE APLICABILIDAD',
		cadastroAtividade: 'Registro de Actividad',
		cadastroCliente: 'Registro de cliente',
		cadastroCombustiveis: 'Registro de combustible',
		cadastroConfigAeronave: 'Registro de configuración de aeronaves',
		cadastroDeBase: 'Registro de Base',
		cadastroDeDepartamento: 'Registro de Departamento',
		cadastroDeDocumentacao: 'Registro de Documentación',
		cadastroDeFuncoes: 'Registro de Funciones',
		cadastroDeOvn: 'Registro de GVN(Gafas de Visión Nocturna)',
		cadastroDeSecao: 'Registro de sección',
		cadastroDeSessao: 'Registro de sesión',
		cadastroDeSetor: 'Registro sectorial',
		cadastroDeVeiculos: 'Registro de Vehículo',
		cadastroFornecedor: 'Registro de Proveedor',
		cadastroGrupoDePassageiros: 'Registro Grupo de Pasajeros',
		cadastroGrupoDeTripulantesTecnicos: 'Registro de grupo de tripulación técnica',
		cadastroHelice: 'Registro de hélice',
		cadastroLayer: 'Registro de capa',
		cadastroLicenca: 'Registro de licencia',
		cadastroMateriais: 'Registro de Materiales',
		cadastroMotor: 'Registro de motor',
		cadastroNivelQuestionarioFadiga: 'Registro a nivel del cuestionario de fatiga.',
		cadastroPassageiros: 'Registro de pasajeros',
		cadastroPontosInteresse: 'Registro de Puntos de Interés',
		cadastroReporteFadiga: 'Registro del cuestionario de fatiga',
		cadastroRotaer: 'Registro de Rotaer',
		cadastroTipoArmazenamento: 'Registro Tipo Almacenamiento',
		cadastroTipoCarga: 'Registro de tipo de carga',
		cadastroTipoEmbalagem: 'Registro del Tipo de Paquete ',
		cadastroTipoMotivoNaoEmbarque: 'Registro de tipos de motivos de no embarque',
		cadastroTipoVeiculo: 'Registro de tipo de vehículo',
		cadastroTripulanteTecnico: 'Registro de tripulación técnica',
		cadastroUnidadeArmazenamento: 'Registro de unidad de almacenamiento',
		cadastroUnidadeConservacao: 'Registro de Unidad de Conservación',
		cadastroUnidadeOrcamentaria: 'Registro Unidad de Presupuesto',
		cadastroUsuarioSimplificado: 'Registro de Usuario Simplificado',
		cafeManha: 'Desayuno',
		calculoSistema: 'Cálculo en el sistema',
		calculosCiclosPreenchimentoDiarioDeBordo: 'Cálculo de ciclos con cada llenado del cuaderno de bitácora',
		calculosDoImpostos: 'Cálculo de impuestos',
		calendarica: 'Calendárico',
		calendaricas: 'Calendáricas',
		calendario: 'Calendario',
		calendarioAnual: 'Calendario Anual',
		calendarioDeManutencao: 'Calendario de mantenimiento',
		calendarioEscala: 'Calendario de escala',
		calendarioManutencao: 'Calendario de mantenimiento',
		calendarioSemanal: 'Calendario Semanal',
		calor: 'Heat',
		caminhao: 'Camión',
		camp: 'Camp',
		campo1: 'Campo 1',
		campo2: 'Campo 2',
		campo3: 'Campo 3',
		campo4: 'Campo 4',
		campo5: 'Campo 5',
		campoCalculaQuantosTorqueCycle: 'Usado para calcular cuántos ciclos de torque por cada aterrizaje',
		campoCalculoAutomaticoClicloMotor: 'Al rellenar el libro de registro, el sistema calcula automáticamente los ciclos del motor',
		campoCalculoQuantosHoistCycle: 'Usado para calcular cuántos ciclos de elevador por cada uso del cabrestante',
		campoCalculoQuantosSilingCycle: 'Usado para calcular cuántos ciclos de deslizamiento por cada uso del gancho.',
		campoContratoLiberado: 'El campo Contrato se liberará si la herramienta se alquila o se presta',
		campoObrigatorio: 'Este campo es obligatorio.',
		campoObrigatorioAbastecimento: 'Los campos PROVEEDOR o UNIDAD DE ALMACENAMIENTO deben ser completados obligatoriamente, siendo necesario que al menos uno de ellos esté completo',
		campoRelacaoAbastecimentoInfoPreenchidaAuto: 'Al definir la lista de suministros, esta información ya se completará automáticamente en el Libro de Registro del Piloto, en la sección Datos de combustible',
		campoRelacaoCombustivelInfoPreenchidaAuto: 'Al definir la relación de combustible, esta información ya se completará automáticamente en el Libro de Registro del Piloto, en la sección de Datos de Vuelo',
		camposCiclosMotorDiarioDeBordo: 'En el libro de registro, solicita la finalización de los campos del ciclo del motor',
		camposCoefficienteCiclos: 'Campos para ingresar el coeficiente de ciclos',
		camposObrigatorios: 'Debe introducir los campos obligatorios.',
		camposOleoLubrificante: 'Campos de aceite lubrificante',
		camposWsdl: 'Campos WSDL',
		cancelaOrdemServico: 'Cancelar orden de servicio',
		cancelada: 'Cancelada',
		canceladaComSucesso: 'Cancelada con éxito',
		cancelado: 'Cancelado',
		canceladoTratado: 'Cancelado manejado',
		cancelados: 'Cancelado',
		cancelando: 'Cancelando',
		cancelar: 'Cancelar',
		cancelarDespacho: 'Cancelar el envío',
		cancelarDiario: ' Cancelar Editar',
		cancelarEnvioAjuda: 'CANCELAR EL ENVÍO DE AYUDA',
		cancelarOrdem: 'Cancelar orden',
		cancelarOrdemServico: '¿Desea CANCELAR esta orden de servicio?',
		cancelarSelecao: 'Cancelar selección',
		capacidade: 'Capacidad',
		capacidadeMaxima: 'Maxima Capacidad',
		capacidadeMaximaMovimentacaoCombustivel: 'Maxima Capacidad (l)',
		capacidadeOuPotenciaOuCilindrada: 'Capacidad / Potencia / Capacidad del Cilindro',
		capacidadeTrechoPoraoUltrapassado: 'Se ha superado la capacidad de algunos tramos/poros',
		capitulo: 'Capítulo',
		capota: 'Capó',
		caracteresRestantes: 'caracteres restantes.',
		cardiologico: 'Cardiológico',
		carga: 'Cargar',
		cargaBagagemSerTransportada: '¿Hay carga/equipaje por transportar?',
		cargaBagagemTransportada: 'Carga/equipaje transportado',
		cargaExcluidaComSucesso: 'Carga eliminada correctamente',
		cargaHoraria: 'Carga horaria',
		cargaHorariaSemanal: 'Carga de trabajo semanal',
		cargaInicial: 'Carga inicial',
		cargaLiquida: '¿Carga Líquida?',
		cargaPadrao: 'Cargo estándar',
		cargaPerigosa: 'Carga peligrosa',
		cargaSalvaComSucesso: 'Carga guardada con éxito',
		cargaTransportada: 'Carga Transportada',
		cargo: 'Cargo',
		cargoExcluidoComSucesso: 'Posición eliminada exitosamente',
		cargoFuncao: 'Cargo/Función',
		carregaAutomaticoPerfilAoCriarUsuario: 'Cargar automáticamente este perfil al crear un nuevo usuario?',
		carregando: 'Cargando',
		carregandoComponentes: 'Cargando los componentes',
		carregandoDados: 'Cargando datos',
		carregandoDadosCAMP: 'Cargando datos de la API de CAMP',
		carregandoDiario: 'Carga diaria de a bordo',
		carregandoDiarios: 'Cargando diarios',
		carregandoEntregas: 'Cargando entregas',
		carregandoHorimetro: 'Cargando horimetro',
		carregandoListas: 'Cargando Listas',
		carregandoMaisOpcoes: 'Cargando más opciones',
		carregandoManutencoes: 'Cargando mantenimiento',
		carregandoModelo: 'Cargando modelo',
		carregandoMovimentacoes: 'Cargar unidades',
		carregandoNFS: 'Subir factura electrónica',
		carregandoOrdemServico: 'Cargando Orden de servicio',
		carregandoPosicaoDoVoo: 'Posición de vuelo de carga',
		carregar: 'Cargar',
		carregarFoto: 'Cargar Foto',
		carregarModelo: 'Cargar Plantilla',
		carregarNota: 'Subir Factura Electrónica',
		carregarPosicaoDoVoo: 'Posición de vuelo de carga',
		carregarVoos: 'Cargar Vuelos',
		carrgandoFoto: 'Cargando foto',
		cartaDeSituacao: 'Carta de Situación',
		cartaDeSituacaoCalendario: 'Cuadro de estado',
		cartaDeSituacaoOperacoes: 'Carta de Situación Operaciones',
		cartaoSus: 'Número de tarjeta SUS',
		cartoesParaAtualizar: 'TARJETAS PARA ACTUALIZAR',
		casaDecimal: 'Requiere lugar decimal',
		casado: 'Casado(a)',
		caso: 'Caso',
		casoMedicoAtualizado: 'Caso médico actualizado con éxito',
		casoMedicoDesativado: 'Caso médico discapacitado',
		casoMedicoSalvo: 'Caso médico salvado con éxito',
		casoNaoUtilizeDiario: 'Si no utiliza el libro de registro para actualizar los manuales, puede habilitar esta opción y se mostrará una pestaña ACTUALIZACIONES en la pantalla DESCRIPCIÓN GENERAL que le permitirá actualizar manualmente el mantenimiento.',
		casoNenhumaAeronave: 'Si no se selecciona ningún avión',
		casoObstetrico: 'Casos Obstétricos',
		casoTraumatico: 'Casos traumáticos',
		casosClinico: 'Casos Clínicos',
		casosMedicoExcluido: 'Caso médico excluido',
		casosMedicos: 'Casos Médicos',
		catastrofico: 'Catastrófico',
		categoria: 'Categoría',
		categoriaRegistro: 'Categoría de registro',
		cautelaMateriais: 'Precaución con los materiales',
		celula: 'Celúla',
		centralizar: 'Centralizar',
		centroCusto: 'Centro de coste',
		centroCustoAtualizado: 'Centro de costos actualizado',
		centroDeCustos: 'Centros de Costo',
		cep: 'Código Postal',
		ceso: 'Gestión de Riesgo',
		cfg: 'Ajustes',
		chamada: 'Llamada',
		chamadaDeSuporte: 'Llamada de soporte',
		chamadoConcluido: 'Llamada completada',
		chamadoSuporte: 'Llamados de Soporte',
		chassi: 'Chasis',
		chaveApi: 'Api Key',
		chaveDaNFE: 'Clave NFe',
		chaveNFE: 'Clave NFe',
		chaveServices: 'Key in Services',
		checkIn: 'Check-in',
		chegada: 'Llegada',
		chegadaLocal: 'Llegada local',
		cicloDeTorque: 'Ciclo de torsión',
		cicloN1: 'Ciclo N1',
		cicloN2: 'Ciclo N2',
		cicloTorque: 'Ciclo de Par',
		cicloTotaisManutencao: 'Ciclos totales de mantenimiento',
		ciclos: 'Ciclos',
		ciclosN1: 'N1 ciclos',
		ciclosN2: 'Ciclos de N2',
		ciclosNF: 'Ciclos de N2',
		ciclosNG: 'N1 ciclos',
		ciclosNP: 'Ciclos NP',
		ciclosTorque: 'Ciclos de torsión',
		ciclosTotais: 'Ciclos Totales',
		ciclosTotaisMotor: 'Total de motocicletas',
		cidade: 'Ciudad',
		cidadeDeVerificacao: 'Ciudad de Verificación',
		classe: 'Clase',
		classeDoProduto: 'Clase de Producto',
		circulacao: 'Circulación',
		circularCordao: 'Cordón Circular',
		classificacao: 'Clasificación',
		classificacaoAtualizada: 'Clasificación actualizado',
		classificacaoDesativada: 'Calificación deshabilitada',
		classificacaoESub: 'Clasificación e Subclasificación',
		classificacaoExcluida: 'Clasificación excluida',
		classificacaoSalva: 'Clasificación salvo',
		clickAquiParaAnexar: 'Haga clic aquí para adjuntar',
		clickExibirApp: 'Haga clic aquí para acceder al Followair de su teléfono.',
		clickParaVerOsTrechosAgrupados: 'Haga clic para ver los vuelos agrupados',
		clickParaVerOsTrechosPor: 'Haga clic para ver los vuelos agrupados por',
		clienteAtualizado: 'Cliente Actualizado',
		clienteSolicitante: 'Cliente solicitante',
		clientesSolicitantes: 'Clientes solicitantes',
		clinico: 'Clínico',
		cliqueAqui: 'haga clic aquí',
		cliqueEmAlgumaImagem: 'Haga clic en cualquier imagen',
		cliqueEmCarregar: 'Haga clic en cargar después de escribir',
		cliqueEmNovoParaAdicionar: 'Haga clic en nuevo para agregar',
		cliqueNoHistoricoParaCarregar: 'haga clic en el historial para cargarlo.',
		cliqueParaAnexar: 'HAGA CLIC PARA ADJUNTAR',
		cliqueParaConcluir: 'Click para terminar',
		cliqueParaRemover: 'Haga clic para eliminar',
		cliqueParaVerAAssinatura: 'Haga clic para ver la firma',
		cliqueTrechoCarregar: 'Haga clic en el tramo para cargarlo.',
		cnpj: 'CNPJ',
		codigo: 'Código',
		codigoClassificacao: 'Código de clasificación',
		codigoDaSolicitacao: 'código de solicitud',
		codigoDoProduto: 'Código de producto',
		codigoGeradoAoSalvar: 'Código generado al guardar',
		codigoGerenciamentoDeRisco: 'Código de gestión de riesgos',
		codigoInterno: 'Codigo Interno',
		codigoOrdemDeServico: 'Código de orden de servicio',
		codigoOsm: 'Código para identificar enfermedades, condiciones de salud, lesiones y trastornos establecido por la OMS',
		codigoRenavan: 'Código Renavan',
		codigoSituacao: 'Código - situación',
		codigoSolicitacao: 'código de solicitud',
		codinome: 'Con nombre en código',
		coluna: 'Columna',
		com: 'Con',
		comDados: 'Con datos',
		comUmLink: 'con un enlace para recuperar su contraseña!',
		comandante: 'Comandante',
		comandanteLocalMissao: 'Comandante de la misión en el lugar',
		combustivel: 'Combustible',
		combustivelConsumido: 'Combustible Consumido',
		combustivelConsumidoTotal: 'Combustible Consumido  Total',
		combustivelInicial: 'Combustible Inicial',
		combustivelTotal: 'Combustible Total',
		comissario: 'Notario',
		comissarios: 'Notario',
		comoDesejaFiltar: 'Elija la forma que desea filtrar',
		complemento: 'Complemento',
		completo: 'Completo',
		componente: 'Componente',
		componenteCargaSolicitacao: 'Solicitud de carga de componentes',
		componentePassageiroSolicitacao: 'Solicitud de pasajero de componente',
		componenteTrechoFuso: 'Husillo utilizado en el componente de sección.',
		componenteTrechoSolicitacao: 'Solicitar componente de estiramiento',
		componentes: 'Componentes',
		comprimento: 'Largo',
		comprovanteAbastecimento: 'Prueba de suministro',
		comprovanteMaterialRequisitado: 'Prueba de material requerido',
		computadorDeBordo: 'Computadora de Bordo',
		comunicacaoESO: 'Gestión de riesgos',
		comunicacoes: 'Comunicaciones',
		comunidade: 'Comunidad',
		comunidadeAtualizada: 'Comunidad actualizada',
		comunidadeAtualizado: 'Comunidad actualizada con éxito',
		comunidadeDesativada: 'Comunidad discapacitada',
		comunidadeExcluida: 'Comunidad discapacitada',
		comunidadeSalva: 'Comunidad guardada exitosamente',
		concluiEssaInspecao: 'Concluí esa Inspección',
		concluida: 'Completada',
		concluido: 'Terminado',
		concluidoNoTotalDe: 'completado en total de',
		concluidoPor: 'Completado por',
		concluidos: 'Terminado',
		concluir: 'Concluir',
		concluirDiscrepancia: 'Completar Discrepancia',
		concluirOrdemDeServico: 'ORDEN DE SERVICIO COMPLETA',
		conclusao: 'Conclusión',
		conclusaoFusoHorario: 'Conclusión (UTC-03:00)',
		concordoComOsTermosDeUso: 'ACEPTO LAS CONDICIONES DE USO',
		conferencia: 'CONFERENCIA',
		configBackend: 'Configuracion del Backend',
		configuracao: 'Ajustes',
		configuracaoAeronave: 'Configuración de aeronaves',
		configuracaoNotificacao: 'Configuración de notificación',
		configuracoes: 'Ajustes',
		configuracoesEscala: 'Configuración de escala',
		configuracoesSalvas: 'Configuraciones guardadas',
		confirmaExclusaoLeitores: 'Esta acción excluirá los lectores obligatorios ya insertados ¿desea continuar?',
		confirmaLeitura: 'Confirma la lectura',
		confirmaLeituraDocumento: 'Usted confirma la lectura del documento?',
		confirmaNovaVersaoDocumento: 'Este cambio generará una nueva versión del documento ¿confirmar la edición?',
		confirmando: 'Confirmando',
		confirmar: 'Confirmar',
		confirmarAlerta: 'Confirmar Alerta',
		confirmarAssinatura: 'Confirmar nueva suscripción',
		confirmarDuplicar: 'Confirma que desea duplicar',
		confirmarLeitura: 'Confirmar lectura',
		confirmarNewPassword: 'Confirmar nueva contraseña',
		confirmeDadosAeronave: 'Confirmar que los datos de la aeronave y del motor sean correctos.',
		confrimarEnvioAjuda: 'CONFIRMAR EL ENVÍO DE AYUDA',
		conjuge: 'Cónyuge',
		conselhoRegional: 'Consejo Regional',
		consultarNota: 'Consultar NFe',
		consumados: 'Consumado',
		consumido: 'Consumido',
		consumidoOValorTotalDoContrato: 'La cantidad total del contrato se consumió',
		consumidoOValorTotalDoEmpenho: 'La cantidad total de esfuerzo se consumió',
		consumivel: 'Consumible?',
		consumo: 'Consumo',
		consumoDeCiclos: 'CONSUMO DEL CICLO',
		consumoTotal: 'Consumo total',
		contador: 'Encimera',
		contato: 'Contacto',
		contatoDeEmergencia: 'Contacto de Emergencia',
		contatoEmCasoDeEmergencia: 'Contacto de emergencia',
		contatosMissao: 'Contactos de la Misión',
		contexto: 'Contexto',
		contextoAtualizado: 'Contexto operativo actualizado',
		contextoExcluido: 'Contexto Operativo excluido.',
		contextoOperativo: 'Contexto Operativo',
		contextoSalvo: 'Contexto Operativo salvo',
		continuar: 'Continuar',
		contracoesMin: 'Contracciones/min',
		contrato: 'Contrato',
		contratoAtualizadoComSucesso: 'Contrato actualizado con éxito',
		contratoEmpenhoMovimentacao: 'Este contrato ya tiene un compromiso o está relacionado con un movimiento de combustible!',
		contratoExcluidoComSucesso: 'Contrato eliminado con éxito',
		contratoSalvoComSucesso: 'Contrato guardado correctamente',
		contratos: 'Contratos',
		contratosAbastecimento: 'Contratos de suministro',
		contratosGenericos: 'Contratos Genéricos',
		contratosSBH: 'Contratos SBH',
		controlado: 'Revisado',
		controle: 'Control',
		controleDeAbastecimento: 'Control de suministro',
		controleDeInpencoesEManuais: 'Inspección y control manual',
		controleDeInspecao: 'Control de inspección',
		controleDePassageiros: 'Control de pasajeros',
		controleDePassageirosECargas: 'Control de pasajeros y carga',
		controleFerramental: 'Control de Utillajes',
		controleHorasEMotor: 'COMPROBACIÓN DE HORAS Y CICLOS DEL MOTOR',
		controleHorasOvn: 'Control de tiempo de gafas de visión nocturna',
		controleHorasVoadas: 'Control de vuelo',
		controleInpencoesComponentes: 'Control de Inspecciones y Componentes',
		copiandoDiario: 'Copiando diario de a bordo',
		copiar: 'Copia',
		copiarDespacho: 'Copiar el último envío',
		copiarOrdem: 'Copiar el última ordem',
		copiarPessoas: 'Copiar personas',
		copiarSolicitacao: 'Copiar el última petición',
		copiloto: 'Copiloto',
		cor: 'Color',
		corIdentificacao: 'Color de identificación',
		corPolilyne: 'Color Polilyne',
		corPredominante: 'Color Predominante',
		coracao: 'Corazón',
		cornea: 'Córnea',
		correcao: 'Corrección',
		corrijaCamposVermelho: 'Corregir los campos en rojo',
		corrijaOsCamposEmVermelho: 'Corrija los campos en rojo',
		corrompidos: 'Corrompido',
		corte: 'Cortada',
		corteVoo: 'Corte',
		cotacao: 'Precio',
		cpfInvalido: 'Identidad inválida',
		cpfInvalidoOuJaCadastradoNoSistema: 'Identidad no válido o ya registrado en el sistema',
		cpfJaCadastrado: 'CPF ya registrado.',
		cpfUsadoComoLoginEsenha: 'El número de CPF se utilizará como LOGIN y CONTRASEÑA que deberá cambiarse en el primer acceso.',
		crea: 'CREA',
		crianca: 'Niño (Entre 2 y 12 años)',
		criancaFicha: 'Niño',
		criar: 'Agregar',
		criarModeloPadrao: 'Crear plantilla predeterminada',
		critica: 'Crítica',
		cumpridoConformeDocumentacaoReferencia: 'Cumplido conforme a la documentación de referencia.',
		custo: 'Costo',
		custoDoCiclo: 'Costo del ciclo',
		custoHora: 'Costo por hora',
		daAeronave: 'del avión',
		daProgramacao: 'de programación',
		dac: 'DAC',
		dados: 'Datos',
		dadosAbastecimento: 'Datos de Suministro',
		dadosCadernetaIndividualVoos: 'Datos del registro de vuelo individual (CIV)',
		dadosDaMissao: 'Datos de la misión',
		dadosDaMissaoPreenchidos: 'Todos los datos de la orden de misión se han cumplido está a la espera de entrar en ejecución.',
		dadosDaPrevencao: 'Datos de la Prevención',
		dadosDeDestino: 'Datos objetivo',
		dadosDeEmissao: 'Datos de emisión',
		dadosDeEntrega: 'Datos de entrega',
		dadosDeMonitoramento: 'Dados de Monitoramento do Motor e Abastecimento de Óleo',
		dadosDoCliente: 'Datos del Cliente',
		dadosDoContrato: 'Datos del contrato',
		dadosDoDespacho: 'Datos del Despacho',
		dadosDoVoo: 'Datos del vuelo',
		dadosDuplicado: 'datos duplicados',
		dadosEstratificado: 'Datos estratificados',
		dadosFornecedor: 'Datos del Proveedor',
		dadosFuncionais: 'Datos funcionales',
		dadosGerais: 'Datos Generales',
		dadosIniciais: 'Datos iniciales',
		dadosKit: 'Datos del Kit',
		dadosMotor: 'Datos del motor',
		dadosOcorrencia: 'Datos de ocurrencia',
		dadosOleoEdicaoMecanico: 'La información referente al aceite lubricante fue editada por el mecánico',
		dadosOverhaulRevisaoGeral: 'Datos del Overhual / Revisión General',
		dadosProgramacaoVoo: 'Datos de horarios de vuelos',
		dadosdeEntregaDaNFe: 'Datos de entrega de NFe',
		dashboardDadosSistema: 'Tablero de datos del sistema',
		data: 'Fecha',
		dataAbertura: 'Fecha de apertura',
		dataAberturaCadastro: 'Fecha de apertura',
		dataAcesso: 'Fecha de acceso',
		dataAfericao: 'Fecha de Medición',
		dataAtualMaiorUltimoTrecho: 'La fecha actual es mayor que el último tramo de la orden de misión.',
		dataAtualizacao: 'Fecha de actualización',
		dataCE: 'Fecha CE',
		dataCadastroOvn: 'Data de registro de gafas de visión nocturna',
		dataCompra: 'Fecha de compra',
		dataConclusao: 'Fecha de Finalización',
		dataCorrecao: 'Corrección de fecha',
		dataCotacao: 'Fecha de cotización',
		dataCriacao: 'Fecha de criación',
		dataDaConclusao: 'Fecha de finalización',
		dataDaNFE: 'fecha NFe',
		dataDaOcorrencia: 'Fecha de la ocurrencia',
		dataDaSolicitacao: 'Fecha de solicitud',
		dataDeConclusao: 'Fecha de finalizacion',
		dataDeInclusao: 'Fecha de inclusión',
		dataDeInspecao: 'Fecha de inspección',
		dataDeVerificacao: 'Fecha de Verificación',
		dataDesembarque: 'Fecha de desembarco',
		dataDiario: 'Diario de fechas',
		dataDoDiarioDeBordo: 'Fecha del libro de registro',
		dataDoMB1A2: 'fecha MB1A2',
		dataDoPagamento: 'Fecha de pago',
		dataDoRecebimentoFisico: 'Fecha de recibo físico',
		dataDuranteTransporte: 'Fecha durante el transporte',
		dataEmbarque: 'fecha de embarque',
		dataEmissao: 'Fecha de emisión',
		dataEmissaoNotaFiscal: 'Fecha de emisión de la factura',
		dataEncerramento: ' Fecha de cierre:',
		dataErroSuperior: 'La fecha no puede ser posterior al momento actual.',
		dataEstimada: 'Fecha estimada',
		dataExecucao: 'Fecha Ejecución',
		dataFabricacao: 'Date of fabrication',
		dataFim: 'Fecha Fin',
		dataFimIndisponibilidade: 'Indisponibilidad de la fecha de finalización',
		dataFimValidade: 'Fecha de fin de validez',
		dataFinal: 'Fecha final',
		dataGarantia: 'Fecha de garantía',
		dataHora: 'Fecha y hora',
		dataHoraCadastro: 'Fecha-Hora Registro',
		dataHorasVoadas: 'Fecha Horas de vuelo',
		dataHorimetro: 'Fecha Contador de horas',
		dataHorimetroAtual: 'Hora actual Fecha',
		dataInicial: 'La fecha de inicio',
		dataInicio: 'Fecha Inicio',
		dataInicioCarga: 'Fecha de inicio de la primera carga',
		dataInicioIndisponibilidade: 'Fecha de inicio de indisponibilidad',
		dataInicioOvn: 'Fecha de inicio de uso de gafas de visión nocturna',
		dataInicioValidade: 'Fecha de inicio de validez',
		dataInstalacao: 'Fecha de Instalación',
		dataInvalida: 'Fecha Invalida',
		dataLeitura: 'Fecha de lectura',
		dataLimite: 'Fecha límite',
		dataManutencao: 'Fecha Mantenimiento',
		dataNascimento: 'Fecha de Nacimiento',
		dataPreenchimentoFim: 'Fecha de finalización del llenado',
		dataPreenchimentoInicio: 'Fecha de inicio del llenado',
		dataPrevisao: ' Fecha prevista:',
		dataProcessamento: 'Fecha Procesamiento',
		dataProximaInspecao: 'próxima fecha de inspección',
		dataProximo: 'próxima fecha',
		dataReportada: 'Fecha reportada',
		dataServico: 'Fecha de servicio',
		dataSolicitacao: 'Fecha de solicitud',
		dataTermino: 'Fecha de finalización',
		dataTolerancia: 'Fecha de tolerancia',
		dataTreinamento: 'fecha de entrenamiento',
		dataUltimaInspecao: 'Fecha de la última inspección',
		dataUltimo: 'Última fecha',
		dataUltimoVoo: 'Fecha del último vuelo',
		dataVencimento: 'Fecha de vencimiento',
		dataVoo: 'Fecha de vuelo',
		dc: 'dc',
		de: 'De',
		deTrabalho: 'trabajo',
		decimal: 'Decimal',
		decimo: 'Décimo',
		decolagem: 'Despegue',
		decolagemAoPouso: 'Del Despegue al Aterrizaje',
		decolagemPrevista: 'Despegue programado',
		decolagemPrevisto: 'Decolagem previsto',
		defasagemVorI: 'Retraso VOR I',
		defasagemVorII: 'Retraso VOR II',
		definirAeroportoPadraoPartida: '¿Establecer este aeropuerto como predeterminado de salida?',
		definirCargaPadrao: '¿Establecer esta carga útil como predeterminada?',
		definirComoPlanoDeFundo: 'Puesto como fondo',
		definirOperador: 'Definir Operador',
		definirPlanoDeFundo: 'Definir fondo',
		delito: 'Delito',
		demandaReprimida: 'Demanda Reprimida',
		densidade: 'Densidad',
		departamento: 'Departamento',
		departamentoSolicitante: 'departamento solicitante',
		derrogacao: 'humillación',
		desabilitado: 'desactivado',
		desabilitar: 'Desactivar',
		desabilitarInspecao: 'Desactivar inspección',
		desagrupando: 'Dispersante',
		desagrupar: 'desagrupar',
		desagruparTrechos: 'Desagrupar tramos',
		desativadoComSucesso: 'Desactivado correctamente',
		desativar: 'Desactivar',
		desativarInspecao: 'Desactivar la Inspección',
		desativarInspecoes: 'Para deshabilitar esta inspección se requiere una justificación',
		desativarTodas: 'Desactivar todo',
		desativarTodasInspecoes: 'Para deshabilitar todas las inspecciones se requiere una justificación',
		desativarUsuario: 'Desactivar el Usuario',
		desconto: 'Descuento',
		descricao: 'Descripción',
		descricaoAlijamentosCarga: 'Descripción de los vertederos de carga',
		descricaoAnp: 'Descripción de la PAN',
		descricaoCapitulo: 'Descripción del capítulo',
		descricaoCompleta: 'Descripción completa',
		descricaoDaCarga: 'Descripción de la carga',
		descricaoDaMissao: 'Descripción de la misión',
		descricaoDaOrdem: 'Descripción de la orden',
		descricaoDoExercicio: 'Descripción del ejercicio',
		descricaoDoLocal: 'Descripción del sitio',
		descricaoDoTema: 'Descripción del tema',
		descricaoDoUso: 'Descripción de uso',
		descricaoDosFatos: 'Descripción de los hechos',
		descricaoLavagemCompressor: 'Descripción del lavado del compresor',
		descricaoLayer: 'Descripción para capa',
		descricaoOrdemDeMissao: 'Descripción Orden de Misión',
		descricaoOrdemMissaoExcluidoComSucesso: 'Descripción Orden de Misión eliminado correctamente.',
		descricaoOrdemMissaoSalvoComSucesso: 'Descripción Orden de Misión se ha guardado correctamente.',
		descricaoProduto: 'Descripción del Producto',
		descricaoResumida: 'Breve descripción',
		descricaoServico: 'Descripción del Servicio',
		descricaoStatus: 'Status',
		descricaoTipoArmazenamento: 'Descripción Tipo Almacenamiento',
		descricaoTrechos: 'Extractos (Origen - Destino / Despegue previsto / Duración)',
		descricaoTreinamentoHint: 'Describe aquí las instrucciones para realizar la formación o el contenido del programa, por ejemplo.',
		descricaoUnidadeCompra: 'Unidad de compra de presupuesto',
		descritivo: 'Descriptivo',
		desdeOInicio: 'DESDE EL INICIO DE OPERACIÓN EN EL MES',
		desejaAdicionarAssinaturaPorLogin: '¿Quieres agregar una suscripción al iniciar sesión?',
		desejaAdicionarRecomendacao: '¿Quieres agregar alguna recomendación?',
		desejaAprovarSolicitacaoFolga: '¿Quiere aprobar la solicitud de tiempo libre a continuación?',
		desejaAssinarEsseTrecho: '¿Quieres suscribirte a esta sección?',
		desejaAtivarEsseUsuario: '¿Desea habilitar este usuario?',
		desejaAtualizarTrecho: '¿Desea actualizar este tramo?',
		desejaCancelarDiscrepancia: '¿QUIERES CANCELAR ESTA DISCREPANCIA?',
		desejaCancelarEssePedido: '¿Quieres cancelar este pedido?',
		desejaCancelarPrevencao: '¿Desea CANCELAR esa prevención?',
		desejaCancelarSolicitacao: '¿Desea cancelar esta solicitud?',
		desejaCancelarTicket: '¿Quieres CANCELAR este Boleto?',
		desejaConcluirDiscrepancia: 'QUIERO CONCLUIR ESTA DISCREPANCIA',
		desejaConcluirEssaDiscrepancia: '¿Desea concluir esta discrepancia?',
		desejaConfirmarExclusaoNota: 'Quieres confirmar la eliminación de este NFe',
		desejaConfirmarVerificacaoNota: 'Quieres confirmar la verificación de este NFe',
		desejaContinuarAPrrencher: '¿Desea continuar llenando este diario de a bordo?',
		desejaDesativarEsseUsuario: '¿Desea deshabilitar este usuario?',
		desejaEncerrarEssaOrdemDeMissao: '¿Desea cerrar esta orden de misión?',
		desejaEncerrarEssaProgramacaoVoo: '¿Quieres terminar este horario de vuelo?',
		desejaEncerrarEsse: 'Desea cerrar este',
		desejaEncerrarEsseDespacho: 'Desea cerrar este auto',
		desejaEncerrarProgramacao: 'Desea cerrar la programación?',
		desejaEnviarNotificacaoTripulante: '¿Quieres enviar una notificación a un miembro de la tripulación?',
		desejaExcluir: 'Quieres borrar',
		desejaExcluirAbastecimento: '¿Quieres eliminar permanentemente el suministro?',
		desejaExcluirACarga: 'Quieres borrar la carga',
		desejaExcluirADocumentacao: 'Quieres borrar la documentación',
		desejaExcluirAcesso: 'Deseas eliminar lo acceso?',
		desejaExcluirCategoria: '¿Deseja eliminar categoria?',
		desejaExcluirClassificacao: '¿Desea eliminar esta clasificación?',
		desejaExcluirContexto: '¿Desea eliminar este contexto operativo?',
		desejaExcluirContrato: '¿Desea eliminar este contrato?',
		desejaExcluirDesativarCasoMedico: '¿Quieres eliminar/desactivar este caso médico?',
		desejaExcluirDesativarClassificacao: '¿Quieres eliminar/desactivar esta Clasificación?',
		desejaExcluirDesativarComunidade: '¿Quieres eliminar/desactivar esta comunidad?',
		desejaExcluirDesativarSubclassificacao: '¿Quieres eliminar/desactivar esta Subclasificación?',
		desejaExcluirDesativarTipoDocumentoHabilitacao: '¿Quieres eliminar/desactivar este tipo de documento?',
		desejaExcluirDesativarTipoMotivoNaoembarque: '¿Quieres eliminar/desactivar este motivo de no embarque?',
		desejaExcluirEmbalagem: '¿Desea excluir este embalaje?',
		desejaExcluirEmpenho: 'Quieres eliminar este compromiso:',
		desejaExcluirEssaAtividade: '¿Quieres eliminar esta actividad?',
		desejaExcluirEssaGrupoVoos: 'Quieres eliminar este grupo de vuelos',
		desejaExcluirEssaLeitura: '¿Quieres eliminar esta lectura obligatoria?',
		desejaExcluirEssaPermissao: '¿Realmente desea eliminar este permiso?',
		desejaExcluirEssaSolicitacao: '¿Desea eliminar esta solicitud?',
		desejaExcluirEsse: '¿Quieres borrar esto',
		desejaExcluirEsseDespacho: '¿Desea eliminar esta orden?',
		desejaExcluirEsseDocumento: '¿Quieres eliminar este documento?',
		desejaExcluirEsseEmpenho: '¿Quieres eliminar este esfuerzo?',
		desejaExcluirEsseItem: '¿Quieres eliminar este elemento?',
		desejaExcluirEsseLayer: '¿Quieres eliminar esta capa?',
		desejaExcluirEsseProcedimento: '¿Quieres eliminar este trámite?',
		desejaExcluirEsseProduto: '¿Quieres eliminar este producto?',
		desejaExcluirEsseProdutoServico: 'Do you want to delete this product/service',
		desejaExcluirEsseTipo: '¿Quieres eliminar este Tipo?',
		desejaExcluirEsseTrecho: '¿Desea eliminar este fragmento?',
		desejaExcluirFornecedor: '¿Desea eliminar este proveedor?',
		desejaExcluirMalhaVoo: '¿Quieres eliminar este Flight Mesh?',
		desejaExcluirMensagem: '¿Quieres eliminar este mensaje?',
		desejaExcluirOTipoDeSolicitacao: '¿Quieres eliminar el tipo de solicitud?',
		desejaExcluirParametroLegais: '¿Quieres eliminar este Parámetro Legal?',
		desejaExcluirPontoInteresse: '¿Quieres eliminar el punto de interés?',
		desejaExcluirSubclassificacao: '¿Desea eliminar esta subclasificación?',
		desejaExcluirUnidadeMedida: '¿Quieres eliminar esta unidad de medida?',
		desejaFinalizarTrecho: '¿Desea finalizar este tramo?',
		desejaGerarFatura: '¿Quieres generar una factura para esta factura?',
		desejaReabrirEssaOrdemMissao: '¿Quieres abrir esta Orden de Misión?',
		desejaReabrirEsse: '¿Quieres abrir esta',
		desejaReabrirEsseProgramacao: '¿Desea reabrir esta programación?',
		desejaReprovarSolicitacaoFolga: ' ¿Quieres rechazar la solicitud de tiempo libre?',
		desejaRetornarOrdemMissaoExecucao: '¿Quieres devolver esta orden de misión a Running?',
		desejaSelecionarvoo: '¿Usar un modelo de vuelo de malla?',
		desejada: 'Deseada',
		desembarque: 'N° ATERRIZAJE',
		desembarqueFicha: 'aterrizaje',
		desenvolvedorVejaOErroRetornadoPeloBackEnd: 'Desarrollador vea el error devuelto por el backend',
		designativo: 'Designador',
		desmarcarTodos: 'Deseleccionar todo',
		desmarqueTrechosCarg: 'Desmarque las secciones que la carga no irá',
		desmarqueTrechosPass: 'Desmarque las secciones a las que no irá el pasajero',
		desmarqueTrechosTrip: 'Deseleccionar las secciones a las que el tripulante no irá',
		despacho: 'Despacho',
		despachoAeronaves: 'Despacho Aeronaves',
		despachoDeAeronaves: 'Despacho de Aeronaves',
		despachoEmergencial: 'Despacho Emergencial',
		despachoExcluido: 'Despacho Excluido',
		despachoGerado: 'Programa generado con éxito',
		despachoReaberto: 'Despacho Reabierto.',
		despachoSalvo: 'Despacho de salvación',
		despachos: 'Despachos',
		despachosDisponiveis: 'Encontramos más de un despacho disponible seleccione a cuál se refiere este vuelo',
		despachosDisponiveisSemAero: 'No encontramos ningún pedido abierto para este avión. Elija un envío listado o ingrese un nuevo envío',
		despachosGerados: 'Órdenes Generadas',
		despachosNaoDisponiveis: 'No pudimos encontrar envíos disponibles ingrese un nuevo envío',
		despachosProgramacaoSemAero: 'No encontramos ningún horario de vuelo abierto para este avión. Elija un horario de la lista o ingrese un nuevo horario',
		despachosProgramacoesDisponiveis: 'Todos los horarios de vuelos abiertos se enumeran a continuación. Seleccione de la lista o ingrese un nuevo horario',
		despachosProgramacoesNaoDisponiveis: 'No encontramos ningún horario de vuelo abierto. Haga clic en Agregar horario de vuelo para registrarse nuevamente',
		destinatario: 'Destinatario',
		destinatarios: 'destinatarios',
		destino: 'Destino',
		destinoAproximado: 'Destino Aproximado',
		detalhar: 'Detalle',
		detalhes: 'Detalles',
		detalhesDaProgramacao: 'Detalles del horario',
		detalhesDoPagamento: 'DETALLE DEL PAGO',
		detalhesDoProduto: 'Detalles del producto',
		determinacaoSessaoManutencao: 'Conforme a la determinación de la sesión de mantenimiento',
		deveConterMininoUm: 'Debe contener al menos 01',
		devolucaoPrevista: 'Regreso Esperado',
		devolvido: 'Devuelto',
		devolvidoEm: 'Regresó el',
		dheg: 'dheg',
		diaAnterior: 'Dia anterior',
		diagonal: 'Diagonal',
		diagonalManutencao: 'Diagonal de Mantenimiento',
		diarias: 'Diario',
		diario: 'Diario',
		diarioDeBordo: 'Bitacóra de Vuelo',
		diarioDeBordoMecanico: 'Diario de Bordo Mecánico',
		diarioDeBordoOperador: 'Diario de Bordo Operador',
		diariosDeBordo: 'Bitacóras de Vuelo',
		diariosDeBordoNaoAssinados: 'Libros de registro sin firmar',
		dias: 'Días',
		diasMaisComuns: 'Día más común',
		diasRestantes: 'Días Restantes',
		diferencaUTC: 'Diferencia de UTC',
		digestivo: 'Digestivo',
		digiteANovaAssinatura: 'Ingrese la nueva firma en el campo a continuación',
		digiteNovaSenhaAbaixo: 'Escriba la nueva contraseña en el campo siguiente.',
		digiteOItemQueDesejaBuscar: 'Ingrese el artículo que desea buscar',
		digiteParaBuscar: 'Escribe para buscar',
		digiteParaRealizarUmaBuscaAvancada: 'Ingrese para realizar una búsqueda avanzada',
		digiteSeuLogin: 'Introduzca su nombre de usuario.',
		digiteSuaAssinatura: 'Introduzca su suscripción',
		digiteSuaSenhaParaRenovala: 'Introduzca su contraseña para renovarla.',
		direcao: 'Dirección',
		direito: 'Derecha',
		diretoOrdemServicoAeronave: 'Ir directamente a las Órdenes de Trabajo de la Aeronave',
		disciplina: 'Disciplina',
		disciplinaAtualizada: 'Disciplina actualizada',
		disciplinaInserida: 'Disciplina insertada',
		discrepancia: 'discrepancia',
		discrepancia1: 'Discrepancias',
		discrepancia2: 'Discrepancia',
		discrepanciaConcluida: 'Discrepancias concluidas',
		discrepanciaSalva: 'Discrepancia Salva',
		discrepancias: 'Discrepancias',
		discrepanciasTecnicas: 'Discrepancias Técnicas',
		discrepanciasVerificadas: 'Discrepancias Comprobadas',
		dispensaMedica: 'Dispensación Médica',
		disponibilidade: 'Disponibilidad',
		disponibilizarAeronave: 'Disponibilizar Aeronave',
		disponivel: 'Disponible',
		disponivelEm: 'Disponible en',
		disponivelNa: 'Disponible en',
		disponivelParaRetorno: 'Disponible para el retorno',
		distancia: 'Distancia',
		distanciaCalculada: 'Distancia Calculada',
		distanciaEmNM: 'Distancia en Nuevo México',
		distanciaTotal: 'Distancia total',
		diurno: 'Diurno',
		divorciado: 'Divorciado(a)',
		do: 'del',
		doArtigo: 'DEL ARTE. 4° DE LA RESOLUCIÓN 457',
		doContrato: 'del contrato',
		documentacao: 'Documentación',
		documentacaoExcluidaComSucesso: 'Documentación eliminada correctamente',
		documentacaoSalva: 'Documentación Salva',
		documento: 'Documento',
		documentoExcluidoComSucesso: 'Documento eliminado con éxito.',
		documentoLeituraObrigatoria: 'Documento de lectura obligatoria',
		documentoObrigatorioExiste: 'El documento obligatorio ya existe en el sistema',
		documentoS: 'Documentos',
		documentoSalvoComSucesso: 'Documento guardado con éxito.',
		documentos: 'Documento(s)',
		documentosArmazenados: 'Documentos almacenados',
		documentosSemDuplicidade: 'CPF y Passport son los únicos documentos que evitan registros duplicados',
		dois: 'Dos',
		dosUltimos: 'del último',
		download: 'Descargar',
		downloadAnexo: 'Descargar Anexo',
		dpoAlteraAtual: 'Cambios de Plazo y DPO vigente.',
		dpoAlterar: 'Cambiar DPO',
		dpoAssinarPolitica: '¿Quiere exigir que todos los usuarios firmen la nueva política de privacidad, incluidos los usuarios que ya firmaron anteriormente?',
		dpoCpf: 'DPO CPF',
		dpoEmail: 'Correo electrónico para contactar con el DPO',
		dpoEndereco: 'Dirección de correspondencia con DPO',
		dpoNome: 'Nombre completo del DPO',
		dpoTelefone: ' Teléfono de contacto del DPO',
		duplicar: 'Duplicar',
		duracao: 'Duración',
		duracaoHintTreinamento: 'El campo de periodicidad se vuelve obligatorio al completar este campo.',
		duracaoPrevistaJornada: 'DURACIÓN JORNADA DE TRABAJO PREVISTO',
		duracaoPrevistaVoo: 'Duración prevista del vuelo',
		duranteTransporte: 'Durante el transporte',
		e: 'y',
		eDestino: 'y el destino',
		eEstrangeiro: 'Es extranjero',
		eImportanteFazerEsseProcedimento: 'Es importante realizar este procedimiento antes de que la aeronave comience a volar',
		eNecessario: 'Se debe generar una factura',
		eOperador: 'es el operador',
		eUmKit: '¿Es un kit?',
		eUsuario: 'y Usuario',
		edicao: 'Edición',
		editadoMecanico: 'EDITADO MECÁNICO',
		editadoPor: 'Editado por',
		editar: 'Editar',
		editarCapitulo: 'Editar Capítulo',
		editarCategoria: 'Editar Categoría',
		editarDespacho: 'Editar orden',
		editarDiario: 'Editar diario',
		editarDocumento: 'Editar documento',
		editarEscala: 'editar escala',
		editarHabilitacao: 'Editar licencia',
		editarMalha: 'editar malla',
		editarTipo: 'Tipo de edición',
		editarTrecho: 'Editar Tramo',
		editarUsuarioSimplificado: 'Editar Usuario Simplificado',
		editaveis: 'Editable',
		efetividade: 'Efectividad',
		em: 'en',
		em2: 'en',
		emAberto: 'En abierto',
		emAnalise: 'En análisis',
		emAndamento: 'EN CURSO',
		emBrancoMantemAssinatura: 'En blanco mantenga la misma firma',
		emEstoque: 'En stock',
		emExecucao: 'En ejecución',
		emExecucaoOuAberta: 'En ejecución o abierta',
		emExecucaoVencida: 'En ejecución vencida',
		emHoras: 'En horas',
		emMeses: 'en Meses',
		emMesesDias: 'en meses y días',
		emMonitoramento: 'En seguimiento',
		emMovimento: 'En movimiento',
		emTolerancia: 'en tolerancia',
		emUso: 'en uso',
		email: 'Correo electrónico',
		emailAnac: 'E-mail ANAC',
		emailInvalido: 'E-mail no válido.',
		emailJaCadastrado: 'Correo electrónico ya registrado.',
		emailObrigatorio: 'Correo electrónico obligatorio',
		embalagemExcluidaComSucesso: 'Embalaje excluido con éxito.',
		embalagemJaCadastrada: 'Paquete ya registrado',
		embarcou: 'Abordado',
		embarque: 'Embarque',
		emergencia: 'Emergencia',
		emergencial: 'Emergencia',
		emissao: 'Emisión',
		emitiuReceita: '¿Emitiste una receta?',
		empenho: 'Compromiso',
		empenhoExcluidoComSucesso: 'Esfuerzo eliminado con éxito',
		empenhoSalvoComSucesso: 'Compromiso guardado con éxito',
		empenhos: 'Compromisos',
		empresa: 'Empresa',
		empresaEstrangeira: 'compañía extranjera',
		encaminharParaExecucao: 'Encaminhar a Ordem para execução',
		encerrada: 'Cerrado',
		encerramento: 'Cierre',
		encerrar: 'Cerrar',
		encerrarProgramacao: 'Encerrar cronograma',
		encerrardespacho: 'Cerrar orden',
		encerrouCom: 'Terminó con',
		encontrados: 'encontró',
		end: 'Dirección',
		endereco: 'Dirección',
		enderecoFuncional: 'Dirección Funcional',
		enderecoResidencial: 'Dirección Residencial',
		enfermeiro: 'Enfermero',
		ensino: 'Enseñanza',
		ensinoInfantil: 'Educação infantil',
		ensinoSuperior: 'Ensino Superior (Graduação)',
		enterSalvaEscCancela: 'ENTRAR para guardar y ESC para cancelar',
		entrada: 'Prohibido',
		entradaEfetuada: 'Registrado',
		entradaRegistrada: 'Entrada registrada',
		entreEmContatoConosco: 'Contáctenos',
		entregar: 'Entregar',
		entregarSuprimentos: 'Entregar suministros',
		entregue: 'Entregado',
		enviaMensagem: 'Enviar mensaje',
		enviamosUmEmail: 'Enviamos email para usted',
		enviando: 'Enviando',
		enviandoSuprimentos: 'Suministros de envío',
		enviar: 'Enviar',
		enviarArquivos: 'Enviar archivos',
		enviarSolicitacao: 'Enviar solicitud',
		envioNotificacoes: 'Envío de notificaciones',
		envolvidos: 'Involucrados',
		equipamento: 'Equipo',
		equipamentoTrocado: 'Equipo intercambiado',
		equipamentos: 'Equipamientos',
		equipe: 'Equipo',
		equipeTitular: 'Equipo/inicial',
		erro: 'Error',
		erroAoNotificar: 'Erro ao notificar',
		erroConectarServidor: 'Error al conectarse al servidor.',
		erroDataOvn: 'No está permitido relacionar este OVN con la sección anterior a su registro.',
		erroExcluir: 'error al eliminar',
		erroHorimetro: 'Contador de horas no completado en el registro de la aeronave',
		erroInserir: 'error al insertar',
		erroVor: 'Erro(grados)',
		escala: 'Escala',
		escalaEditada: 'Escala editada exitosamente',
		escalaEditadaErro: 'Error al editar la escala',
		escalaFinalizada: 'Escala completada exitosamente',
		escalaFinalizadaErro: 'Error al finalizar escala',
		escalaReaberta: 'báscula reabierta exitosamente',
		escalaReabertaErro: 'error al reabrir báscula',
		escalaTripulacao: 'horario de la tripulación',
		escalaTripulante: 'lista de tripulantes',
		esclero: 'Esclero',
		escola: 'Escuela',
		escolaDeVoo: 'Escuela de vuelo',
		escolaridade: 'Escolaridad',
		escolha: 'Elección',
		escolhaAFuncaoTripulante: 'Seleccione la función de este tripulante',
		escolhaAOrigem: 'Seleccione el origen',
		escolhaData: 'Elija una fecha',
		escolhaOMotivoCancelamentoOrdem: 'Seleccione el motivo para cancelar la solicitud',
		escolhaOpcao: 'Elija una probabilidad y gravedad',
		escolhaOpcaoAbaixo: 'Elija una acción a continuación',
		escolhaPeloMenosUmTrecho: 'Elija al menos un segmento por pasajero',
		escolhaPeloMenosUmTrechoCarga: 'Elija al menos un segmento por carga',
		escolhaProbabilidade: 'Elija una probabilidad',
		escolhaSeveridade: 'Elija una gravedad',
		escolhaUmEmpenhoParaOCampoValorSerLiberado: 'Elija un compromiso para el campo de valor que se liberará',
		escolhaUmTrechoParaCopiar: 'Elija un tramo para que usted copie.',
		escolhaUmaAcao: 'Elija una acción anterior.',
		escolhaUmaClassificacaoPara: 'Seleccione una clasificación<br/> para ver la lista.',
		escolhaUmaOpcao: 'Elige una opción',
		escolhaUmaOpcaoAbaixo: 'Elija una opción a continuación.',
		escolhaUmaOpcaoAoLado: 'Elija una opción en el menú junto a.',
		escolhaUmaTabelaDoBancoDeDadosNaLista: 'Elija una tabla de base de datos de la lista',
		escolhaaTurma: 'Elegir una Clase',
		escolhaoAluno: 'Elegir un Alumno',
		escolhaoTreinamento: 'Elegir un Treinamento',
		escolherItemAcima: 'Tienes que elegir uno o más elementos anteriores.',
		esconder: 'Esconder',
		esconderConcluidos: 'Esconder Terminadas',
		esconderDetalhes: 'Ocultar detalles',
		esconderItens: 'Ocultar elementos',
		escritorio: 'Escritório',
		esfera: 'Alcance',
		espacoEmDisco: 'Espacio en disco',
		espacoEmDiscoUtilizado: 'Espacio en disco usado',
		especial: 'Special',
		especieOuTipo: 'Especies/Tipo',
		esqueceuSuaSenha: 'Olvidaste tu contraseña?',
		esqueciMinhaSenha: 'Olvide mi contraseña',
		esquerdo: 'Izquierda',
		essaDocumentacaoTemValidade: 'Esta documentación es válida.',
		essaOrdem: 'Esta orden',
		essaOrdemNaoPossui: 'Este pedido NO TIENE firma',
		essaOrdemPossui: 'Este pedido TIENE firma',
		essaSolicitaoTemAvalManutencao: '¿Esta solicitud tiene el aval del Mantenimiento?',
		essaSolicitaoTemOaval: '¿Esta solicitud tiene el aval de la Operación?',
		esseCampoObrigatorio: 'Este campo es obligatorio',
		esseDiarioDeBordoNaoEstaIntegroEntreEmContatoComOSuporte: 'Este libro de registro no está completo comuníquese con el soporte.',
		esseGrupoExige: 'Este grupo requiere la firma del inspector.',
		esseMes: 'Ese mes',
		esseTrechoNaoPodeSerPreenchido: 'Este tramo no puede llenarse ahora',
		essesDados: 'Estos datos',
		estaExibindo: 'esta mostrando',
		estaPreenchendoUmDiarioDeBordo: 'está llenando un diario para esa aeronave.',
		estaSiglaUtilizadaRelatorios: 'Esta sigla se utiliza en algunos informes. Si es una función estándar de la ANAC, el campo se completará automáticamente de acuerdo con las directrices de la ANAC. Si estás registrando una nueva función, introduce la sigla que corresponda a la descripción de la función.',
		estado: 'Estado',
		estadoCivil: 'Estado Civil',
		estadoConsciencia: 'Estado de conciencia',
		estadoDeVerificacao: 'Estado de Verificación',
		estadoDoItem: 'Estado del artículo',
		estagiario: 'Aprendiz',
		estavaAtualizado: 'Se actualizó',
		esteCampoEObrigatorio: 'Este campo es requerido',
		estePerfilEhTripulante: 'Este perfil es tripulación',
		estoque: 'Inventario',
		estoqueDisponivelSuprimentos: 'Disponible',
		estoqueQuantidadeMinima: 'Cantidad mínima de producto en stock.',
		estoqueTotalSuprimentos: 'Stock total incluidos ELIMINADOS Y DEFECTUOSOS',
		estoqueUnidadeMedida: 'Inventario - Unidades de Medida',
		estouCiente: 'Estoy consciente',
		estouCienteQuanto: 'ESTOY CONSCIENTE DE LA INFORMACIÓN PROPORCIONADA POR EL',
		etiqueta: 'Etiqueta',
		evento: 'Evento',
		excecoes: 'excepciones',
		excelParaCompra: 'Excel para comprar',
		excelente: 'EXELENTE',
		excluida: 'Eliminado',
		excluidoComSucesso: 'Excluido con éxito!',
		excluidoSucesso: 'eliminado exitosamente',
		excluindo: 'Excluyendo',
		excluir: 'Borrar',
		excluirAtualizacao: 'Eliminar actualización',
		excluirAbastecimento: 'Eliminar Abastecimento',
		excluirContrato: 'Borrar Contrato',
		excluirDesativar: 'Eliminar/Desactivar',
		excluirDespacho: 'Eliminar despacho',
		excluirFatura: 'BORRAR FACTURA',
		excluirFoto: 'Excluir Foto',
		excluirImagem: 'Eliminar Imagen',
		excluirLicenca: '¿Quieres eliminar esta licencia?',
		excluirMensagem: 'Borrar mensaje',
		excluirPontoInteresse: 'Eliminar punto de interés',
		excluirProcedimento: 'Eliminar procedimiento',
		excluirUsuario: 'Excluyendo usuario',
		exclusaoLeitores: 'Exclusión de lectores obligatorios',
		execucao: 'Ejecución',
		execucaoSalva: 'La ejecución se guardó correctamente.',
		executado: 'Ejecutado',
		exercicio: 'EJERCICIO',
		exercicios: 'Ejercicios',
		exibeAnuncio: 'Muestra anuncios',
		exibeDiariosVinculoCom: 'Muestra los diarios de este',
		exibeDiariosVinculoComDespacho: 'Muestra los diarios de este envío.',
		exibicao: 'Mostrar',
		exibir: 'Exhibir',
		exibirConcluidos: 'Mostrar completadas',
		exibirDadosDiarioBordo: 'Los datos se rellenarán tras rellenar el CE y número de aeronave según bitácora',
		exibirDesativados: 'Ver Deshabilitados',
		exibirEncerradas: 'Mostrar Cerradas',
		exibirFaturaEmAtraso: '¿Mostrar mensaje Factura vencida?',
		exibirLegendas: 'Ver subtítulos',
		exibirTodas: 'Mostrar Todos',
		exibirTodosTrechos: 'Mostrar todas las secciones',
		exibirTrechosSelecionados: 'Mostrar secciones seleccionadas',
		exigirPolitica: 'Exigir que cada usuario firme digitalmente la Política de Privacidad en su primer acceso.',
		exigirPoliticaObrigatoria: 'Todos los usuarios del sistema deberán aceptar la nueva Política de Privacidad en su primer acceso.',
		existemCampoDaAeroASerem: 'Existen campos a ser llenados en las aeronaves empleadas.',
		existiuAcompanhante: '¿Hay una escolta?',
		existiuAvarias: '¿Se han registrado fallos de funcionamiento?',
		experienciaRecente: 'Experiencia reciente - Últimos 90 días',
		experienciaTotal: 'Experiencia total',
		exportacaoDados: 'Exportación de datos',
		exportar: 'Exportar',
		exportarJSON: 'Exportar JSON',
		externo: 'Externo',
		extrato: 'Extracto',
		extratoDiarioDeBordo: 'Extracto Diario de Bordo',
		extremamenteImprovavel: 'Extremadamente improbable',
		fabricacao: 'Fabricación',
		fabricante: 'Fabricante',
		fabricanteAtualizado: 'Fabricante Actualizado',
		fabricanteInserido: 'Fabricante Añadido',
		fabricantes: 'Fabricantes',
		faixaEtaria: 'rango de edad',
		faltaPagar: 'Falta pagar',
		farol: 'Faro',
		fatorContribuinte: 'Factor contribuyente',
		fatura: 'FATURA',
		faturaEmAberto: 'FACTURA ABIERTA',
		faturaFechadaPor: 'FACTURA CERRADA POR',
		faturaSBH: 'Factura SBH',
		faturas: 'FACTURAS',
		favorPreencherCamposDiurnoNoturno: 'Rellene los campos "Día", "Noche", "RSI real" o VFR.',
		favorPreencherCamposEmVermelho: 'Por favor llene el (los) campo (s) en rojo.',
		fechaExercicio: 'CERRAR EJERCICIO',
		fechado: 'Cerrado',
		fechar: 'Cerrar',
		fecharDadosDaAeronave: 'Cerrar datos de la aeronave',
		fecharOrdemDeMissao: 'Cerrar el orden de misión',
		fem: 'Femenino',
		feminino: 'Femenino',
		ferias: 'Vacaciones',
		ferramenta: 'Herramienta',
		ficha: 'Registro',
		fichaCadastralFuncional: 'Ficha de Registro Funcional',
		fichaDeAtendimento: 'Formulario de servicio',
		fichaDeAtendimentoPreHospitalar: 'Formulario de atención prehospitalaria',
		figado: 'Hígado',
		filtrar: 'Filtrar',
		filtrarPorNome: 'Posiciones de filtro',
		filtro: 'Filtros',
		filtroPor: 'Filtrar por:',
		filtros: 'Filtros',
		fim: 'Fin',
		fimAtividade: 'fin de actividad',
		fimJornada: 'final del viaje',
		fimRepouso: 'Fin del descanso',
		fimVigencia: 'Fin de los términos',
		final: 'Final',
		finalidade: 'propósito',
		finalizadoPor: 'Finalizado por:',
		finalizar: 'Final',
		finalizarEdicao: 'terminar de editar',
		finalizarEscala: 'Finalizar escala',
		finalizarOrdemDeServico: 'Finalizar orden de servicio',
		finalizarTracho: 'Finalizar Tramo',
		foiAtivado: 'Se ha activado',
		foiGeradoUmCodigo: 'Se ha generado una orden de misión con código',
		foiPressionado: 'Fue presionado',
		folga: 'Día libre',
		folgaSolicitada: '¿Tiempo libre solicitado?',
		forcarAssinarTermo: 'Forzar firmar término?',
		forma: 'Pago',
		formaControle: 'Forma de control',
		formaControleAlteradaSucesso: '¡El formulario de control se cambió correctamente!',
		formaDePagamento: 'Forma de pago',
		formularioBloqueado: 'El formulario estará bloqueado para modificaciones.',
		fornecedor: 'Proveedor',
		fornecedorCombustivel: 'Suministro de Combustible',
		fornecedores: 'Proveedores',
		foto: 'Fotografía',
		fotorreagentes: 'Fotorreactivos',
		fragil: 'Frágil',
		frequencia: 'Frecuencia',
		frequenciaCardiacaBpm: 'Frecuencia cardíaca (lpm)',
		frequenciaRespiratoria: 'frecuencia respiratoria',
		frequenciaRespiratoriaBpm: 'Frecuencia respiratoria (lpm)',
		frequente: 'Frecuente',
		funcao: 'función',
		funcaoABordo: 'Función a bordo',
		funcaoComoTripulante: 'Función como Tripulante',
		funcaoNaEmpresa: 'Función na Empresa',
		funcoes: 'Roles',
		fuso: 'Huso',
		fusoHorario: 'Huso Horario',
		fusoOrigem: 'Huso de Origen',
		galao: 'Galón',
		gancho: 'Gancho',
		ganchos: 'Manos',
		geradoApos: 'Generado después de rellenar',
		geradoPor: 'Generado por',
		gerais: 'General',
		geral: 'General',
		gerando: 'Generando',
		gerandoDespacho: 'Generando despacho de la semana',
		gerandoRelatorio: 'Generando Informe',
		gerandoRelatorioDemorar: 'Generando Informe(esto puede llevar un tiempo)',
		gerar: 'Generar',
		gerarDespacho: 'Generar despacho',
		gerarDespachoAvulso: 'Generar pedido separado',
		gerarDespachoSemana: 'Generar despacho de la semana',
		gerarDiarioBordo: 'Generar libro de registro',
		gerarEscala: 'Generar escala',
		gerarExcel: 'Generar Excel',
		gerarFatura: 'Generar factura',
		gerarMapa: 'Generar Mapa',
		gerarNotas: 'Generar notas',
		gerarOrdem: 'Generar Orden',
		gerarOrdemDeServico: 'Generar orden de servicio?',
		gerarOrdemMissao: 'Generar Orden de Misión',
		gerarOrdemServico: 'Generar orden de servicio',
		gerarPrevencao: 'Generar Prevención',
		gerarProgramacaoDeVoo: 'Generar horario de vuelos',
		gerarProgramacaoVoo: 'generar horario',
		gerarRelatorio: 'Generar Informe',
		gerenciamentoDeRisco: 'Gestión de riesgos',
		gerenciamentoDeRiscoRecomendacao: 'Recomendación de Gestión de Riesgos',
		gerenciamentoTrecho: 'Gestión de Tramo',
		gerenciamentoVoo: 'Gestión de Vuelo',
		gesta: 'gesto',
		gestao: 'Gestión',
		gestaoAbastecimento: 'Administración de proviciones',
		gestaoAeronave: 'Gestión de aeronaves',
		gestaoDe: 'Gestión de',
		gestaoDeContratos: 'Gestión de contratos',
		gestaoDeEscala: 'Gestión de escala',
		gestaoDeMalha: 'Gestón de malla',
		gestaoInterna: 'Gestión Interna',
		gestaoLayer: 'Gestión de Capas',
		gesticulacao: 'Gesticulación',
		gestorResponsavel: 'Gerente responsable',
		glasgow: 'Glasgow',
		glicemiaMgDl: 'Glucosa en sangre (mg/dl)',
		graficos: 'Gráficos',
		grau: 'GRADO',
		grauDeRelacionamento: 'Grado de Relación',
		graus: 'Grados',
		grupo: 'Grupo',
		grupoDePassageiro: 'Grupo de Pasajeros',
		grupoDePassageiroSalvoComSucesso: 'Grupo de Pasajeros guardado correctamente.',
		grupoDePassageiros: 'Grupo de Pasajeros',
		grupoDePassageirosAtualizadoComSucesso: 'Grupo de pasajeros actualizado con éxito.',
		grupoDePassageirosExcluidoComSucesso: 'Grupo de pasajeros eliminado correctamente',
		grupoDePassageirosSalvoComSucesso: 'Grupo de Pasajeros guardado correctamente.',
		grupoDeTripulantesTecnicos: 'Grupo de tripulación técnica',
		grupoOrgaos: 'grupo de órganos',
		grupoVoos: 'Grupo de vuelo',
		grupos: 'Grupos',
		guarnicao: 'Guarnición',
		guincho: 'Cabrestante',
		hAssinatura: 'Firma',
		hNotificacao: 'Notificaciones',
		haCargaASerTransportada: '¿Hay carga a ser transportada?',
		haContextoOperativo: '¿Hay contexto operativo?',
		haNecessidadeDeAbastecimento: '¿Hay necesidad de reabastecimiento?',
		haNecessidadeDeAlmoco: 'Almuerzo',
		haNecessidadeDeCafeManha: 'Desayuno',
		haNecessidadeDeDiarias: '¿Hay necesidad de empeño de diarias?',
		haNecessidadeDeJantar: 'Cena',
		haPassageiros: '¿Hay Pasajeros?',
		haResalvasNaSituacao: '¿Hay salvedades en la situación?',
		haTripulacaoTecnica: '¿Hay equipo técnico?',
		habilitaCamp: '0',
		habilitacao: 'Habilitación',
		habilitacaoExcluido: 'Licencia eliminada exitosamente',
		habilitacaoRequerida: 'Habilitación Requerida',
		habilitado: 'habilitado',
		habilitar: 'Permitir',
		habilitarCargasEmTempos: 'Habilitar carga de tiempo',
		habilitarCiclos: 'Habilitar Ciclos',
		habilitarContrato: 'Habilitar contrato',
		habilitarContratoConfirmacao: '¿Realmente desea habilitar este contrato?',
		habilitarInspecao: 'Habilitar inspección',
		haviamCargasPerigosas: '¿Hubo cargas peligrosas?',
		helicopteros: 'Helicópteros',
		hintAeroportoFavorito: 'Cuando se marca como SÍ este aeropuerto se definirá como de salida en la Solicitud. Si ya hay un aeropuerto favorito definido será reemplazado',
		hintCargaPadrao: 'Cuando se marca como SÍ esta carga se definirá como predeterminada en la Solicitud. Si ya hay una carga útil predeterminada definida será reemplazada',
		hintInformacoesRenovacao: 'Ingrese los datos a continuación sobre la programación de exámenes/simuladores/vuelos de verificación para renovación de licencias calificaciones y registros',
		hintNotificarTodos: 'Al hacer clic en “Notificar a todos solo se notificará a aquellos que no hayan leído el documento',
		hintSituacaoAdministrativa: 'Cumplimiento obligatorio para cumplir con la norma establecida en el punto 61.4 (a) del RBAC 61',
		hintTrigrama: 'Rellena este campo utilizando las tres iniciales de tu nombre y apellido o según tu preferencia.',
		hipoteseDiagnostica: 'Hipótesis diagnóstica',
		historico: 'Historia',
		historicoAcesso: 'Historial de Acceso',
		historicoAtualizacoesDocumento: 'Historial de actualización de los documentos',
		historicoDoEmpenho: 'Historial de compromisos',
		historicoSistema: 'Historial del sistema',
		historicoTreinamentos: 'Historial de entrenamiento',
		historicoVoo: 'Historico del',
		homeHora: 'Hombre/Hora',
		hora: 'Hora',
		horaChamada: 'hora de llamada',
		horaFinal: 'Hor. Fin',
		horaInicial: 'Hor. Hogar',
		horario: 'schedule',
		horarioAcionamentoInvalido: 'La hora informada es anterior a la hora de corte del apartado anterior',
		horarioApresentacao: 'tiempo de presentación',
		horarioApresentacaoTripulacao: 'Horario de presentación de la tripulación',
		horarioMaisComum: 'Horario más común',
		horarioPrevisto: 'Hora prevista',
		horarioVoo: 'tiempo de vuelo',
		horariosMaisComuns: 'Horarios más comunes',
		horas: 'Horas',
		horasAcionamentoCorte: 'Horas de Activación de Corte',
		horasCelula: 'Horario de celular',
		horasCelulaProximaInspecao: 'Horas Célula Próx. Inspección',
		horasDeCelulaParaAProxima: 'Horas de celda previstas para la próxima intervención',
		horasDeUtilizacao: 'Horas de uso',
		horasDeVooApoio: 'Horas de vuelo en apoyo',
		horasDecolagemPouso: 'Horas de Despegue a Aterrizaje',
		horasDisponiveis: 'Horas disponibles',
		horasDisponivel: 'Horas disponibles',
		horasECiclosDoMes: 'Horas y ciclos del mes.',
		horasManutencao: 'Horas de mantenimiento',
		horasMotor: 'Horas de motor',
		horasMotorInformativo: 'Referido a las horas de motor computadas en el momento de cumplimentar el Libro de Bitácora. El monto será informado solo después de completar el formulario',
		horasOvnAntesDb: 'Gafas de visión nocturna horas antes de completar el primer libro de registro',
		horasPilotoComandoInstrucao: 'Las horas de piloto al mando también incluyen horas como piloto en formación',
		horasProximaInspecao: 'Próximo horario de inspección',
		horasTotais: 'El tiempo total',
		horasTotaisAcionamentoCorte: 'Total de horas conducidas al corte',
		horasTotaisDecolagemPouso: 'Horas totales de despegue a aterrizaje',
		horasUltimaInspecao: 'Últimas horas de inspección',
		horasUsoDecimal: 'Horas de uso (decimales)',
		horasVoadas: 'Horas de Vuelo',
		horasVoadasAbreviacao: 'HV',
		horasVoadasSemanal: 'Horas voladas semanalmente',
		horasVoo: 'Horas de vuelo',
		horasVooPrimeiroPilotoComando: 'Horas de vuelo Primer comando piloto',
		horasVooSegundoPilotoComando: 'Horas de vuelo Segundo piloto al mando',
		horasVooTripulacao: 'Horas de Vuelo Tripulación',
		horasVooUsuarioOvn: 'Horas de vuelo con gafas de visión nocturna',
		horimetro: 'Horímetro',
		horimetroCelula: 'Contador de horas de celda',
		horimetroFinal: 'Hor. Final',
		horimetroFinalCelula: 'Hor. Final Célula',
		horimetroFinalManutencao: 'Mmm. Mantenimiento Final',
		horimetroFinalMotor: 'Contador horario final del motor',
		horimetroInicial: 'Hor. Inicial',
		horimetroInicialCelula: 'Hor. Inicio Célula',
		horimetroInicialManutencao: 'Mmm. Mantenimiento inicial',
		horimetroInicialMotor: 'Horímetro final del motor',
		horimetroInicialOvn: 'Horas de uso de las gafas de visíon nocturna',
		horimetroManutencao: 'Mantenimiento del horómetro',
		horimetroMotor: 'Contador de horas del motor',
		horimetroProximaInspecao: 'Contador de horas próxima inspección',
		horimetroUltimaInspecao: 'Contador de horas de última inspección',
		houveAbastecimento: 'Hubo Abastecimento?',
		houveAcidenteAnimalPeconhento: '¿Ha habido algún accidente causado por un animal venenoso?',
		houveAcionamentoDosOrgaos: '¿Hubo acción de los componentes externos del ',
		houveAlijamento: '¿Hubo una emergencia o un vertido involuntario de artículos peligrosos?',
		houveCargaTransportada: '¿Ha habido carga transportada?',
		houveCautelaMateriais: '¿Se cuidó algún material?',
		houveObito: '¿Hubo una muerte?',
		houveRecusaAtendimento: '¿Hubo una negativa de servicio?',
		houveUmErroAoTentarAcessarOSeguinteEnderecoURL: 'Hubo un error al intentar acceder a la siguiente dirección URL',
		houveUmErroAoTentarSalvar: 'Hubo un error al intentar guardar',
		ibfInstalado: '¿FIB instalado?',
		icone: 'Icono',
		id: 'Id',
		idade: 'Edad',
		idadeAparente: 'Edad Aparente',
		identificacaoVoo: 'Identificación del vuelo',
		ifrSimulado: 'IFR simulado',
		imagem: 'Imagen',
		imagensCadastradas: 'Imágenes registradas',
		importar: 'Importar',
		importarLayer: 'Importar capa',
		imprimir: 'Imprimir',
		imprimirEtiqueta: 'Imprimir la Etiqueta',
		imprimirPDF: 'Imprimir el PDF',
		imprimirRequisicao: 'Solicitud de impresión',
		imprimirTickets: 'Imprimir Entradas',
		improvavel: 'Improbable',
		inaceitavel: 'Inaceptable en las circunstancias actuales',
		inativo: 'Inactivo',
		incidenciaFatores: 'Incidencia de factores contribuyentes.',
		incisoss: 'TEMA XIII AL XVII',
		incluir: 'Incluir',
		incluirLer: 'Incluir + Leer',
		inclusao: 'Inclusión',
		inclusaoAnalise: 'Análisis inicial del evento',
		inclusaoAnexar: 'Adjuntar archivos',
		inclusaoApreciacaoDevem: 'La inclusión y el aprecio deben ser completos.',
		inclusaoDescricao: 'Descripción del evento de seguridad operativa',
		inclusaoDeve: 'La inclusión debe completarse.',
		inclusaoInformacao: 'Información adicional',
		inclusaoRecomendacoes: 'Opinión y recomendaciones',
		inclusaoSalva: 'Inclusión guardada exitosamente',
		indeterminada: 'Indeterminado',
		indicador: 'Indicator',
		indicadorAno: 'Indicador anual',
		indicadorMes: 'Indicador Mes',
		indiceDocumento: 'Índice por Tipo Documento',
		indiceNomeDocumento: 'Índice de documentos',
		indicePorDocumento: 'Índice por nombre',
		indisponibilidadeAeronave: 'Indisponibilidade de aeronave',
		indisponibilidadeEfetivo: 'Indisponibilidad de efectivo',
		indisponibilizarAeronave: 'Indisponibilizar Aeronave',
		indisponivel: 'Indisponible',
		info: 'Información',
		infoHorasOvn: 'Rellene este campo con el total de horas de vuelo que ya ha realizado utilizando las gafas de visión nocturna. Después de completar esto el sistema agregará automáticamente este valor inicial a las horas de vuelo en el libro de registro',
		infoOrdemDeMissao: 'Misión Solicitar Información',
		informacaoDiarioMecanico: 'Utilice filtros para optimizar la carga de fragmentos. Períodos de tiempo muy largos y una gran cantidad de aviones pueden hacer que la página se ralentice.',
		informacaoDoPonto: 'Información del punto',
		informacaovoo: 'Información de vuelo',
		informacoesAdicionais: 'información adicional',
		informacoesAdicionaisProduto: 'Información adicional del producto',
		informacoesConfiguracaoNotificacao: 'Antes de completar esta pantalla, debes registrar todas las preguntas.',
		informacoesDiasSemana: 'Después de 1 semana de la primera notificación, el sistema notificará diariamente al usuario pendiente.',
		informacoesIniciais: 'Información inicial',
		informacoesQuestionarioFadiga: 'Antes de completar esta pantalla, debe registrar todas las preguntas.',
		informacoesRenovacao: 'Información de renovación',
		inicial: 'Inicial',
		inicio: 'Inicio',
		inicioAtividade: 'inicio de actividad',
		inicioCargaOpcao: '0',
		inicioDaOrdem: 'Inicio de la orden',
		inicioDoMesReferencia: 'inicio del mes de referencia',
		inicioJornada: 'inicio del viaje',
		inicioOrdem: 'Início da Ordem',
		inicioRepouso: 'Descanso en casa',
		inicioSBH: 'Inicio SBH',
		inicioValidade: 'Inicio de vigencia de la póliza',
		inicioVigencia: 'Inicio del trimestre',
		inpecoesAssinadas: 'Inspección(es) firmada(s).',
		inscricao: 'Inscripción',
		inseridoManualmentePor: 'Inserido manualmente por',
		inseridoPor: 'Inserido por:',
		inseridoSucesso: 'insertado exitosamente',
		insignificante: 'Insignificante',
		insiraCaso: 'o ingresa uno si no tienes uno',
		inspecao: 'Inspección',
		inspecaoAdicionadaComSucesso: 'Inspección agregada con éxito',
		inspecaoAtiva: 'Inspección Activa',
		inspecaoDesativada: 'Inspección deshabilitada',
		inspecaoEmMeses: 'Próxima inspección en meses',
		inspecaoExcluidaComSucesso: 'Inspección eliminada correctamente',
		inspecaoListadas: 'Las inspecciones enumeradas no contienen componentes vinculados al mismo.',
		inspecaoVinculada: 'Inspección vinculada',
		inspecoes: 'Inspecciones',
		inspecoesAgrupadasPorLimite: 'Inspecciones agrupadas por límite',
		inspecoesDisponibilidades: 'Inspecciones y Disponibilidad',
		inspecoesMandatorias: 'Inspecciones obligatorias',
		inspecoesNaoMandatorias: 'Inspecciones no obligatorias',
		inspetor: 'Inspector',
		inspetorResponsavel: 'Inspector Responsable',
		instalacao: 'Instalación',
		instalar: 'Instalar',
		instrucao: 'Instrucción',
		instrumentos: 'Instrumentos',
		instrutor: 'Entrenador',
		instrutorVoo: 'Instructor de Vuelo',
		instruçãoDemissao: 'MISSION INSTRUCCIÓN',
		interacaoSalva: 'Interacción guardada',
		intercambialidade: 'Intercambiabilidad',
		intercambialidades: 'Intercambialidad',
		intercambiaveisAdicionadas: 'Intercambiables agregados',
		interno: 'Interno',
		intervalo: 'Intervalo',
		intervaloRastreamento: 'Intervalo de seguimiento',
		intervaloRastreamentoHint: 'Tiempo mínimo entre el seguimiento de una posición y la siguiente.',
		intervaloServico: 'Intervalo de Servicio',
		intervencao: 'Intervención',
		intoxicacao: 'Intoxicación',
		inverter: 'Reverso',
		irParaA: 'Ir a',
		irParaHoje: 'Ir a hoy',
		irParaO: 'IR PARA EL',
		irParaOrdemDeMissao: 'Ir a la orden de misión',
		irParaOrdemServico: 'Para ir a trabajar',
		isocoricas: 'isocórico',
		item: 'artículo',
		itemAtualizado: 'Elemento actualizado',
		itemJaAdicionado: 'Elemento ya agregado',
		itemNoGo: 'Item No-Go',
		itens: 'Elementos',
		itensComOEstadoDefeituosoOuDescarteNaoEstaoDisponiveisParaEntrega: 'Los artículos DEFECTUOSOS o DESECHADOS no están disponibles para entrega',
		itensIntercambiaveis: 'Elementos intercambiables',
		itensParaAeronave: 'Artículos de aviones',
		jaAssinados: 'Ya firmado',
		jaExiste: 'Ya existe.',
		jantar: 'Cena',
		jivochat: 'Jivochat',
		jornadaDeTrabalho: 'Horas de trabajo',
		jornadaMensal: 'Viaje mensual',
		jornadaSemanal: 'Viajes semanales',
		jornadaTrabalho: 'jornada laboral',
		jornadaTrabalhoCumprida: 'Viaje de trabajo completado',
		juntadoTrechos: 'Juntando Tramos',
		justificativa: 'Justificación',
		justificativaInspecao: 'esta inspección se requiere una justificación',
		kitComissaria: 'Kit de Comisaría',
		kmAtual: 'Km Actual',
		kmVoado: 'Km Volados',
		labelQuantidadeCaracteres: 'Número de caracteres restantes',
		largura: 'Ancho',
		lat: 'lat',
		latInicio: 'Lat Start',
		latitude: 'Latitud',
		latitudeFinal: 'Latitud Final',
		latitudeInicial: 'Latitud Inicial',
		lavagemCompressor: 'Lavado de compresores',
		layer: 'Capa',
		layerAtualizadoSucesso: '¡Capa actualizada con éxito!',
		layerCadastradoSucesso: '¡Capa registrada con éxito!',
		layerExcluidoSucesso: '¡Capa eliminada correctamente!',
		legenda: 'subtitular',
		legislacao: 'Legislación',
		lei: 'Ley',
		leiAeronauta: 'Ley de Aeronautas',
		leiaAOrdem: 'Lea su orden y al final haga clic en ACTUALIZAR ORDEN.',
		leiaQRCode: 'Lea el QR Code a través del Followair en su teléfono.',
		leiaSuaSolicitacao: 'Lea su solicitud y al final haga clic en ENVIAR SOLICITUD.',
		leitores: 'Lectores',
		leituraConfirmada: 'Lectura Confirmada',
		leituraExcluida: 'Lectura Obligatoria eliminada.',
		leituraObrigatoria: 'Lectura Obligatoria',
		leituraObrigatoriaUsuario: 'Lectura obligatória para el usuario actual',
		lembreteExclusaoAnexo: 'Atención',
		ler: 'Leer',
		letra: 'Carta',
		lgpd: 'LGPD y Política de Privacidad',
		lgpdPoliticaPrivacidade: 'Política de Privacidad y LGPD',
		lgpdTermo: '0',
		liberadoParaConhecimentoGeral: 'Publicado para conocimientos generales',
		libras: 'Libras',
		licenca: 'Licencia',
		licencaExcluida: 'Licencia eliminada',
		licencasHabilitacoesRegistros: 'Licencias calificaciones y registros',
		licencasHabilitacoesTreinamentos: 'Licencias calificaciones y entrenamientos',
		lido: 'Leído',
		lidoPor: 'Leído por',
		limite: 'Límite',
		limiteReferencia: 'Límite de referencia',
		limitesContratuais: 'Límites del contrato',
		limpaTudas: 'Borrar todas',
		limpar: 'Limpar',
		limparFiltro: 'Borrar filtro',
		limparSelecao: 'Borrar Selección',
		linhaContrato: 'Línea de contrato',
		linhaDoContrato: 'Línea de contrato',
		linkAPP: 'Aplicación de enlace',
		linkBD: 'Enlace de base de datos',
		linkTrello: 'Enlace a Trello',
		linkWS: 'Enlace WS',
		links: 'Enlaces',
		liquida: 'Líquida',
		lista: 'lista',
		listaContratosNaoOcultos: 'Esta lista se refiere a contratos no ocultos',
		listaContratosOcultos: 'Essa lista se refiere a contratos ocultos',
		listaDePerfis: 'Lista de Perfiles',
		listaNFS: 'Lista de NFe',
		listarEscala: 'Escala de lista',
		listarNovosUsuarios: 'Listar Nuevos Usuarios',
		litros: 'Litros',
		litrosProcessados: 'Litros procesados',
		lng: 'lng',
		local: 'Lugar',
		localDeNascimento: 'Lugar de Nacimiento',
		localInstalar: 'Ubicación a instalar',
		localidade: 'Ubicación',
		localisacaoPorao: 'Ubicación del sótano',
		localizacao: 'Ubicación',
		logAcessos: 'Registro de acceso',
		logProcessamento: 'Registro de Procesamiento',
		login: 'Iniciar sesión',
		loginAs: 'Inicio de sesión realizado en',
		loginComoLogin: 'El INICIO DE SESIÓN registrado se utilizará como CONTRASEÑA que deberá cambiarse al acceder por primera vez al sistema.',
		loginsHoje: 'Inicios de sesión para hoy',
		logitudeFinal: 'Longitud Final',
		logitudeInicial: 'Longitud Inicial',
		logo: 'Logotipo del cliente',
		logradouro: 'Dirección',
		longInicio: 'Inicio largo',
		longitude: 'Longitud',
		lotacao: 'Capacidad',
		lote: 'Lote',
		maintenanceStatus: 'Mapa',
		maior: 'Más grande',
		maiorValor: 'Mayor que el valor.',
		maisDeumDespacho: 'Encontramos más de un despacho para esa aeronave seleccione qué despacho ese vuelo se refiere.',
		maisDeumItem: 'más de un artículo',
		maisDias: 'mas dias',
		maisInformacoes: 'Mas informaciones',
		maisInformacoesRenovacao: '+ Información de Renovación',
		malha: 'Malla',
		malhaAnual: 'Malla anual',
		malhaSemanal: 'Malla semanal',
		malhaVoo: 'malla de vuelo',
		malhas: 'Prendas de punto',
		manuais: 'Manuales',
		manual: 'Manual',
		manualOnline: 'Manual en Linea',
		manutencao: 'Mantenimiento',
		manutencaoAeronave: 'Mantenimiento de aeronave',
		manutencaoAtrasada: 'Mantenimiento retrasado',
		manutencaoCamp: 'Mantenimiento del campamento',
		manutencaoCiencia: 'Modelo de mantenimiento en la ciencia',
		manutencaoDeuParecer: 'Tiene el parecer del mantenimiento',
		manutencaoNaoDeuParecer: 'El mantenimiento no ha dador',
		manutencoes: 'Mantenimiento',
		mapa: 'Mapa',
		marcaDagua: 'Marca de agua',
		marcaOuModelo: 'Marca / Modelo',
		marcadores: 'Markers',
		marcarTodos: 'Seleccionar todo',
		margem: 'margen',
		margemTelaLogin: 'Margen de la pantalla de inicio de sesión en píxeles',
		marqueOsTrechosQueACargaIra: ' Marcar los tramos que recorrerá el pasajero',
		marqueOsTrechosQueOPassageiroIra: 'Elija los tramos que viajará el pasajero:',
		masc: 'Masculino',
		masculino: 'Masculino',
		materiaEncerrada: 'Materia cerrada por',
		materiaisMedicamentos: 'Materiales y medicamentos',
		materialDeixado: 'Material restante',
		materias: 'Materias',
		matricula: 'Matrícula',
		matriculaProntos: 'Listo para registrarse',
		matriculado: 'Matriculado',
		maximo: 'Máximo',
		mao: 'Mão',
		mecanico: 'Mecánico',
		mecanicoResponsavel: 'Mecánico Responsable',
		mecanicos: 'Mecánico',
		media: 'Promedio',
		mediaCiclos: 'Ciclos promedio',
		mediaHorasDiario: 'Promedio de horas de vuelo diarias',
		mediaHorasMes: 'Promedio de horas mensuales de vuelo',
		mediaManual: 'Promedio manual',
		medicao: 'Medición',
		medico: 'Doctor',
		menor: 'Menor',
		mensagem: 'Mensaje',
		mensagemFaturaAberta: 'Este es un recordatorio de que su factura está abierta. Realiza el pago para evitar inestabilidad en el sistema FollowAir. En caso de duda póngase en contacto con el sector financiero. Si ya se ha realizado el pago ignore este mensaje',
		mes: 'Mes',
		mesAtual: 'Més Actual',
		meses: 'Meses',
		mesesDias: 'Meses y Días',
		mesmoDbMovimentacoes: 'Estos libros de registro a continuación se encontraron para este número EC y este avión. el libro de registro referente al movimiento es Seleccionar',
		mesmoMovimentacoesDb: 'Estos movimientos de combustible a continuación se encontraron para este número EC y este avión. Seleccione el movimiento de combustible para este libro de registro',
		messagemInputError: 'Valor no Válido!',
		meta: 'Meta',
		metaAno: 'Meta Anual',
		metaHoras: 'Meta Horas',
		metaIndicadores: 'Meta e indicadores',
		metaMes: 'Meta Mes',
		metabolico: 'Metabólico',
		metricas: 'Métricas',
		midriaticas: 'midriáticos',
		milhas: 'Milhas',
		milhasNauticas: 'Milhas Náuticas',
		milhasNavegacao: 'Millas de navegación',
		milhasNavegacaoTexto: 'Os vuelos de navegación son aquellos que se realizan en un radio de 27 minutos (50 km) desde el aeródromo de salida. En el caso de un vuelo de navegación, tal y como se ha definido anteriormente, este campo debe rellenarse con la distancia (en mis rutas náuticas) entre los aeródromos de origen y destino. En el caso de sobrevuelo o touch and go-around (TGL) en un aeródromo intermedio, se deberá especificar en el campo "Observaciones".',
		minimoAprovacao: 'Mínimo para aprobación',
		minutos: 'Minutos',
		mioticas: 'mióticos',
		missao: 'Misión',
		missaoESigilosa: '¿Es la misión confidencial?',
		missaoSigilosa: 'misión secreta',
		modalErroElementoJaInserido: 'El elemento ya ha sido insertado.',
		modelo: 'Modelo',
		modeloAtualizado: 'Modelo Actualizado',
		modeloDoMapa: 'Modelo del Mapa',
		modeloInserido: 'Modelo Añadido',
		modelos: 'Modelos',
		modelosAtualizados: 'Modelos actualizados',
		modulo: 'Seleccione el módulo que desea acceder',
		moduloManutencao: 'Módulo de mantenimiento',
		modulos: 'Módulos',
		moeda: 'Acuñar',
		monitora: 'Monitora',
		monitorada: 'Monitoreado',
		monitoramento: 'Monitoreo',
		monitoramento1: 'Cuadro de estado',
		monitoramento2: 'Monitoreo',
		mostrarDetalhes: 'Mostrar detalles',
		mostrarItens: 'Mostrar elementos',
		motivacao: 'Motivación',
		motivo: 'Razón',
		motivoApareceraDiario: 'Este motivo figurará en la firma de este libro de registro.',
		motivoDaEdicao: 'Motivo de la edición',
		motivoNaoEmbarcou: 'Razón para no abordar',
		motivoNaoEmbarque: 'Razones de Registro para No Embarcar',
		motivoNaoEmbarqueDesativado: 'Motivo de no embarque discapacitado',
		motivoNaoEmbarqueObs: 'Motivo por el que el pasajero no aborda',
		motivoReassinatura: 'MOTIVO DE LA RESUSCRIPCIÓN',
		motor: 'Motor',
		motorAdicionado: 'Motor Añadido',
		motorAtualizado: 'Motor Actualizado',
		motorEHorario: 'Motor y Horario',
		motorNaoEncontrado: 'No se encontraron motores para este avión.',
		motores: 'motores',
		movimentacao: 'Movimiento',
		movimentacaoCombustivel: 'Manejo de combustible',
		movimentacaoCombustivelAbaixo: 'el movimiento del combustible debajo',
		movimentacaoCombustivelEntreUnidades: 'Movimiento de Combustible entre Unidades',
		movimentacaoCombustivelEntreUnidadesSucesso: 'Movimiento de Combustible entre Unidades Guardado con Éxito',
		movimentacaoCombustivelSalvaSucesso: 'El movimiento de combustible se guardó con éxito',
		movimentacaoDeCombustivelExcluidaComSucesso: 'Movimiento de combustible eliminado con éxito',
		msgPagamentoMaiorPagamento: 'Usted está agregando un valor mayor que la compra.',
		mudancaFuncao: 'Cambio de Función',
		mudarMoeda: 'Cambiar la moneda',
		multicamadasMapa: 'Multicapa en el mapa',
		municipio: 'Ciudad',
		nFicha: 'Número de tarjeta',
		nOrdem: 'N Orden',
		nSolicitacao: 'Nro. de solicitud',
		nacionalidade: 'Nacionalidad',
		nao: 'No',
		naoAprovado: 'No aprobado',
		naoAssinado: 'No firmado',
		naoAssinados: 'No firmados',
		naoCalculado: 'No calculado',
		naoControlado: 'No controlado',
		naoDefinido: 'No definido',
		naoDocumento: 'No hay ningún documento disponible como archivo adjunto',
		naoEPossivelColocarUmValorQueEstaAbaixoDoTotalDeProdutosServicos: 'No es posible colocar un valor por debajo del total de productos/servicios',
		naoEPossivelEscolherUmaQuantidadeMaiorQueADisponivelNoEstoque: 'No es posible elegir una cantidad superior a la disponible en stock',
		naoEPossivelRemoverUmEmpenhoQueHaProdutosServicosVinculados: 'No es posible eliminar un compromiso de que hay productos/servicios vinculados',
		naoEncontramosSuaAero: 'No encontramos esa aeronave dentro de la orden de misión si quería importar los datos de la aeronave de la orden de misión basta con hacer clic en el modelo abajo.',
		naoExecutado: 'Sin ejecutar',
		naoExisteAtividadeAnteriror: 'No hay actividad registrada previamente',
		naoExisteAtividadeCadastrada: 'no hay actividad registrada para este día.',
		naoExisteDespachoAvulso: 'No se encontró un solo horario de vuelo',
		naoExisteFatoresContribuintesParaOObjetoEscolhido: 'No hay factores que contribuyan al objeto elegido',
		naoExisteNenhumParecerParaEsteRelatorio: 'No hay opinión para este informe.',
		naoExisteTrechoAeroOm: 'No hay secciones vinculadas a este avión en la Orden de Misión.',
		naoFoiPossivelAlterarSenha: 'No se pudo cambiar la contraseña.',
		naoFoiPossivelAssinar: 'No se pudo suscribir',
		naoFoiPossivelAssinarOS: 'No se puede firmar la Orden de Servicio',
		naoFoiPossivelCadastrarUsuario: 'No se puede registrar el usuario',
		naoFoiPossivelCancelar: 'No se puede cancelar',
		naoFoiPossivelEncontrarDados: 'No se ha encontrado ningún dato a través de este login.',
		naoFoiPossivelEnviarSuprimentos: 'No se pueden enviar suministros',
		naoFoiPossivelExcluir: 'Incapaz de borrar',
		naoFoiPossivelGerarRelatorio: 'No se pudo Generar Informe',
		naoFotorreagentes: 'No fotorreactantes',
		naoHaAeronaves: 'No hay aviones',
		naoHaCarga: 'No hay carga',
		naoHaDiariosDeBordo: 'No hay libros de registro abiertos libros de registro sin firmar',
		naoHaDiscrepancia: 'No hay discrepancias',
		naoHaEmpregoAeronave: 'No hay empleo de aeronave',
		naoHaNenhumVoo: 'NO HAY VUELOS ESPECIALES REGISTRADOS',
		naoHaNenhumaTarefaCadastrada: 'No hay tarea registrada',
		naoHaNovoTripulante: 'No hay ningún nuevo miembro de la tripulación.',
		naoHaRoteiro: 'No hay guía',
		naoHaTripulacao: 'no hay tripulacion',
		naoHaViolacao: 'No hay violación de la ley de aeronáuticos.',
		naoInformado: 'No informado',
		naoLido: 'No leído',
		naoNecessarioImprimirRelprev: 'No es necesario imprimir RELPREV',
		naoPossivelExcluirUnidadeMedidaSuprimentosLigados: 'No puede eliminar una unidad de medida con suministros adjuntos',
		naoPossui: 'NO TENGO',
		naoPossuiEntregas: 'Sin entregas',
		naoSaiaDessaTela: 'No salga de esa pantalla esto interrumpirá el proceso.',
		naoSatisfeito: 'NO SATISFACE',
		naoSelecionouData: 'No ha seleccionado una fecha.',
		naoTemManutencao: 'Sin mantenimiento',
		naoTemParecerManutencao: 'No tiene el parecer del mantenimiento',
		naoTemParecerOperacoes: 'No tiene el parecer de las operaciones',
		naoTenhoUmAerodromoDefinido: 'No tengo un aeródromo definido.',
		nascer: 'Salida',
		nascidoVivo: 'Nacido vivo',
		naturalidade: 'Naturalidad',
		natureza: 'Naturaleza',
		naturezaDoVoo: 'Naturaleza del Vuelo',
		naturezas: 'Naturalezas',
		navegacao: 'Navegación',
		necessarioAdicionarPeloMenosUmItemAoPN: 'Necesario agregar al menos un elemento al PN',
		necessarioDataInicio: 'Es necesario tener rellenada la fecha de inicio de la actividad para buscar el último viaje deseado',
		necessarioPeloMenosUmaInspecao: 'Se requiere al menos una inspección para actualizar',
		negada: 'Denegado',
		negar: 'negar',
		negativo: 'Negativo',
		nenhum: 'Ninguno',
		nenhumAlertaEncontrado: 'NO SE ENCONTRARON ALERTAS',
		nenhumArquivo: 'No hay archivos adjuntos',
		nenhumArquivoAnexado: 'No hay archivos adjuntos',
		nenhumDadoEncontrado: 'Ningún dato encontrado para esa fecha.',
		nenhumDespacho: 'No encontramos ningún despacho para esa aeronave seleccione uno en la lista o introduzca un despacho.',
		nenhumDespachoParaEssesDias: 'Ninguno Despacho para estos días',
		nenhumDiarioDeBordoEncontrado: 'NO SE ENCONTRÓ LIBRO DE REGISTRO EN ESTE PERIODO',
		nenhumDiarioDisponivelParaAssinatura: 'Ningún diario de a bordo disponible para la firma.',
		nenhumHistoricoEncontrado: 'ningún historial encontrado.',
		nenhumItemEncontrado: 'No se encontraron artículos',
		nenhumMotorAcionado: 'Ningún motor accionado',
		nenhumParametroLegalCadastrado: 'No hay parámetros legales registrados',
		nenhumProdutoFoiAdicionado: 'No se agregaron productos',
		nenhumRegistroEncontrado: 'No se encontraron registros',
		nenhumResultadoFoiEncontrado: 'No se han encontrado resultados',
		nehumTermoEncontrado: 'Ningún término encontrado.',
		nenhumTrecho: 'NO HAY EXTRACTO',
		nenhumTrechoAdicionado: 'No se agregaron extractos',
		nenhumValorRegistrado: 'Ningún valor registrado',
		nenhumVooEncontrado: 'Ningún vuelo fue encontrado.',
		nenhumaAcao: 'Ninguna acción',
		nenhumaAcaoFoiTomadaDiscrepancia: 'Ninguna acción fue tomada para esa discrepancia.',
		nenhumaAeronaveAdicionada: 'No se agregó ningún avión',
		nenhumaAlteracao: 'No se guardarán los cambios realizados en el diario. Para ello, debe hacer clic en editar diario.',
		nenhumaAtividadeCadastrada: 'No hay actividades registradas',
		nenhumaConversaEncontrada: 'Ninguna conversación encontrada.',
		nenhumaDiscrepanciaAberta: 'Ninguna discrepancia abierta.',
		nenhumaDiscrepanciaEncontrada: 'Ninguna discrepancia encontrada',
		nenhumaDisponibilidadeEncontrada: 'No se encontró disponibilidad.',
		nenhumaDocumentacaoAdicionada: 'Ninguna Documentación agregada',
		nenhumaEscalaEncontrada: 'No se encontró ninguna escala',
		nenhumaImagemCadastrada: 'No hay imagen registrada',
		nenhumaInformacaoEncontrada: 'Nenhuma Informação Encontrada',
		nenhumaInspecaoEncontrada: 'No se encontró ninguna inspección',
		nenhumaMalha: 'NO HAY MALLA REGISTRADA',
		nenhumaNotificacao: 'Usted no tiene ninguna notificación',
		nenhumaNotificacaoEncontrada: 'Ninguna notificación encontrada',
		nenhumaObservacao: 'No se agregaron comentarios',
		nenhumaOrdemFoiEncontrada: 'No se ha encontrado ninguna solicitud.',
		nenhumaOrdemParaEssesDias: 'Ninguna orden para estos días',
		nenhumaPosicaoEncontrada: 'Ninguna posición encontrada',
		nenhumaRegistroFichaEncontrado: 'No record of Service Form found in the Period',
		nenhumaRessalvaAdicionada: 'Ninguna Reserva Agregada',
		nenhumaSolicitacaoEmAberto: 'Ningúna solicitación en abierto',
		nenhumaSolicitacaoParaEssesDias: 'Ninguna Solicitud para estos días',
		nenhumaTripulacaoAdicionada: 'No se agregó tripulación',
		neurologico: 'neurológico',
		nice: 'BIEN',
		nivel: 'Nível',
		nivelDeAprendizagem: 'Nivel de Aprendizaje',
		noLlenado: 'NO LLENADO',
		noMes: 'en el mes',
		nome: 'Nombre',
		nomeAdicionado: 'Nombre añadido',
		nomeAlternativo: 'Nombre alternativo',
		nomeCompleto: 'Nombre Completo',
		nomeContato: 'Nombre de Contacto',
		nomeDaCategoria: 'Nombre de categoría',
		nomeDaUnidade: 'Nombre de la Unidad',
		nomeDoVoo: 'Nombre del vuelo',
		nomeDocumentoJaExistente: 'Este nombre de documento ya existe',
		nomeESobrenomealuno: 'NOMBRE Y ÚLTIMO NOMBRE',
		nomeESobrenomeinstrutor: 'NOMBRE Y APELLIDO DEL INSTRUCTOR',
		nomeModelo: 'Nombre del modelo',
		nomePasta: 'Nombre de carpeta',
		nomePrincipal: 'Nombre principal',
		nomeRelacaoCombusivel: 'Al definir la relación de combustible, esta información se completará automáticamente en el Libro de registro del piloto.',
		nomeSocial: 'Nombre social',
		nomeTipoDocumentoJaExistente: 'Este nombre de tipo de documento ya existe',
		nomeTratamento: 'Nombre de tratamiento',
		nomeTreinamento: 'Nombre del entrenamiento',
		nomeclaturaComumMercosul: 'Nomenclatura Común del Mercosur',
		nomeclaturaOleoLubrificante: 'Informar las nomenclaturas que se mostrarán en los Libros de Registro si hay control de aceite lubricante',
		nomenclatura: 'Nomenclatura',
		nomesAlternativos: 'Nombres Alternativos',
		normas: 'Normas',
		nos: 'nudos',
		nota: 'Aviso',
		notaCadastradaSistema: 'Nota Registrada en el Sistema',
		notaFiscal: 'Nota Fiscal',
		notasAtualizacao: 'Notas de actualización',
		notasDaVersao: 'Notas de lanzamiento',
		notificaTripulacao: 'Notificar a la tripulación ',
		notificacao: 'NOTIFICACIONES',
		notificacaoAtualizada: 'Notificación actualizada',
		notificacaoEncontrada: 'notificaciones encontradas',
		notificacaoVencimentoDias: 'Notificación de vencimiento (días)',
		notificacoesEnviadas: 'Notificaciones enviadas',
		notificadoComSucesso: 'Notificado con éxito',
		notificar: 'Notificar',
		notificarResponsavel: 'Notificar Responsable',
		notificarTodos: 'Notificar a todos',
		noturno: 'Noturno',
		nova: 'Nueva',
		novaAcao: 'Nueva Acción',
		novaAssinatura: 'Nueva suscripción',
		novaCategoria: 'Nueva Categoría',
		novaComunicacao: 'Nueva Comunicación',
		novaDisciplina: 'Nueva Disciplina',
		novaDiscrepancia: 'Nueva Discrepancia',
		novaDocumentacao: 'Nueva Documentacion',
		novaFerramenta: 'Nueva herramienta',
		novaFicha: 'Nuevo récord',
		novaHabilitacao: 'Nueva licencia',
		novaInteracao: ' Nueva interacción',
		novaMalha: 'Malla nueva',
		novaNota: 'Nueva ENF',
		novaObservacao: 'Nueva observación',
		novaPrestacao: 'NUEVA PRESTACIÓN DE SERVICIOS',
		novaSenha: 'Nueva contraseña',
		novo: 'Nuevo',
		novoAcionamento: 'Nuevo Accionamiento',
		novoCapitulo: 'Nuevo Capítulo',
		novoContato: 'Nuevo contacto',
		novoDespacho: 'Nuevo Despacho',
		novoDocumento: 'Nuevo documento',
		novoFornecedor: 'Nuevo Proveedor',
		novoKit: 'Nuevo Kit',
		novoLayer: 'Nueva capa',
		novoMotor: 'Nuevo Motor',
		novoParametro: 'Nuevo parámetro',
		novoPonto: 'Nuevo punto',
		novoProcedimento: 'Nuevo Procedimiento',
		novoRelatorio: 'Nuevo Informe',
		novoSimplificado: 'Nuevo Simplificado',
		novoTicket: 'Nuevo billete',
		novoTipo: 'Nuevo tipo',
		novoTrecho: 'Nuevo tramo',
		novoUsuario: 'Nuevo usuario',
		numAtividade: 'Nro. Actividad',
		numChamada: 'Nro. Llamada',
		numMotores: 'Número de motores',
		numReds: 'Nro. REDS',
		numSiape: 'Número de SIAPE',
		numberMotor: 'Nº Serie del motor',
		numero: 'Número',
		numeroCarne: 'Número de Carne',
		numeroCe: 'Número CE',
		numeroCodigo: 'Número de código',
		numeroDB: 'Número DB',
		numeroDaCE: 'número CE',
		numeroDaFatura: 'Número de factura',
		numeroDaNota: 'número NFe',
		numeroDaOrdem: 'Número de orden',
		numeroDaProgramacao: 'Número de horario',
		numeroDeCE: 'Número CE',
		numeroDeReprovacoes: 'Número de rechazos',
		numeroDeVoo: 'Número de vuelo',
		numeroDiario: 'Número de Diario',
		numeroDoCe: 'Número de recibo de entrega',
		numeroDoContrato: 'Número de contrato',
		numeroDoDespacho: 'Nº del despacho',
		numeroDoDiarioDeBordo: 'Número del libro de registro',
		numeroDoEmpenho: 'Número de compromiso',
		numeroDoPedido: 'Número de orden',
		numeroIdentificacaoEmpregado: 'CNPJ',
		numeroItem: 'Número de artículo',
		numeroLei: 'Número de ley',
		numeroLicenca: 'Número de Licencia',
		numeroMaximoTripulantes: 'Número máximo de tripulantes',
		numeroOrdemServico: 'Número de orden de servicio',
		numeroPatrimonio: 'Número de Capital',
		numeroPeca: 'Número de Pieza',
		numeroPergunta: 'Número de preguntas',
		numeroPrevencao: 'Número de la Prevención',
		numeroRegistro: 'Número de registro.',
		numeroSolicitacao: 'Número de solicitud',
		numeroTarefa: 'Número de Tareas',
		numeroTicket: ' Número de billete:',
		numeroVoo: 'Número de vuelo',
		oCampoDePassaporteEObrigatorioParaUmEstrangeiro: 'El campo del pasaporte es obligatorio para un extranjero',
		oEventoFoiAtualizadoComSucesso: 'El evento se ha actualizado correctamente',
		oEventoFoiCadastradoComSucesso: 'El evento se registró con éxito',
		oHorimetroDeveSerMenorQueOAtual: 'El contador de horas debe ser más pequeño que la corriente',
		oKitDeveConterUmItem: 'El kit debe contener un mínimo de 1 elemento',
		oPrimeiroAssina: 'El tripulante insertado en el primer casillero será el responsable de firmar el Logbook',
		oQueEstaAcontecendo: ' ¿Lo que está sucediendo?',
		oRelatorioFoiAtualizadoComSucesso: 'El informe se actualizó correctamente',
		oRelatorioFoiSalvoComSucesso: 'El informe se guardó correctamente',
		oResultadoPodeDemorarUmPouco: 'el resultado puede tardar un poco.',
		oTipoDeSolicitacaoFoiAtualizadoComSucesso: 'El tipo de solicitud se actualizó correctamente',
		oTipoDeSolicitacaoFoiExcluidoComSucesso: 'El tipo de solicitud se eliminó correctamente',
		oTipoDeSolicitacaoFoiSalvoComSucesso: 'El tipo de solicitud se guardó correctamente',
		oTrechoEstaAberto: 'El Tramo de <strong>{{INICIO}}</strong> está abierto y necesita ser llenado.',
		oTrechodeInicioTexto: 'El tramo de inicio <strong>{{TRECHO}}</strong> del día <strong>{{INICIO}}</strong> está abierto y necesita ser llenado.',
		oUsuarioPodeAlterarSuasConfigs: 'El usuario puede editar su configuración?',
		objetivosAlcancados: '¿Se ha alcanzado el objetivo?',
		objetivosMissaoAlcancados: '¿Se alcanzaron los objetivos de la misión?',
		objeto: 'Objeto',
		obrig: 'Requerido',
		obrigInstrutorVoo: 'Obligatorio para el instructor de vuelo',
		obrigPilotoComando: 'Obligatorio para el Piloto en Comando',
		obrigacao: 'Obligatorio',
		obrigatorio: 'Campos con * <b> son obligatorios </b>',
		obs: 'Observación',
		observacao: 'Observación',
		observacaoAsteriscoHoraRastreada: '* Los vuelos marcados * en la columna rastreada aún no han sido firmados ni ratificados por el piloto. En este caso se calcula el tiempo desde la activación hasta la parada de la aeronave.',
		observacaoCalculoHoraRastreada: '0',
		observacoes: 'Comentarios',
		observacoesImportante: 'Notas importantes',
		observacoesMedicoRegulador: 'Notas para el médico regulador.',
		obstetrico: 'Obstétrico',
		ocasional: 'Ocasional',
		ocorrencias: 'Ocurrencias',
		ocorreuErroTenteNovamente: 'Se produjo un error inténtalo de nuevo',
		ocultar: 'Esconder',
		ocultarContrato: 'Esconder Contrato',
		ocultarContratoConfirmacao: '¿De verdad quieres ocultar este contrato?',
		ocultarContratoNaoVigente: 'Ocultar contratos vencidos',
		oficina: 'Taller',
		oficio: 'Empleo',
		okParaUso: 'Bien para usar?',
		ola: 'Hola',
		oleoLubrificante: 'Aceite Lubricante',
		onde: 'Dónde',
		ondeNoEstoque: 'Donde en stock',
		opcoes: 'Opciones',
		operacao: 'Operación',
		operacional: 'Operacional',
		operacoes: 'Operaciones',
		operacoesDeuParecer: 'Tiene el dictamen de las operaciones',
		operacoesNaoDeuParecer: 'La operación no dio la opinión',
		operador: 'Operador',
		operadorAerotatico: 'Operador Aerotático',
		operadorIndefinido: 'El operador no se ha definido',
		ordemCancelada: 'Orden cancelada',
		ordemDeMissao: 'Orden de Misión',
		ordemDeMissaoSalva: 'Orden de Misión Salva',
		ordemDeServico: 'Orden de Servicio',
		ordemDeServicoConcluida: 'Orden de Servicio Completado',
		ordemDeServicoSalvaComSucesso: 'La orden de servicio guarda con éxito',
		ordemEncerrada: 'Orden cerrada',
		ordemMissao: 'Órden de Misión',
		ordemMissaoEncerrada: 'Orden de misión cerrada.',
		ordemMissaoPrevencaoQualificada: 'Orden de Misión de Prevención Cualificada',
		ordemMissaoReaberta: 'Ordem de misión reabierta',
		ordemMissaoRetornoExecucao: 'Orden de la misión volvió a Correr',
		ordemMissaoRetornoExecucaoErro: 'No se puede devolver el orden de la misión a Correr',
		ordemServico: 'Orden de servicio',
		ordemServicoCancelada: 'Orden de servicio cancelada',
		ordemServicoManutencao: 'Orden de Servicio de Mantenimiento',
		ordensDeMissao: 'Órdenes de Misión',
		ordensGeradas: 'Pedidos generados',
		organizacao: 'Organización',
		orgao: 'Órgano',
		orgaoApioadoSalvo: 'Orgón apoyado salvo',
		orgaoApoiado: 'Órgano Apoyado',
		orgaoApoiadoAtualizado: 'Orgánico apoyado actualizado',
		orgaoApoiadoAtualizadoComSucesso: 'Órgano Compatible actualizado con éxito.',
		orgaoApoiadoUnidades: 'Órganos Compatibles - Unidades',
		orgaoOperador: 'Órgano Operador',
		orgaoProprietario: 'Orgánico Propietario',
		orgaoSolicitante: 'Agencia solicitante',
		orgaoUtilizam: 'Agencias que utilizan la aeronave',
		orgaos: 'Órganos',
		orgaosApoiados: 'Órganos apoyados',
		orgaosApoiadosDesativados: 'Órgano soportado desactivado',
		origem: 'Fuente',
		origemDoVoo: 'Origen del vuelo',
		origemSistema: 'Documento original del sistema',
		osArquivosNãoPodemSerMaiorQue: 'Los archivos no pueden ser más grandes que',
		osDeSaida: 'SO de destino',
		osTrechosPrecisamSerSeqquencial: 'Los extractos seleccionados deben ser secuenciales.',
		osUltimos: 'los ultimos',
		ou: 'O',
		outras: 'Otros',
		outrasClassificacao: 'otros',
		outrasPatologia: 'Otras patologías',
		outro: 'Otro',
		outros: 'Otro',
		outrosMateriais: 'Otros Materiales',
		outrosAchados: 'Otros hallazgos',
		paSistolico: 'PA sistólica',
		paciente: 'paciente',
		pacientesAtendidosComSoro: 'Pacientes tratados con suero antiveneno',
		pacote: 'Paquete',
		padrao: 'Estándar',
		padraoProcedimento: 'Funcionamiento estándar',
		pagamento: 'PAGO',
		pagamentoDetalhes: 'Pago',
		pagamentoFeitoSucesso: 'Pago agregado con éxito',
		pagamentoNaoEfetuado: 'Ningún pago efectuado.',
		pago: 'Pagado',
		pais: 'Pais',
		pancreas: 'Páncreas',
		para: 'para',
		paraAddObrigatorio: 'Para este nuevo campo es obligatorio.',
		paraAdicionarEmpenhos: 'Para agregar compromisos',
		paraAdicionarTarefasVocePrecisaTerPeloMenosUmaInspecao: 'Para agregar tareas debe tener al menos una inspección',
		paraAdicionarUmTripulante: 'Para añadir un tripulante, seleccione el tripulante y haga clic en AÑADIR',
		paraBase: 'para la base',
		paraRemoverEsteGrupoVocePrecisaRemoverTodasTarefasLigadaAEle: 'Para eliminar este grupo debe eliminar todas las tareas conectadas a él',
		paraTodosOsArquivos: 'para todos los archivos',
		parametro: 'Parámetro',
		parametroLeiAeronauta: 'Parámetro de la ley aeronáutica',
		parametrosAeronave: 'Parámetros de la Aeronave',
		parametrosCalculoOsCiclosAeronave: 'Parámetros para calcular los ciclos de la aeronave',
		parametrosLegais: 'Parámetros Legales',
		parametrosMidia: 'Parámetros y promedios',
		parcela: 'Parcela',
		parcelas: 'Las parcelas',
		parciais: 'Parcial',
		parcial: 'Parcial',
		parcialmentePago: 'Pagado parcialmente',
		parecer: 'Opinion',
		parecerAdicionadoComSucesso: 'Opinión agregada correctamente',
		parecerFinal: 'Opinión final',
		parecerRecomendacoes: 'Opinión y recomendaciones presentadas en la inclusión.',
		pareceres: 'Opiniones',
		partida: 'Salida',
		partidas: 'Salidas',
		partoNatural: 'parto natural',
		passageiro: 'Pasajero',
		passageiroAtualizadoComSucesso: 'Passageiro atualizado com sucesso',
		passageiroExcluidoComSucesso: 'Pasajero eliminado con éxito',
		passageiroSalvoComSucesso: 'Pasajero guardado con éxito',
		passageiros: 'Pasajeros',
		passageirosDaAeronave: 'Pasajeros de la aeronave',
		passaporte: 'Pasaporte',
		passouTolerancia: 'Pasó de la tolerancia',
		patrimonial: 'Patrimonial',
		patrimonio: 'Herencia',
		pecaAlugadaEmprestada: '¿Es una parte alquilada/prestada?',
		pediatrico: 'Pediátrico',
		pedidoCanceladoComSucesso: 'Pedido cancelado con éxito',
		pedirPecas: 'Ordenar piezas',
		peloMenosUmContato: 'Debe agregar al menos un contacto',
		peloMenosUmTelefone: 'Debe agregar al menos un número de teléfono',
		peloUsuario: 'por el usuario',
		pendentePagamento: 'Pendiente Pago',
		percentualRastreado: 'Porcentaje rastreado',
		percentualRastreamento: 'Porcentaje mínimo de seguimiento',
		percentualRestante: 'Porcentaje restante',
		percursoASerEfetuado: 'Recorrido a efectuar',
		perfil: 'Perfil',
		perfilDoUsuario: 'Perfil del usuario',
		perfilTipo: 'Tipo de perfil',
		perfilTripulacao: 'Perfil de la tripulación',
		perfis: 'Perfiles',
		pergunta: 'Pregunta',
		perguntaParaExclusaoHint: 'No es posible editar preguntas ya utilizadas en la prueba. Sólo eliminación.',
		perguntaSolicitacaoAprovada: '¿Se aprueba esta solicitud?',
		perguntasERespostas: 'Preguntas y respuestas',
		perguntasSelecionadas: 'Preguntas seleccionadas',
		perguntasSelecionadasHint: 'Definir el número de preguntas que utilizará el sistema para estructurar la capacitación.',
		perigosa: 'Peligroso',
		perigoso: 'Peligroso',
		periodicidade: 'Periodicidad',
		periodicidadeHintTreinamento: 'El campo Duración se vuelve obligatorio al completar este campo.',
		periodo: 'Período',
		periodoDeTesteAcabou: 'El período de prueba ha terminado',
		periodoEmHoras: 'Periodo (horas)',
		periodoInstalado: 'Período de Instalación',
		permissaoExcluida: 'Permiso eliminado',
		permissaoNegada: 'Permiso rechazado',
		permiteAlterarOContrato: 'Te permite cambiar el contrato',
		permiteMovimentarOContrato: 'Le permite mover el contrato',
		pernoite: 'Pernoche',
		peso: 'Peso',
		pesoAprox: 'Peso Aprox.(Kg)',
		pesoMaxBagabem: 'Peso máximo de equipaje de mano para los pasajeros',
		pesoMaxCabine: 'Peso máx. de la cabina (KG)',
		pesoBagagemMao: 'Peso del Equipaje de Mano',
		pesoBagagemPorao: 'Peso del Equipaje de Sótano',
		pesoMedio: 'Peso Promedio (Kg)',
		pesoPassageiro: 'Peso del pasajero',
		pesoReal: 'Peso real (kg)',
		pesoTotal: 'Peso total del equipaje',
		pesquisar: 'buscar',
		pesquisarPor: 'Buscar por',
		pessoalEnvolvido: 'Personal involucrado',
		pessoasDetidas: 'Personas detenidas',
		pessoasSalvas: 'Personas Salvas',
		piloto: 'Piloto',
		pilotoComandante: 'PILOTO AL MANDO',
		pilotoComando: 'Piloto en el mando',
		pilotoECopiloto: 'Piloto y Copiloto',
		pilotoEmComando: 'piloto al mando',
		pilotoEmInstrucao: 'Piloto en formación',
		pilotoInstrucao: 'Piloto en Instrucción',
		pilotoResponsavel: 'Piloto Responsable',
		pilotos: 'Piloto',
		placa: 'Placa',
		planejada: 'Planificado',
		planejamentoMissao: 'Planificación de Misiones',
		plano: 'Plan',
		planoDeFundo: 'Fondo de Pantalla',
		planoDeFundoAtual: 'Antecedentes actuales',
		planoDeRegistro: 'AVION MATRICULA',
		planoPlem: 'Plan de emergencia aeroportuaria (PLEM)',
		planoPre: 'Plan de respuesta a emergencias de la empresa (PRE)',
		planta: 'Planta',
		pn: 'PN',
		pnPodeSerConsultado: 'BP puede ser consultado en el campo de arriba para rellenar este campo',
		podeSerAlocado: 'Permiso de Asignación',
		ponto: 'Punto',
		pontos: 'Marcadores',
		pontosInteresse: 'Puntos de interés',
		pontuacao: 'Puntaje',
		pontuacaoMaxima: 'Puntuación máxima',
		pontualOuCondicao: 'Puntual o bajo condición',
		por: 'Puesta',
		por1: 'Poner',
		porArtigo: 'Poner',
		porHoraVoada: 'Con alas por hora',
		porPeriodo: 'por periodo',
		porQuestoesAlterarSenha: 'Por cuestiones de seguridad es necesario que cambie su contraseña.',
		porQuestoesDeSeguranca: 'Por razones de seguridad, necesitas cambiar tu Firma Digital',
		porcentagem: 'Porcentaje',
		porcentagemConsumidaDoContrato: 'Porcentaje consumido del contrato',
		porcentagemConsumidaDoEmpenho: 'Porcentaje de esfuerzo consumido',
		porao: 'Sótano',
		poroes: 'Sótanos',
		poroesQuantidade: 'Número de retenciones',
		portePassageiro: 'Puerto de Pasajeros',
		porteTripulante: 'Tamaño del equipo técnico',
		posGraduacao: 'Pós-Graduação',
		posicao: 'Posición',
		posicaoVoo: 'Posiciones de Vuelo',
		posicoes: 'Posiciones',
		positivo: 'Positivo',
		possui: 'TIENE',
		possuiConselhoRegional: '¿Tiene un consejo regional?',
		pouso: 'Aterrizaje',
		pousoPrevisto: 'Aterrizaje previsto',
		pousos: 'Aterrizajes',
		pratica: 'PRÁCTICA',
		prazo: 'Plazo',
		prazoParaExecucao: 'Fecha límite para la ejecución',
		preRequistos: 'Prerrequisitos',
		precoMedio: 'Precio medio',
		predefinicoes: 'Plantillas',
		preechaTodasAsInformacoesNecessarias: 'Complete toda la información necesaria',
		preenchaOsDadosDoResponsavelPeloVoo: 'Rellena los datos del responsable del vuelo.',
		preenchaOsDadosDoSolicitante: 'Rellene los datos de la autoridad solicitante.',
		preenchaPeloMenosUmCampo: 'Por favor complete al menos un campo',
		preencher: 'Llenar',
		preenchimentoConcluido: 'Relleno completado',
		preenchimentoMotorHorario: 'El llenado de los 4 campos de Motor y Hora debe hacerse en hora local.',
		preenchimentoPeriodo: 'Preste atención a la cumplimentación de los campos Día Noche IFR real IFR simulado y VFR.',
		preenchimentoUTC: 'Los 4 campos de hora deben completarse en hora UTC',
		prefiroNaoDeclarar: 'No Declare',
		prefixoAeronave: 'Prefijo de aeronave',
		prefixoOuIdentificacao: 'Prefijo/Identificación',
		prefixoOuIdentificacaoDoVeiculo: 'Prefijo / Identificación del vehículo',
		pressaoArterialMmHg: 'Presión arterial (mmHg)',
		pressioneCtrl: 'Presione CRTL',
		prevencao: 'Prevención',
		prevencaoDespacho: 'Prevención',
		prevencaoQualificada: 'Prevención Cualificada',
		prevencaoSalva: 'Prevención Salva',
		preventiva: 'Preventivo',
		previewOrdemMissao: 'Vista previa del orden de la misión',
		previsao: 'Previsión',
		previsaoDeData: 'Fecha Pronóstico',
		previsaoDisponibilidadeDbEletronico: 'Electronic DB Availability Forecast',
		primeiroPilotoComando: '1º Piloto en Mando',
		prioridade: 'Prioridad',
		privilegio: 'Privilegio',
		privilegiosParaVer: 'privilegios para ver',
		proa: 'Arco',
		probabilidade: 'Es probable que vuelva a suceder',
		procedencia: 'Origen',
		procedimento: 'Procedimiento',
		procedimentoOperacionalPadrao: 'Procedimiento operativo estándar',
		procedimentosRealizados: 'Procedimientos realizados',
		processaVoos: 'Procesos de vuelos',
		processandoManutencao: 'Procesando mantenimiento (esto puede tardar un poco)',
		processandoManutencaoVisao: 'Mantenimiento de procesamiento',
		processarAuditoria: 'Procesamiento de Auditoría',
		processo: 'Proceso',
		processoEmAndamento: 'Proceso en curso de una orden de misión o despacho.',
		produto: 'Producto',
		produtoExcluidoComSucesso: 'Producto eliminado correctamente',
		produtoSalvoComSucesso: 'Producto guardado correctamente',
		produtoServico: 'Product/Service',
		produtoServicoExcluidoComSucesso: 'Product/Service successfully deleted',
		produtoServicoSalvoComSucesso: 'Product/Service has been successfully saved',
		produtos: 'Productos',
		produtosServicos: 'Products/Services',
		produtosServicosVinculados: 'Productos/Servicios vinculados',
		programacao: 'Cronograma',
		programacaoDeVoo: 'Vuelo',
		programacaoDeVooEncerrado: 'Cronograma de vuelo cerrado',
		programacaoSalvaSucesso: 'CRONOGRAMA GUARDADO CORRECTAMENTE',
		programacaoVoo: 'Cronograma de Vuelo',
		projecaoHorasVoo: 'Proyección de horas de vuelo',
		provedorSMS: 'Proveedor de SMS',
		proximaData: 'próxima fecha',
		proximaHora: 'Próxima hora.',
		proximaInspecao: 'Siguiente intervención',
		proximaInspecaoCamp: 'Próxima inspección',
		proximo: 'Seguiente',
		pulso: 'Legumbres',
		pupilas: 'Alumnos',
		qtdDias: 'Cantidad de días',
		qtdPago: 'Cantidad pagada',
		qtdSolicitado: 'Cantidad solicitada',
		qtdUtilizadaSoro: 'Cantidad utilizada',
		qtdeASerEntregue: 'Cant. para ser entregado',
		qtdeEmEstoque: 'Cant. en stock',
		qtdeEntregue: 'Cant. Entregado',
		qtdeRecebida: 'Cant. Recibió',
		qtdeSolicitado: 'Cant. Solicitado',
		quadrantes: 'Cuadrantes',
		qual: 'Cual ?',
		qualAeronaveVaiSerUtilizada: '¿Qué aeronave se utilizará?',
		qualDirigenteDesseOrgao: '¿Quién es el dirigente de este órgano?',
		qualOMotivo: '¿Cuál es el motivo?',
		qualificacaoCivil: 'Cualificación civil',
		qualificada: 'Cualificada',
		qualquerAeronave: 'Cualquier aeronave',
		quandoBotaoAlerta: 'Cuando se cancela el botón de alerta (ROJO).',
		quandoPesquisarPorLongosPeriodos: 'Al buscar por largos periodos',
		quantas: '¿Cuántos?',
		quantidade: 'Cantidad',
		quantidadeAeronaves: 'Cantidad de aeronaves',
		quantidadeAtual: 'Cantidad Actual',
		quantidadeDeAeronavePorColuna: 'Número de aviones por columna',
		quantidadeDeItens: 'Cantidad de artículos',
		quantidadeDeLitros: 'Cantidad de Litros',
		quantidadeDeSemanas: 'Cantidad de Semanas',
		quantidadeDeveSerMaiorQueZero: 'La cantidad debe ser mayor que 0',
		quantidadeDeveraSerMaiorQueZero: 'La cantidad debe ser mayor que 0',
		quantidadeDisponivel: 'Cantidad disponible',
		quantidadeEstimadaPassageiros: 'Número estimado de pasajeros',
		quantidadeHorasAcionamentoAoCorte: 'Cantidad Horas (Unidad de corte)',
		quantidadeHorasDecolagemAoPouso: 'Cantidad Horas (Aterrizaje Despegue)',
		quantidadeMaxima: 'Cantidad máxima',
		quantidadeMinima: 'Cantidad Mínima',
		quantidadeMissao: 'Misión de cantidad',
		quantidadePassageiros: 'Cantidad de pasajeros',
		quantidadeTransferir: 'La cantidad a transferir',
		quantidadeTransferirMovimentacaoCombustivel: 'La cantidad a transferir (l)',
		quantitativo: 'Cuantitativo',
		quantos: '¿Cuántas confirmados?',
		quantosItens: '¿Cuántos elementos?',
		quatro: 'cuatro',
		quemEOOperador: '¿Quién es el operador de esta solicitud?',
		questionarioReporteFadiga: 'Cuestionario de notificación de fatiga',
		questionarioReporteFadigaEditar: 'Editar Cuestionario de notificación de fatiga',
		quilometros: 'Kilómetros',
		radial: 'Radial(grados)',
		radio: 'Radio',
		rastreado: 'Rastreado',
		rastreadoresAtivos: 'Rastreadores activos',
		rastreamento: 'Seguimiento',
		razaoLatitude: 'Relación de latitud',
		razaoLongitude: 'Razón de longitud',
		razaoSocial: 'Razón Social',
		rbacTolerancia: 'Se permite el funcionamiento normal relativo a una licencia vencida hace menos de 30 (treinta) días. Se prohíbe la operación normal relacionada con una licencia vencida hace más de 30 (treinta) días en cualquier situación.',
		reabastecimento: 'Reposición',
		reabertura: 'Reabriendo',
		reabrindo: 'Reapertura',
		reabrir: 'ABRIR',
		reabrirDespacho: '¿Desea volver a abrir este despacho?',
		reabrirEscala: 'reabrir escala',
		reabrirOrdem: 'Reabrir Orden',
		real: 'Real',
		realprevTelaLogin: 'Pantalla de inicio de sesión de Realprev',
		reativadoComSucesso: 'Reactivado con éxito',
		reativar: 'Reactivar',
		receber: 'Recibir',
		receberSuprimentos: 'Recibir suministros',
		recebido: 'Recibió',
		recebidoPor: 'Recebido por',
		recomendacao: 'Recomendación',
		recomendacoes: 'Recomendaciones',
		recomendadoPeloFabricantePublicacao: 'Recomendado por fabricante/publicación',
		recusaAtendimento: 'Denegación de servicio',
		recusados: 'Rechazado',
		recusar: 'rechazar',
		refOrigem: 'Ref Origen',
		refereSeAoInicio: 'se refiere al comienzo',
		referenciaManual: 'Manual de referencia',
		referenciaMaxima: 'referencia máxima',
		referenciaMinima: 'referencia mínima',
		referencias: 'Referencias',
		regNo: 'Número de registro',
		registro: 'Registro',
		registroAbastecimento: 'Registro de suministro',
		registroDeVoo: 'Registro de Vuelo',
		registroDeVooParte1: 'PARTE I - Registro de vuelo',
		registroHFDM: 'FDM',
		registroNome: 'INSCRIPCIÓN - NOMBRE',
		registrosDaTripulação: 'Registros de tripulación',
		registrosPrincipaisTabelas: 'Registros en tablas principales',
		regua: 'regla',
		reguaDigital: 'Regla digital',
		regulamento: 'Reglamento',
		regulamentoAtualizado: 'Reglamento actualizado',
		regulamentoExcluido: 'Reglamento eliminado con éxito',
		regulamentoSalvo: 'Regulamento salvo',
		regular: 'REGULAR',
		relPrev: 'RelAnterior',
		relacao: 'Relación',
		relator: 'Reportero',
		relatorio: 'Informe',
		relatorioAbastecimento: 'Relatório Abastecimento',
		relatorioAbastecimentoAnual: 'Informe Anual de Suministro',
		relatorioAeronave: 'Informe de aeronave',
		relatorioAlocacao: 'Informe de Asignación',
		relatorioAviacaoCivil: 'Informe de aviación civil',
		relatorioCIV: 'Informe CIV',
		relatorioCentroCusto: 'Informe del centro de costos',
		relatorioDiarios: 'Informe diario',
		relatorioEpidemiologico: 'Informe Epidemiológico',
		relatorioEquipamentoOvn: 'Informe de gafas de visión nocturna',
		relatorioEstoque: 'Informe de Inventario',
		relatorioHorasDeVoo: 'Informe de Horas de Vuelo',
		relatorioHorasVoadas: 'Informe de Horas Voladoras',
		relatorioIndicadorEfetividade: 'Informe de Indicador de Efectividad',
		relatorioMetaHorasVoadas: 'Informe de las Horas Voladas',
		relatorioMovimentacaoCombustivel: 'Relación de movimiento de combustión',
		relatorioMultiprofissional: 'Informe Multiprofesional',
		relatorioOVN: 'Informe GVN',
		relatorioPerfil: 'Informe de perfil',
		relatorioPerfilUsuario: 'Informe Perfil y Usuario',
		relatorioPrecoMedio: 'Informe de precio promedio',
		relatorioPrestacaoDeContas: 'Informe de Cuentas de Cuentas',
		relatorioPrevencao: 'Informe de Prevención',
		relatorioProdutividade: 'Informe de productividad',
		relatorioReporteFadiga: 'Informe de fatiga',
		relatorioSinteticoDeProdutividade: 'Encuesta de productividad',
		relatorioTripulanteAeronave: 'Informe de la Tripulación del Avión',
		relevancia: 'Relevancia',
		remota: 'Remoto',
		removeTrechoVoltaHorimetro: 'Quita el tramo y vuelve el horímetro',
		remover: 'Eliminar',
		removerAeronave: 'Quitar Aeronave',
		removerDadosDbLocalidade: 'Eliminar el libro de registro y los datos de ubicación',
		removerHelice: 'Remoción de hélice',
		removerInformacao: 'Eliminar información',
		removerItem: 'Quitar artículo',
		removerMotor: 'Remoción del Motor',
		removidoSucesso: 'Eliminado con éxito',
		renovacao: 'Renovación',
		reporteFadiga: 'Informe de Fatiga',
		repouso: 'descansar',
		reprovado: 'Fallido',
		requisicao: 'Solicitud',
		requisitoNumero: 'Requisito/Número',
		requisitos: 'Requisitos',
		reserva: 'Reserva',
		reservado: 'Reservado',
		resgateAnimalPeconhento: 'Rescates por accidente de animal venenoso',
		resgatePorComunidade: 'Rescates por comunidad',
		resgatePorFaixaEtaria: 'Rescates por grupo de edad',
		resgatePorSexo: 'Rescates sexuales',
		resgatesCasoMedico: 'Rescates por caso médico',
		respiracao: 'Respiración',
		respiratorio: 'Respiratorio',
		responsavel: 'Responsable',
		responsavelCarga: 'Responsable de la carga',
		responsavelExecucao: 'Responsable de la ejecución',
		responsavelMovimentacao: 'Responsable del manejo',
		responsavelOS: 'Responsable de la orden de servicio',
		responsavelPelaAprovacao: 'Responsable por la aprobación para retorno al servicio',
		responsavelPelaCriacaoDaOrdem: 'Responável pela Confecção da Ordem de Missão',
		responsavelPelaExecucao: 'Responsable de la ejecución',
		responsavelPeloAbastecimento: 'Responsable de suministro',
		responsavelPeloRetorno: 'Responsable del retorno',
		responsavelPeloVoo: 'Responsable de vuelo',
		responsavelTecnico: 'Responsable técnico',
		resposta: 'Respuesta',
		respostaCorreta: 'respuesta correcta',
		respostaMotora: 'Respuesta motora',
		respostaVerbal: 'respuesta verbal',
		respostas: 'Respuestas',
		ressalvas: 'Reservas',
		resultados: 'Resultados',
		resultadosObtidos: 'Resultados obtenidos',
		resumoDaOrdemDeMissao: 'Resumo da Ordem De Missão',
		resumoDaSolicitacao: 'Resumen de la solicitud',
		retirada: 'Retirada',
		retiradoEm: 'Eetirado el:',
		retornarExecucao: 'Volver a Corriendo',
		retrair: 'Retraer',
		revalidacao: 'Revalidación',
		revisao: 'Revisión',
		revisaoData: 'Fecha de revisión',
		revisar: 'Revisión',
		revogação: 'revocación',
		rim: 'Riñón',
		rire: 'RIRE',
		roteiro: 'Guión',
		rua: 'Calle',
		ruaSemNome: 'Calle sin nombre',
		saida: 'Salida',
		saidaHangar: 'Salida del hangar',
		saidaLocal: 'Salida local',
		sair: 'Salir',
		sairTelaCheia: 'Salir Pantalla Completa',
		saldo: 'Balance',
		salvando: 'Guardando',
		salvandoGerandoRastreamento: 'Guardar y generar seguimiento',
		salvandoSolicitacaoAvulsa: 'Guardar solicitud perdida',
		salvar: 'Guardar',
		salvarAlteracoes: 'Guardar ediciones',
		salvarE: 'Salvar es',
		salvarImagem: 'Guardar imagen',
		salvarNovoPadrao: 'Guardar nuevo patrón',
		salvarOrdemMissao: 'Guarde la orden de trabajo o regrese a la Lista de entrega o Manuales e inserte las inspecciones que faltan',
		salvarPagamento: 'SALVAR',
		salvarProcessar: 'GUARDAR Y PROCESAR',
		salvarTermo: 'Quardar Término',
		salvarTrechos: 'Guardar Tramos',
		salvo: 'Salvo',
		salvoComSucesso: 'Guardado exitosamente',
		saoExibidasSolicitacoes: 'Solo se muestra la vista abierta, para ver todo haga clic aquí',
		sangramento: 'Sangría',
		satelite: 'Satélite',
		saudeESanitarias: 'de salud y sanitario',
		scorePontuacao: 'Score (Puntaje)',
		se: 'Si',
		seHabilitadoSolicitaNumeroVoo: 'Si está calificado, al completar el libro de registro, solicita el número de vuelo',
		seOErroPersistirPorFavorEntreEmContatoConosco: 'Si el error persiste contáctanos',
		secao: 'Sección',
		secaoAtualizada: 'Sección actualizada',
		secaoExpirada: 'Sección expirada',
		segundoComando: 'Segundo al mando',
		segundoPilotoComando: '2º Piloto en Mando',
		segurancaOperacional: 'Seguridad operacional',
		segurancaPublica: 'de seguridad pública',
		segurancaRelativa: 'de seguridad relacionados con actos de injerencia ilícita contra la aviación civil',
		seguro: 'Seguro',
		sejaBemVindo: 'Bienvenido al',
		selecionadoOrgaos: 'Órganos seleccionados',
		selecionarAeronave: 'Seleccionar Aeronave',
		selecionarDespacho: 'Seleccione una Orden',
		selecionarItens: 'Seleccionar articulos',
		selecionarMalha: 'seleccionar malla',
		selecionarOpcaoAcima: 'Tienes que seleccionar una opción arriba.',
		selecionarSemana: 'Seleccione Semana',
		selecionarTodos: 'Seleccionar Todos',
		selecionarTodosTrechos: 'Seleccionar todas las secciones',
		selecionarTodosTrechosDisponiveis: 'Seleccionar todas las rutas disponibles para la suscripción',
		selecionarTrechoEspecifico: 'Seleccione una sección específica',
		selecionarUmDespacho: 'Seleccione un despacho',
		selecionarUmDiario: 'Seleccione el libro de registro a continuación.',
		selecionarUmaProgramacao: 'Seleccione un horario de vuelo',
		selecionarUmaSolicitacao: 'Seleccione una solicitud',
		selecione: 'Seleccionar',
		selecioneAPrevencaoQualificadaAbaixo: 'Seleccione prevención cualificada a continuación',
		selecioneAbaixoALista: 'SELECCIONE DE LA LISTA A CONTINUACIÓN EL COMPROMISO QUE DESEA AGREGAR A ESTA FACTURA',
		selecioneAeronave: 'Seleccione una Aeronave',
		selecioneAoMenosUmAcesso: 'Seleccione al menos un acceso al tipo de documento.',
		selecioneAoMenosUmLeitor: 'Seleccione al menos un lector para el documento',
		selecioneAsCargasTransportadas: 'Seleccionar las cargas transportadas',
		selecioneInspecaoAbaixo: 'Seleccione una inspección abajo',
		selecioneOAcesso: 'Seleccione lo acesso',
		selecioneOTipo: 'Seleccione el tipo',
		selecioneOUsuario: 'Seleccione el usuario',
		selecioneOrdemMissaoAbaixo: 'Seleccione la orden a la siguiente misión.',
		selecioneOrdemMissaoPrevencaoAbaixo: 'Seleccione la orden de misión de prevención que se describe a continuación.',
		selecioneOrdemMissaoPrevencaoQualificada: 'Seleccione una orden de misión de prevención cualificada',
		selecioneOrgaos: 'Seleccione los órganos',
		selecioneOsPassageirosTrecho: 'Seleccione los pasajeros que volaron ese tramo',
		selecioneOsTrechosAgrupados: 'Seleccione los tramos que se van a agrupar a continuación.',
		selecioneOsTripulantesTrecho: 'Seleccione la tripulación que voló este segmento',
		selecioneParaExibir: 'Seleccione un elemento para abrir la configuración.',
		selecioneParaExportar: 'Seleccionar el formato para la exportación de datos',
		selecionePrioridade: 'Seleccione una prioridad',
		selecioneProgramacoesVooAlterar: 'Seleccione los horarios de vuelos que desea cambiar',
		selecioneSeDesejaNotificar: 'Seleccione si deseas notificar',
		selecioneSolicitacaoAbaixo: 'Seleccione una solicitud a continuación',
		selecioneTrecho: 'Selecciona la sección',
		selecioneUmContrato: 'Seleccione un contrato',
		selecioneUmContratoAtivo: 'Seleccione un contrato activo',
		selecioneUmContratoOculto: 'Seleccione un contrato oculto',
		selecioneUmContratoOcultoParaHabilitar: 'Seleccione un contrato oculto para permitir',
		selecioneUmEmpenho: 'Seleccione un esfuerzo',
		selecioneUmManual: 'Seleccione un manual',
		selecioneUmMotor: 'Seleccione un motor',
		selecioneUmaAero: 'Seleccione una aeronave para comenzar.',
		selecioneUmaAeronave: 'Seleccione una aeronave',
		selecioneUmaCor: 'Seleccione un color',
		selecioneUmaFatura: 'Seleccione una factura',
		selecioneUmaFuncao: 'Seleccione un rol',
		selecioneUmaMoeda: 'Seleccione una moneda',
		selecioneUmaOrdemDeMissao: 'Seleccione una orden de misión',
		selecioneUmaPrevencaoQualificada: 'Seleccione prevención calificada',
		selecioneUmaSolicitacao: 'Seleccione una solicitud',
		sem: 'Sin',
		semDados: 'Sin datos',
		semDataInstalacao: 'Aún no se han instalado los PN con fecha 00/00/0000',
		semMaisAlertas: 'NO MÁS ALERTAS',
		semMaisConversa: 'sin más conversación.',
		semPassageiros: 'Sin Pasajeros',
		semSolicitacao: 'No hay pedidos',
		semTermoAbertura: 'Sin plazo de apertura',
		semTripulantesTecnicos: 'No hay equipo técnico confirmado',
		semValor: 'Sin valor',
		semVitimas: 'Sin Víctimas',
		semVoo: 'No hay suficiente vuelo',
		semana: 'Semana',
		semanas: 'Semanas',
		senha: 'Contraseña',
		senhaInvalida: 'Contraseña no válida.',
		senhaSpider: 'Contraseña de araña',
		senhaUtilizadaAoLogar: 'Contraseña utilizada para iniciar sesión en el sistema.',
		senhasNaoCoincidem: 'Las contraseñas ingresadas no coinciden',
		separado: 'Separado(a)',
		seraExibidoTodas: 'todos los aviones se mostrarán en el monitoreo del cuadrante',
		seraExibidoTodasElas: 'Se mostrarán las inspecciones de todas las aeronaves.',
		seraNecessarioAssinarAlgumaInspecaoParaConfirmarNovasAlteracoesNosDadosDessaOrdemDeServico: 'Deberá firmar una inspección para confirmar los nuevos cambios en los datos de esa orden de trabajo.',
		seraNecessarioAssinatura: 'Se requerirá una nueva firma del piloto.',
		servicesWS: 'Servicios WS',
		servico: 'Servicio',
		servicos: 'Mantenimiento',
		servicosAExecutar: 'Servicios a ejecutar',
		servicosExecutados: 'Servicios desempeñados',
		sessao: 'Sesión',
		sessaoAtualizada: 'Sesión actualizada',
		sessaoExpirada: 'Sesión expirada',
		setor: 'Sector',
		setorDestino: 'Sector objetivo',
		setorOuOrgaoExterno: 'Sector / Órgano externo',
		setores: 'Sectores responsables de eliminar el peligro',
		severidade: 'De la gravedad',
		sexo: 'Género',
		sgpe: 'Nr do Arquivo SGP-e da pasta digital individual.',
		sigla: 'Acrónimo',
		sim: 'Sí',
		simples: 'Simple',
		simulado: 'Simulado',
		simulador: 'SIMULADOR',
		sinaisVitais: 'Signos Vitales',
		sistema: 'Sistema',
		sistemaIntegado: 'Sistema Integrado',
		sistemaIntegrado: 'Sistema Integrado',
		sistemasDoCliente: 'Sistemas de clientes',
		situacao: 'Situación',
		situacaoAdministrativa: 'Situación Administrativa',
		situacaoDoPagamento: 'Estado de pago',
		situacaoTecnicaAeronave: 'Parte II -  Situación técnica de la aeronave',
		situacaoTripulacao: 'Situación de la tripulación',
		situacaoTripulante: 'situación de la tripulación',
		situcaoEncontrada: 'Situación encontrada',
		sn: 'SN',
		snCelula: 'célula SN',
		snDeEntrada: 'SN entrante',
		snDeSaida: 'Salida SN',
		snOvn: 'Número de serie de las gafas de visión nocturna',
		soRecomendacoes: 'Recomendación',
		sobre: 'Sobre',
		sobreaviso: 'Advertencia',
		socorridos: 'Socorridos',
		solicitaNumeroVoo: 'Solicitar número de vuelo',
		solicitaUsoAeronave: 'Solicitud de uso de aeronave',
		solicitacao: 'Solicitud',
		solicitacaoCancelada: 'Solicitud cancelada.',
		solicitacaoCriadaDeUmaOrdemDeServico: 'Solicitud creada a partir de una orden de servicio',
		solicitacaoFolga: 'solicitud de tiempo libre',
		solicitacaoInserida: 'Solicitud insertada en el sistema.',
		solicitacaoSalva: 'Solicitud Salva',
		solicitacaoSalvaComSucesso: 'Solicitud guardada exitosamente',
		solicitacoes: 'Solicitudes',
		solicitacoesDeEdicao: 'Editar solicitudes',
		solicitacoesEdicao: 'Editar solicitudes',
		solicitacoesFeitaPorVoce: 'Solicitudes realizadas por usted',
		solicitacoesItens: 'Solicitudes de artículos',
		solicitacoesItensAvulsas: 'Solicitudes de un solo artículo',
		solicitacoesParaVoce: 'Solicitudes para usted',
		solicitado: 'Solicitado',
		solicitadoEm: 'Solicitado en',
		solicitante: 'Solicitante',
		solicitanteCancelou: 'Solicitante canceló',
		solicitanteDaMissao: 'Solicitante de la Misión',
		solicitanteSelecionado: 'Este usuario sólo se guardará como solicitante en los perfiles del sistema.',
		solicitar: 'Pedido',
		solicitarFolga: 'solicitar tiempo libre',
		solicitarItemAvulso: 'Solicitar un solo artículo',
		solicitarItens: 'Solicitar artículos',
		solicitarOS: 'Tienes que guardar el sistema operativo para pedir suministros.',
		solicitarSuprimento: 'Solicitar suministro',
		solo: 'Terreno',
		solteiro: 'Solo(a)',
		somaDiurnoNoturno: 'La suma de los campos Día y Noche debe ser igual al Tiempo de vuelo del piloto',
		somaIfrVfr: 'La suma de los campos VFR y IFR debe ser igual al Tiempo de vuelo del piloto',
		somenteLeitura: 'Solo lectura',
		somentePeso: 'Solo peso',
		souPiloto: 'Soy Piloto',
		status: 'Estado',
		statusContrato: 'Estado del contrato',
		statusDaExecucao: 'Estado de ejecución',
		statusDaRecomendacao: 'Estado de la recomendación',
		statusExcluidoComSucesso: '¡Estado eliminado correctamente!',
		statusFoiSalvoComSucesso: '¡El estado se ha guardado correctamente!',
		statusLeitura: 'Status de Lectura',
		statusLicencas: 'Días restantes hasta el vencimiento.',
		suaSecaoExpirou: 'Su sección ha caducado.',
		suaSessaoExpirou: 'Su sesión ha caducado.',
		subEclassificacao: 'Subclasificación y Clasificación',
		subcategoria: 'Subcategoría',
		subclassificacao: 'Subclasificación',
		subclassificacaoAtualizada: 'Subclasificación actualizado',
		subclassificacaoDesativada: 'Subclasificación deshabilitada',
		subclassificacaoExcluida: 'Subclasificación excluida',
		subclassificacaoInstrucao: 'subclasificación de Instrução?',
		subclassificacaoSalva: 'Subclasificación salvo',
		subtitulo: 'Subtítulo',
		suporte: 'Soporte',
		suprimento: 'Suministrar',
		suprimentoAeronauticos: 'Suministros Aeronáuticos',
		suprimentos: 'Suministros',
		tabela: 'Tabla',
		tamanho: 'Tamaño',
		tamanhoTelaLogin: 'Ancho de la pantalla de inicio de sesión en píxeles',
		tanque: 'Tanque',
		tarefaAdicionada: 'Tarea Agregada',
		tarefaCadastrada: 'Tarea Registrada',
		tarefaRemovidaComSucesso: 'Tarea eliminada correctamente',
		tarefas: 'Tareas',
		tas: 'Tas',
		telaCheia: 'Pantalla Completa',
		telefone: 'Teléfono',
		telefoneCelular: 'Teléfono celular',
		telefoneDeEmergencia: 'Teléfono de emergencia',
		telefoneResidencial: 'Teléfono residencial',
		temAcompanhante: '¿Hay una escolta?',
		temUmTermino: 'Tiene un término',
		temperaturaC: 'Temperatura (ºC)',
		template: 'Plantilla',
		tempo: 'Tiempo',
		tempoBusca: 'Búsqueda de tempo',
		tempoDePreenchimento: 'Tiempo de llenado',
		tempoDeVoo: 'Tiempo de vuelo',
		tempoDeVooDecolagemPousoDecimal: 'Tiempo de vuelo Despegue a Aterrizaje (Decimal)',
		tempoEstimado: 'Tiempo estimado',
		tempoEstimadoViaAr: 'ETA vía AÉREA',
		tempoIndisponibilidade: 'Duracíon de la indisponibilidad',
		tempoMedioRepasseSamu: 'Tiempo medio de traslado de pacientes al equipo SAMU',
		tempoMedioSaidaHangar: 'tiempo medio de salida del hangar',
		tempoNotificao: 'Hora de notificación',
		tempoResposta: 'Tiempo de respuesta',
		tempoRestante: 'Tiempo restante',
		tempoSessao: 'Hora de la sesión',
		tempoSobrevoo: 'Tiempo de Sobrevuelo',
		tempoTotal: 'Tiempo total',
		tempoTotalPiloto: 'Tiempo total del piloto:',
		tempoUso: 'tiempo de uso',
		tempoVooDecolagemAoPouso: 'Tiempo de Vuelo (Despegue al Aterrizaje)',
		tempoVooMuitoGrande: 'Tiempo de vuelo muy grande',
		tentativas: 'Intentos',
		teorico: 'TEÓRICO',
		termino: 'Final',
		terminoOrdem: 'Terminación de la orden',
		termoAbertura: 'Término de apertura',
		termoAtualizado: 'Término Actualizado',
		termoDeUso: 'Término de Uso',
		termoDeUsoAtualizacao: 'ES NECESARIO ACTUALIZAR EL PLAZO CON LOS DATOS DEL DPO EN VIRTUD DE LA LGPD (LEY 13.709/2018).',
		termoDeUsoSistema: 'SE HAN ACTUALIZADO LAS CONDICIONES DE USO DEL SISTEMA O HAY CAMPOS DEL RESPONSABLE DE PROTECCIÓN DE DATOS PERSONALES QUE DEBEN SER RELLENAR.',
		termoDescentralizacaoCredito: 'Plazo Descentralización Crédito',
		termosDeUso: 'Condiciones de uso',
		termoDiarioDeBordo: 'Libro de Vuelo Diario',
		testemunha: 'Testigo',
		texto: 'Texto',
		textoDiaDiscrepancia: 'tiene un mayor número de casos ocurriendo en el',
		textoDigiteSeuLogin: 'Introduzca su login que vamos a encontrar la mejor forma de establecer una nueva contraseña.',
		textoHorarioDiscrepancia: 'en un horario próximo a las',
		textoLogin: 'Texto en la pantalla de inicio de sesión',
		textoModificarSenha: 'Para modificar su contraseña actual introduzca la nueva contraseña en el campo siguiente.',
		textoNotificacao: 'Texto de notificación',
		textoSenhaAlteradaSucesso: 'Su contraseña ha cambiado con éxito!',
		ticket: 'Entrada',
		ticketCancelado: 'Boleto cancelado',
		timeline: 'CRONOGRAMA',
		tipo: 'Tipo',
		tipoAcionamento: 'Tipo de Accionamiento',
		tipoAeronave: 'Tipo de aeronave',
		tipoAplicacao: 'Tipo de aplicación',
		tipoArmazenamentoExcluido: 'Tipo de almacenamiento eliminado correctamente',
		tipoCarga: 'Tipo de carga',
		tipoCiclo: 'Tipo de ciclo',
		tipoCombustivel: 'Tipo de combustible',
		tipoCompensacao: 'tipo de compensación',
		tipoContador: 'tipo de contador',
		tipoContrato: 'Tipo de Contrato',
		tipoContratoExcluidoComSucesso: '¡Tipo de contrato eliminado correctamente!',
		tipoContratoFoiSalvoComSucesso: '¡El tipo de contrato se ha guardado correctamente!',
		tipoControle: 'Tipo de control',
		tipoDaMissao: 'Tipo de Misión',
		tipoDeAmazenamentoSalvoComSucesso: 'Tipo De almacenamiento guardado exitosamente!',
		tipoDeArmazenamento: 'Tipo de Almacenamiento',
		tipoDeCarga: 'Tipo de carga',
		tipoDeEntrada: 'Tipo de entrada',
		tipoDeLicenca: 'Clase de Licencia',
		tipoDePagamento: 'Tipo de pago',
		tipoDePlano: 'Tipo de plan',
		tipoDeServico: 'Tipo de servicio',
		tipoDeSolicitacao: 'Tipo de solicitud',
		tipoDeUsuario: 'Tipo de usuario',
		tipoDeVoo: 'Tipo de vuelo',
		tipoDespacho: 'Tipo de Despacho',
		tipoDoEvento: 'Tipo de evento',
		tipoDoProduto: 'Tipo de producto',
		tipoDocumento: 'Tipo Documento',
		tipoDocumentoExcluidoComSucesso: 'Tipo documento eliminado con éxito',
		tipoDocumentoSalvoComSucesso: 'Tipo documento guardado con éxito',
		tipoEmbalagem: 'Tipo de embalaje',
		tipoEmbalagemCadastro: 'Tipo de embalaje caducado con éxito',
		tipoEntrada: 'Tipo de entrada',
		tipoHorasCelulaIntervencaoManutencao: 'Horas de vuelo hasta la próxima intervención de mantenimiento // Disponibilidad:',
		tipoIfr: 'Tipo IFR',
		tipoMapa: 'Tipo Mapa',
		tipoMissao: 'Tipo de misión',
		tipoMotivoNaoEmbarcaAtualizado: 'Razón por la que no se pudo abordar correctamente actualizado',
		tipoMotivoNaoEmbarcaSalvo: 'Motivo por el que no se pudo abordar correctamente guardado',
		tipoMotivoNaoEmbarque: 'Tipo de motivos para no embarcar',
		tipoMotivoNaoEmbarqueExcluido: ' Motivo por el que no se ha podido abordar correctamente eliminado',
		tipoMovimentacao: 'Tipo de movimiento',
		tipoNOcorrencia: 'Tipo/Nº de ocurrencia',
		tipoNumeroOcorrencia: 'Tipo/número de ocurrencia',
		tipoOcorrencia: 'Tipo de ocurrencia',
		tipoOrdemDeMissao: 'Tipo de Orden de Misión',
		tipoOrdemMissaoExcluidoComSucesso: 'Tipo Orden de Misión eliminado correctamente',
		tipoOrdemMissaoSalvoComSucesso: 'El Tipo Orden de Misión se ha guardado correctamente',
		tipoParametro: 'tipo de parámetro',
		tipoPassageiro: 'Tipo de pasajero',
		tipoPeriodo: 'tipo de periodo',
		tipoProximaIntervencao: 'Tipo de la próxima intervención',
		tipoProximaIntervencaoManutencao: 'Tipo de la próxima intervención de mantenimiento',
		tipoSolicitacao: 'tipo de solicitud',
		tipoTarefa: 'Tipo de tarea',
		tipoTreinamento: 'Tipo de entrenamiento',
		tipoTripulacao: 'tipo de tripulación',
		tipoUltimaIntervencao: 'Tipo de la última intervención',
		tipoUltimaIntervencaoManutencao: 'Tipo de la última intervención de mantenimiento',
		tipoUnidadeArmazenamento: 'Tipo Unidad Almacenamiento',
		tipos: 'Tipos',
		tiposDeSolicitacao: 'Tipos de solicitud',
		titulo: 'Para generar el informe llene los siguientes campos',
		tituloPrimario: 'Título',
		tituloTarefa: 'Título de la Tarea',
		tituloTicket: ' Título',
		tituloTicketForm: ' Título:',
		todas: 'Todos',
		todasAlteracoesSalvas: 'Todos los cambios se guardarán.',
		todasAsFuncoes: 'Todas las funciones',
		todasDiscrepanciasConcluidas: 'Todas las discrepancias completadas',
		todasInspecoes: 'Todas las inspecciones',
		todasInspecoesAssinadaPeloInspetor: 'Todas las inspecciones firmadas por el inspector',
		todasInspecoesAssinadaPeloMecanico: 'Todas las inspecciones firmadas por el mecánico.',
		todasInspecoesDesabilitadas: 'Todas las inspecciones deshabilitadas',
		todasNaturezas: 'Todas las naturalezas',
		todasNturezas: 'Todas Naturalezas',
		todasSeraoExibidas: ' todo se mostrará',
		todos: 'Todos',
		todosGrupos: 'Todos los grupos',
		todosModelos: 'Todos los modelos',
		todosOsContratos: 'todos los contratos',
		todosOsDiariosForamAssinados: 'Ok! Todos los Diarios de Bordo de esa aeronave fueron firmados.',
		todosOsDiariosSelecionadosForamAssinados: 'Ok! Todos los Diarios de Bordo seleccionados de esa aeronave fueron firmados.',
		todosOsTipos: 'Todos los Tipos',
		todosOsTrechos: 'Todos los extractos',
		todosOsVoos: 'Todos los vuelos',
		todosProcessosOrdemMissaoOuDespachoConcluidos: 'Todos los procesos de la orden de misión o de la orden se concluyeron.',
		tolerabilidade: 'Tolerabilidad',
		tolerancia: 'Tolerancia',
		toleranciaDisponivel: 'Tolerancia disponible',
		tooltipDescricaoFatos: 'Descripción de los hechos indicando necesariamente qué y cómo ocurrió el hecho. Algunos ejemplos de ocurrencia son la muerte de un pasajero en vuelo una mujer en trabajo de parto transmisión de un virus etc.',
		tooltipLocalOcorrencia: 'Lugar de ocurrencia necesariamente por el código de localidad o coordenada geográfica si en el suelo y obligatoriamente por coordenada geográfica si en vuelo.',
		tooltipQualificacaoCivil: 'Mejor cualificación civil posible de las personas implicadas (nombre completo documento de identificación utilizado para el embarque nacionalidad y fecha de nacimiento entre otros).',
		tooltipReabrirDespacho: 'Reabrir Despacho',
		tornarPublico: 'Promulgar',
		tornarRecomendacaoDeConhecimentoPublico: 'Hacer pública la recomendación',
		totais: 'Totales',
		total: 'Total',
		totalAtendimentos: 'Llamadas totales',
		totalAcionamentoCorte: 'Total accionamento al corte',
		totalCapacidadeMaxima: 'Capacidad máxima total',
		totalCiclosAviao: 'Total de Ciclos',
		totalCiclosVoados: 'Total de Ciclos Volados',
		totalComunidadesAtendidas: 'Total de comunidades atendidas',
		totalDeAviao: 'Plano total',
		totalDeCiclosNF: 'Total de Ciclos NF',
		totalDeCiclosNG: 'Total de Ciclos NG',
		totalDeCiclosNP: 'Total de Ciclos NP',
		totalDeGancho: 'Total de Gancho',
		totalDeGuincho: 'Total de Guincho',
		totalDeHelicoptero: 'Helicóptero total',
		totalDeOcorrencias: 'Total de ocurrencias',
		totalDePartidas: 'Total de Salidas',
		totalDePerguntas: 'preguntas totales',
		totalDePousos: 'Total de Pisos',
		totalDecolagemPouso: 'Total despeche a aterrizaje',
		totalDia: 'Total en el día',
		totalDoTreinamento: 'Total del treinamento',
		totalHoras: 'Horas totales',
		totalHorasPiloto: 'Total de Horas (Piloto)',
		totalHorasUtilizacao: 'Horas de uso totales',
		totalHorasVoadas: 'Total de Horas Voladas',
		totalIfraAeronave: 'Aeronaves IFRA totales',
		totalIfrhHelicoptero: 'Helicóptero IFRH total',
		totalNaoRastreado: 'Total não rastreado',
		totalObitos: 'Muertes totales',
		totalPago: 'Total Pago',
		totalRastreado: 'Total Rastreado',
		totalResgates: 'Reembolsos totales',
		totalTempoVoo: 'Tiempo total de vuelo',
		totalTraumaScore: 'Puntuación total de trauma',
		totalidade: 'en su totalidad',
		totalvolume: 'Volumen Total',
		trabalho: 'Trabajo',
		transferencia: 'Transferencia',
		transferenciaBase: 'Transferencia de Base',
		transicao: 'Transición',
		traumaScore: 'Trauma score',
		traumatico: 'Traumático',
		transportada: ' transportada',
		trecho: 'Tramo',
		trechoAdicionado: 'Tramos añadido.',
		trechoAgrupadoPor: 'Trecho agrupado por',
		trechoAposData: 'Las secciones solo pueden tener una fecha de activación después de la fecha de corte de la última sección',
		trechoAssinado: 'Tramo firmado',
		trechoConflito: 'El avión ya tiene otro horario durante este período.',
		trechoDesagrupado: 'Tramo desagrado.',
		trechoExcluido: 'Tramo excluido.',
		trechoJuntado: 'Tramo agrupado.',
		trechoNaoPreenchido: 'Sección no rellenada',
		trechoSeraSalvo: 'El número de segmento se creará después de guardar la Solicitud de soporte aéreo.',
		trechos: 'Tramos',
		trechosAgrupados: 'Tramos Agrupados',
		trechosQueOPassEstara: 'Extractos que el pasajero estará',
		treinamento: 'Treinamento',
		treinamentoDesativados: 'Entrenamientos discapacitados',
		treinamentoEnviado: 'Formación enviada',
		treinamentoGrupoDesativados: 'Grupos discapacitados',
		treinamentos: 'Entrenamientos',
		treinamentosGrupo: 'Grupo de entrenamiento',
		treinamentosValidos: 'Formación válida',
		treinamentosValidosHint: 'El estudiante no será agregado a cursos de formación válidos.',
		trelloFollowair: 'Seguir Trello',
		tres: 'Tres',
		trigrama: 'Trigrama',
		tripulacao: 'Tripulación',
		tripulacaoMinima: 'Tripulación mínimo',
		tripulacaoTecnica: 'Equipo técnico',
		tripulacaoVoo: 'la tripulación de vuelo',
		tripulacaoZero: 'Tienes que agregar una tripulación.',
		tripulanteTecnico: 'Equipo técnico',
		tripulantesTecnicos: 'Equipo técnico',
		trocaEquipamentoAeronave: 'Equipo de avión de intercambio',
		trocaSucesso: 'Intercambio completado con éxito',
		trocar: 'para reemplazar',
		trocarVoo: 'Cambiar vuelo',
		tudoCerto: '¡Todo bien, el solicitante ahora puede recibir el(los) artículo(s)!',
		turma: 'clase',
		txtNovoTipoHabilitacao: 'Haga clic en Nueva licencia',
		ubidadeDeOrgaoApoiadoSalvoComSucesso: 'Unidad de órgano apoyado guardada con éxito',
		ultilizado: 'Usado',
		ultima: 'Última',
		ultimaAtualizacaoDaManutencao: 'Última actualización de mantenimiento',
		ultimaData: 'Última fecha',
		ultimaInspecao: 'Última intervención',
		ultimaManutencaoRealizada: 'Se celebra el último mantenimiento',
		ultimo: 'Último',
		ultimoReport: 'Último informe',
		ultimoServico: 'Último Service',
		ultimoVoo: 'Último Vuelo',
		ultimos30Dias: 'Últimos 30 días',
		ultimos60Dias: 'Últimos 60 días',
		ultimos90Dias: 'Últimos 90 días',
		um: 'Uno',
		umCampoObrigatorio: 'Completa al menos un teléfono',
		umDessesCampoEObrigatorio: 'Uno de estos campos es obligatorio.',
		unidade: 'Unidad',
		unidadeArmazenamento: 'Unidad Almacenamiento',
		unidadeArmazenamentoSalvaComSucesso: 'Unidad de almacenamiento guardada exitosamente',
		unidadeCompra: 'Unidad de compra',
		unidadeContabil: 'Unidad de Contabilidad',
		unidadeDeArmazenamentoDeDestino: 'Unidad de almacenamiento de destino',
		unidadeDeArmazenamentoDeOrigem: 'Unidad de Almacenamiento de Origen',
		unidadeDeConservacao: 'Unidad de Conservación',
		unidadeDeMedida: 'Unidad de medida',
		unidadeDestino: 'Unidad de Destino',
		unidadeDoOrgao: 'Unidad de Órgano',
		unidadeDoOrgaoApoiadoExcluidoComSucesso: 'Unidad de órgano apoyado eliminado con éxito',
		unidadeMedida: 'Unidad de Medida',
		unidadeOrcamentaria: 'Unidad de Presupuesto',
		unidadeOrcamentariaExcluida: 'Unidad de presupuesto eliminada',
		unidadeOrcamentariaSalvaComSucesso: 'Unidad de Presupuesto se guardó con éxito',
		unidadeOrgaoApoiado: 'Unidad de Apoyo de Órganos',
		unidadeOrigem: 'Unidad de Origen',
		unidades: 'Unidades',
		upload: 'subir',
		url: 'URL',
		usaCAMP: 'Utilice CAMP o Followair Mantenimiento',
		userSpider: 'Usuario Araña',
		usoDe: 'Uso de',
		usoDeAereonave: 'Uso de la aeronave',
		usoDeFlir: 'Uso de FLIR',
		usoDeOvn: 'Uso de OVN',
		usoSoroAntiofidico: 'Uso de suero antiveneno',
		usuario: 'Usuario',
		usuarioDesativado: 'Usuario Deshabilitado',
		usuarioLicenca: 'Licencia de usuario',
		usuarioNaoTenha: 'el usuario no tiene',
		usuarioQuePodeVer: 'Usuario que puede ver este contrato',
		usuarioSemLicenca: 'Usuario no tiene ninguna Licencia',
		usuarios: 'Usuarios',
		usuariosAtivos: 'Usuarios Activos',
		usuariosAtivosInativos: 'Usuarios Activos / Deshabilitados',
		usuariosDesativados: 'Usuarios Deshabilitados',
		usuariosSimultaneos: 'Usuarios concurrentes',
		utcDate: 'fecha UTC',
		utilizaManutencao: 'Uso Mantenimiento',
		utilizaSigiloOM: 'Usa el secreto en la orden de la misión',
		utilizaTrigrama: 'Utiliza Trigram',
		utilizada: 'Usado',
		utilizadoAlgumMaterialMedicamentoAbordo: '¿Se utilizó algún material/medicamento a bordo?',
		validade: 'Duracion',
		validadeEmMeses: 'Validez en meses',
		validando: 'Validando',
		validandoIntegridadeDoDiarioDeBordo: 'Validación de la integridad del libro de registro',
		validandoSenha: 'Validando contraseña',
		validandoTrecho: 'Extracto de validación',
		validarDados: 'VALIDAR DATOS DE AERONAVES Y MOTORES',
		validos: 'Válido',
		valor: 'valor',
		valorCompensacao: 'valor de compensación',
		valorDaHora: 'Valor por hora',
		valorDoCiclo: 'Valor del ciclo',
		valorDoContrato: 'Valor del contrato',
		valorDoLitro: 'Valor del Litro',
		valorDoPagamento: 'Valor Pago',
		valorEmpenhado: 'Valor Esforzado',
		valorFrete: 'Valor de envío',
		valorHoraTreinamentoPrático: 'valor del treinamento práctico',
		valorMaiorQueDisponivel: 'Valor mayor que el disponible',
		valorMaiorQueDisponivelContrato: 'Valor ingresado mayor que la cantidad máxima disponible en el contrato',
		valorMaiorQueTempoPiloto: 'Valor mayor que el tiempo del piloto',
		valorMaximo: 'Valor máximo',
		valorMaximoExcecao: 'valor máximo de excepción',
		valorMinimo: 'Valor mínimo',
		valorMinimoExcecao: 'excepción de valor mínimo',
		valorNFS: 'Valor NFe',
		valorNaoPermitidoPorUltrapassarOValorContratado: 'Cantidad no permitida por exceder el valor contratado',
		valorNaoPermitidoPorUltrapassarOValorEmpenhado: 'Cantidad no permitida por exceder la cantidad de esfuerzo',
		valorNumericoInvalido: 'Valor numérico no válido.',
		valorProcessado: 'Cantidad procesada',
		valorProduto: 'Valor del producto',
		valorProdutoServico: 'Product/Service Value',
		valorReais: 'Valor (R$)',
		valorReal: 'Valor real',
		valorRecuperado: 'Valor Recuperado',
		valorReferencia: 'Valor de referencia',
		valorReferenteAData: 'Valor relativo a la fecha de inspección',
		valorReportado: 'Valor informado',
		valorRestante: 'Valor restante',
		valorTempoVoo: 'Valor de la hora de vuelo',
		valorTotal: 'Valor Total',
		valorTotalAbastecido: 'Valor total suministrado',
		valorTotalEmProdutosServicos: 'Importe total en productos/servicios',
		valorTotalMedio: 'valor total promedio',
		valorTotalProduto: 'Valor total del producto',
		valorTreinamentoTeorico: 'valor del treinamento teórico',
		valorTributos: 'Impuestos sobre el valor',
		valorUnitario: 'Valor Unitario',
		valorUnitarioMedio: 'valor unitario promedio',
		valorUnitarioTributos: 'Valor unitario con impuestos',
		valordaMatricula: 'valor de la matrícula',
		valoresAtivos: 'Valores activos',
		valoresDoContrato: 'Valores del contrato',
		valoresPorOrgao: 'VALORES POR ÓRGANO',
		varIndMeta: 'var % ind/meta',
		variacoes: 'Variaciones',
		vcTemQueDigitarSenha: 'Usted tiene que introducir su contraseña.',
		veiculo: 'Vehículo',
		veiculoExcluidoComSucesso: 'Vehículo eliminado correctamente',
		velocidade: 'Velocidad',
		velocidadeAtual: 'Velocidad actual',
		velocidadeMedia: 'Velocidad Media',
		vencido: 'Vencido',
		vencimento: 'Fecha de vencimiento',
		vencimentoTreinamento: 'Salarios de formación',
		vencimentos: 'Vencimiento',
		ventilacao: 'Ventilación',
		ver: 'Ver',
		verAcionamentoECorte: 'Ver marcha y parada',
		verDecolagemEPouso: 'Ver despegue y aterrizaje',
		verEstoque: 'Ver stock',
		verTodos: 'Ver todos',
		verificaBloqueioDiscrepancia: 'Comprobar discrepancia de bloqueo',
		verificacao: 'MARQUE LA FORMA DE EJECUCIÓN DE LA MANIOBRA EN EL LUGAR CORRESPONDIENTE',
		verificacaoDoVor: 'Verificación VOR',
		verificacaoSePodeExcluir: 'Comprobar si se puede excluir',
		verificados: 'Escaneado',
		verificando: 'Viendo',
		verificandoSePodePreencher: 'Comprobar si puede llenar',
		verificar: 'para comprobar',
		verificarDisponibilidade: 'Consultar disponibilidad',
		verificarVolumeAlerta: 'POR FAVOR, COMPRUEBE EL VOLUMEN PARA ESCUCHAR LAS ALERTAS',
		versao: 'Versión',
		versaoApi: 'Versión de Api',
		versaoArquivo: 'Versión del archivo',
		via: 'A través de',
		vidaUtil: 'Esperanza de vida',
		violacaoLeiAeronauta: 'Violación de la ley aeronáutica.',
		visaoGeral: 'Visión General',
		visualizacoes: 'Puntos de vista',
		visualizar: 'Visualizar',
		visualizarDespacho: 'Ver despacho',
		visualizarMalha: 'Ver malla',
		visualizarNFS: 'Ver NFe',
		visualizarOrdemServico: 'Ver Orden de Servicio',
		visualizarRelatorio: 'Vista del informe',
		vitima: 'Víctima',
		vitimaFoiIdentificada: ' ¿Se ha identificado a la víctima?',
		vitimas: 'Víctimas',
		viuvo: 'Viuvo(a)',
		voadas: 'Voladas',
		voando: 'Volando',
		voce: 'Usted',
		voceAlterandoAeronave: 'Estás cambiando el modelo de avión.',
		voceAlterandoModelos: 'Estás cambiando todas las plantillas.',
		voceAlterandoSerial: 'Estás cambiando la plantilla del número de serie.',
		voceEAAutoridadeSolicitante: 'Usted es la autoridad solicitante?',
		voceJaAddEsseCaso: 'Ya has añadido este caso médico',
		voceJaAddEsseFator: '¿Ya agregaste este factor?',
		voceJaAddEssePerfil: 'Usted ha agregado este perfil',
		voceJaAddEsseSetor: 'Ya has añadido este sector',
		voceJaAddItem: 'Te ha añadido este artículo.',
		voceJaCadastrouItem: 'Usted ya ha registrado este artículo.',
		voceNaoPodeAgrupar: 'Usted no puede desagrupar esos tramos ya se han llenado.',
		voceNaoPodeExcluirEditando: 'Usted no puede excluir alguien está llenando el diario.',
		voceNovaSenha: 'Debe introducir la nueva contraseña.',
		vocePodeAtualizar: 'Ahora puedes actualizar el libro de registro.',
		voceResponsavelPeloVoo: '¿Eres responsable del vuelo?',
		voceTem: 'Tú tienes',
		voceTemAddUmPerfil: 'Usted tiene que agregar al menos un perfil.',
		voceTemQueEscolherUnidade: 'Usted tiene que agregar al menos una unidad.',
		voceTemQueEsperarPois: 'Usted tiene que esperar pues',
		voltar: 'Volver',
		voltarMapa: 'Volver al mapa',
		volume: 'Volumen',
		volumeAbastecido: 'Volumen de suministro',
		volumeAbastecidoUnidadeArmazenamento: 'Volumen lleno (l)',
		volumeAtual: 'Volumen actual',
		volumeAtualMovimentacaoCombustivel: 'Volumen actual(l)',
		volumeEmLitros: 'Volumen en litros',
		volumeFinal: 'Volumen final',
		volumeFinalMovimentacaoCombustivel: 'Volumen final (l)',
		volumeMaiorQueDisponivelContrato: 'Volumen ingresado mayor que la cantidad máxima disponible en el contrato',
		volumeMaiorQueDisponivelUa: 'Volumen insertado mayor que la cantidad máxima disponible en la unidad de almacenamiento',
		volumeMaiorQueTanqueAeronave: 'Volumen insertado mayor que el tanque del avión.',
		volumeMedio: 'Volumen promedio',
		volumeMovimentacaoCombustivel: 'Volumen (l)',
		volumeReal: 'Volumen real',
		volumeTotalAbastecido: 'Volumen total suministrado',
		voo: 'Vuelo',
		vooAdicionadoSucesso: 'Vuelo añadido con éxito',
		vooAssinadoPeloMecanico: 'Vuelo firmado por el Mecánico',
		vooAssinadoPeloOperador: 'Vuelo firmado por el operador',
		vooAssinadoPeloPiloto: 'Vuelo firmado por el Piloto',
		vooAssinadoPor: 'Vuelo firmado por',
		vooDecimoCelula: 'Vuelo Décimo Célula',
		vooDecimoMotor: 'Vuelo Décimo Motor',
		vooDeveConterPiloto: 'El vuelo de instrucción debe contener un Piloto en instrucción',
		vooEspecial: 'vuelo especial',
		vooFinal: 'Hor. Fin',
		vooInicial: 'Hor. Hogar',
		vooLegado: 'vuelo heredado',
		vooNaoPreenchido: 'Vuelo no rellenado',
		vooPreenchidoPor: 'Vuelo completado',
		vooReferenteAData: 'Vuelo respecto a la fecha',
		vooRegular: 'Vuelo Regular',
		vooSalvo: 'Vuelo guardado correctamente',
		voos: 'Vuelos',
		voosEspeciais: 'VUELOS ESPECIALES',
		wsdlCampFeed: 'WSDL Feed',
		wsdlCampGeneral: 'WSDL General',
		wsdlCampStatus: 'WSDL Status',
		wsdlCampoWorkOrder: 'WSDL Work Order',
		zonaQuenteCriminalidade: 'Zona Caliente de Criminalidad',
		zoomAeronave: 'Zoom Aircraft',
		zoomMobile: 'Zoom (móvil)',
		zoomPrincipal: 'Zoom principal',
		zoomRastreamento: 'Seguimiento de zoom',
		zqc: 'ZCC',
	},
	helice: {
		dadosHelice: 'Datos de la hélice',
		helice: 'Hélice',
		heliceAdicionada: 'Hélice agregada exitosamente',
		heliceAtualizada: 'Hélice actualizada con éxito',
		heliceUnica: 'Hélice única',
		helices: 'Hélices',
		novaHelice: 'Nueva hélice',
		numHelices: 'Números de hélice',
		salvarHelice: 'Guardar hélice',
	},
	login: {
		digiteLogin: 'Digite su nombre de usuario',
		digiteSenha: 'Digite su contraseña',
		digiteSenhaAtual: 'Ingrese la contraseña actual del usuario',
		entrando: 'Entrando',
		entrar: 'Entrar',
		textoErro: 'Usuario o contraseña no válidos',
	},
	menu: {
		administracao: 'Administración general',
		comercial: 'Comercial',
		despachoComercial: 'Despacho Comercial',
		gestaoEscala: 'Gestión de escala',
		gestaoFadiga: 'Gestión de la fatiga',
		gestaoFinanceira: 'Gestión financiera',
		gestaoMalhaComercial: 'Gestión de Redes Comerciales',
		menuAdministracao: 'Administración',
		menuAdministracaoEnsino: 'Administración Educativa',
		menuCertificados: 'Certificados',
		menuExecucaoEnsinoTreinamento: 'Ejecución de la Enseñanza/Capacitación',
		menuGeral: 'General',
		menuGerenciais: 'Gerenciales',
		menuManutencao: 'Mantenimiento',
		menuManutencaoAeronave: 'Aeronave',
		menuMissao: 'Misión',
		menuMonitoraAeronaves: 'Aeronaves',
		menuOrdem: 'Orden',
		menuProjeto: 'Proyectos',
		menuRastreador: 'Rastreador',
		menuRastreamento: 'Seguimiento',
		menuRelatorios: 'Informes',
		menuTrello: 'Trelo',
		menuTrocarEquipamento: 'Cambiar equipo',
		prontos: 'Listo',
		sairSistema: '¿Desea salir del sistema?',
		segurancaOperacional: 'Seguridad operacional',
		segurancaOperacionalOperacional: 'Operacional',
		segurancaOperacionalSeguranca: 'Seguridad',
	},
	menuAGCadAula: {
		aberta: 'Abierta',
		adicionarAula: 'Agregar clase',
		aula: 'Lección',
		aulaAtualizada: 'Lección actualizada',
		aulaCancelada: 'Lección cancelada',
		aulaEncerrada: 'Lección cerrada',
		aulaInserida: 'Lección insertada',
		aulaReaberta: 'Lección reabierta',
		aulas: 'Lecciones',
		aulasEFrequencias: 'Lecciones e Frecuencias',
		cancelada: 'Cancelada',
		duracaoNaoPodeMaiorQue: 'La dutación no puede ser mayor que',
		encerrada: 'Cerrada',
		frequencias: 'Frecuencias',
		msgAjudaAula: 'Haga clic en las cartas de la tabla para editar o tirar frecuencias.',
		presente: 'Presente',
	},
	menuAGCadTurma: {
		abertaParaInscricao: 'Inscripción abierta',
		emAndamento: 'En curso',
		excluirTurma: '¿Desea EXCLUIR esta Clase?',
		finalizada: 'Cerrada',
		novaTurma: 'Nueva Clase',
		turmaAtualizada: 'Clase actualizada',
		turmaInserida: 'Clase insertada',
		turmaRemovida: 'Clase eliminada correctamente',
		turmaTitulo: 'Clase',
	},
	menuAGcadAluno: {
		acidente: 'En caso de accidente avisar a la',
		alergico: 'Es alérgico a algún tipo de medicamentos (s)? Describirlo (s)',
		contato1: 'Teléfono Principal',
		contato2: 'Teléfono Celular',
		contato3: 'Contacto 3',
		dadosPessoais: 'Datos Personales',
		doSecao: 'Sección',
		doc1: 'Documento 1',
		doc2: 'Documento 2',
		doc3: 'Documento 3',
		docCategoria: 'Categoría',
		docCertidaoDeReservista: 'Certificado de Reservista',
		docCic: 'RUC',
		docDataExpedicao: 'Fecha de emisión',
		docIdentidade: 'Identidad',
		docOrgaoExpeditor: 'Órgano Expedidor',
		docTituloEleitor: 'Título de elector',
		docZona: 'Zona',
		documentacao: 'Documentación',
		doutorado: 'Doctorado',
		empresa: 'Empresa',
		ensinoFundamental: 'Escuela',
		ensinoMedio: 'Bachillerato',
		entende: 'Entiende',
		escolhaNivelInstrucao: 'Eligir su nivel de instrucción',
		escreve: 'Escribió',
		eulieaceitootermo: 'He leído y estoy de acuerdo con los términos anteriores.',
		fala: 'Habla',
		fatorRH: 'Factor RH',
		filiacao: 'Afiliación',
		grauParentesco: 'Grado de parentezco',
		habIFRaviaoP: 'Habilitación IFR Avión - Práctico',
		habIFRaviaoT: 'Habilitación IFR Avión - Teórico',
		habIFRhelicopteroP: 'Habilitação IFR Helicóptero - Prático',
		habIFRhelicopteroT: 'Habilitação IFR Helicóptero - Teórico',
		habilitacao: 'Para los Portadores de Habilitación',
		idioma: 'Idioma',
		idiomasEstrangeiros: 'Idiomas Extranjeros',
		infoAdicionais: 'Informaciones adicionales',
		inscricaoSalva: 'La inscripción se salva con éxito!',
		le: 'Lee',
		menuAGalunoAdm: 'Administración',
		menuAGalunoCargo: 'Cargo',
		menuAGalunoDoc: 'Documento',
		menuAGalunoEscolar: 'Escolar',
		menuAGalunoFicha: 'Ficha de Inscripción',
		menuAGalunoInsc: 'Inscripción',
		menuAGalunoInscs: 'Inscripciones',
		menuAGalunoNovaInsc: 'Nueva Inscripción',
		menuAGalunoSexo: 'Sexo',
		mestrado: 'Máster',
		nivelInstrucao: 'Nível de Instrucción',
		nomeEmpresa: 'Nombre de la Empresa',
		nomeMae: 'Nombre de la Madre',
		nomePai: 'Nome del Padre',
		numeroInscricao: 'Número de la inscripción',
		outrasInfo: 'Otras Informaciones',
		paraPortadoresDeLicenca: 'Para los Portadores de licencias',
		pilotoCPaviao: 'Piloto Comercial de Avión - Práctico',
		pilotoCPhelicoptero: 'Piloto Comercial de Helicóptero - Práctico',
		pilotoCTaviao: 'Piloto Comercial de Avión - Teórico',
		pilotoCThelicoptero: 'Piloto Comercial de Helicóptero - Teórico',
		pilotoPPaviao: 'Piloto Privado de Avión - Práctico',
		pilotoPPhelicoptero: 'Piloto Privado de Helicóptero - Práctico',
		pilotoPTaviao: 'Piloto Privado de Avión - Teórico',
		pilotoPThelicoptero: 'Piloto Privado de Helicóptero - Teórico',
		requisitosParaOtreinamento: 'Requisitos para este treinamento.',
		sebrac: 'SEBRAC',
		simuladorVoo: 'Simulador de vuelo',
		superiorCompleto: 'Superior',
		tipoSanguineo: 'Tipo Sanguíneo',
		treinamento: 'Treinamento',
		voltarParaLista: 'Volver a la lista',
	},
	menuAGcadMatricula: {
		addMatricula: 'Matrícula insertada',
		attMatricula: 'Matrícula actualizada',
		cadHabilitacao: 'Habilitación',
		cadMatriculaTitulo: 'Matrícula',
		cadNomeAluno: 'Nombre del Alumno',
		cadNovaMatricula: 'Nueva Matrícula',
		cadNumero: 'Número',
		cadTreinamento: 'Treinamento',
		fechaMatricula: 'Matrícula encerrada',
	},
	menuAGcadPagamento: {
		addPagamento: 'Pagamento insertado',
		attPagamento: 'Pagamento actualizado',
		cadNovoPagamento: 'Nuevo Pagamento',
		cadPagamentoTitulo: 'Pagamento',
		cadValor: 'Valor',
		codigoPagamento: 'Código',
		fechaPagamento: 'Pagamento encerrado',
		nomeAluno: 'Nombre - Alumno',
		treinamentoHab: 'Treinamento',
	},
	menuAGcadTreinamento: {
		cadEditarTreinamento: 'Editar Treinamento',
		cadNomeTreinamento: 'Nombre del Treinamento',
		cadNovoTreinamento: 'Novo Treinamento',
		cadTreinamentoAtualizado: 'Treinamento actualizado',
		cadTreinamentoCargaHoraria: 'Carga Horaria',
		cadTreinamentoCliente: 'Clic en el Nuevo',
		cadTreinamentoDisciplina: 'Disciplinas',
		cadTreinamentoNovaDisciplina: 'Insertar Nueva Disciplina',
		cadTreinamentoPratico: 'Práctico',
		cadTreinamentoSecretaria: 'Escuela de vuelo',
		cadTreinamentoSucesso: 'Treinamento Insertado',
		cadTreinamentoTeorico: 'Teórico',
		cadTreinamentoTitulo: 'Treinamentos',
		cadTreinamentoValorTeorico: 'valor teórico',
		cadTreinamentomenuMtexto2: 'clic en el ícono',
		cadTreinamentomenuMtexto3: 'na lista opuesta.',
		cadValorTreinamento: 'Valor del Treinamento',
		disciplinaAvaliativa: '¿Este curso es evaluativo?',
		eAvaliativo: '¿Es evaluativo?',
		frequenciaParaAprov: 'Frecuencia de aprobación',
		notaMinimalParaAprov: 'Nota mínima de aprobación',
	},
	menuAGinspecao: {
		menuAGaAeronave: 'de Aeronaves',
		menuAGatualizado: 'Inspección actualizada con éxito.',
		menuAGcCiclo: 'Ciclo',
		menuAGdadosInspecao: 'Datos de Inspección',
		menuAGdescInspecao: 'Descripción de la inspección',
		menuAGeditarInspecao: 'Editar Inspección',
		menuAGgInspecao: 'Grupo Inspección',
		menuAGhHomem: 'Hora/Hombre',
		menuAGiAnos: 'Años',
		menuAGiDescricao: 'Descripción',
		menuAGiDias: 'Días',
		menuAGiHoras: 'Horas',
		menuAGiInspecao: 'Inspección',
		menuAGiMeses: 'Meses',
		menuAGinserido: 'Inspección insertada con éxito.',
		menuAGmInspecao: 'Modelo',
		menuAGmodelAeronave: 'Modelo',
		menuAGnInspecao: 'Naturaleza',
		menuAGnovaInspecao: 'Nueva Inspección',
		menuAGnumPeca: 'Número Parte',
		menuAGnumSerie: 'Número Serie',
		menuAGtInspecao: 'Tipo',
		menuAGtextoI1: 'Clic en Nueva Inspección',
		menuAGtextoI2: 'Clic en el ícono',
		menuAGtextoI3: ' na lista opuesta lado.',
		menuAGvidaUtil: 'Vida útil de la Inspección',
	},
	menuAGnovaEscala: {
		menuAGbusca: 'Búsqueda',
		menuAGcarregar: 'Cargar',
		menuAGtipoEscala: 'Tipo',
	},
	menuAGnovoCargo: {
		menuAGaddCargo: 'Cargo insertado',
		menuAGattCargo: 'Cargo actualizado',
		menuAGcadCargo: 'Nuevo Cargo',
		menuAGcadCargo2: 'Registro de cargo',
		menuAGdescCargo: 'Descripción',
		menuAGdescCargo2: 'Descripción del trabajo',
		menuAGeditCargo: 'Editar Cargo',
		menuAGtexto1: 'Clic en Nuevo',
		menuAGtexto2: 'Clic en el icono',
		menuAGtexto3: ' na lista opuesta.',
	},
	menuAGnovoGrupo: {
		cadGrupoTitulo: 'Grupo de Inspección',
		menuAGaddGrupo: 'Grupo insertado',
		menuAGattGrupo: 'Grupo actualizado',
		menuAGcadGrupo: 'Nuevo Grupo',
		menuAGdescGrupo: 'Descripción',
		menuAGdescGrupo2: 'Descripción del grupo',
		menuAGeditGrupo: 'Editar',
		menuAGtextoG1: 'Clic en Nuevo',
		menuAGtextoG2: 'Clic en el icono',
		menuAGtextoG3: ' na lista opuesta.',
		naturezaManutencao: 'Naturaleza De Mantenimiento',
	},
	menuAGnovoOrgao: {
		cadOrgaoTitulo: 'Registro del Órgano',
		menuAGaddOrgao: 'Órgano insertado',
		menuAGattOrgao: 'Órgano actualizado',
		menuAGcadOrgao: 'Nuovo Órgano',
		menuAGdescOrgao: 'Descripción',
		menuAGdescOrgao2: 'Descripción del órgano',
		menuAGeditOrgao: 'Editar Órgano',
		menuAGtextoG1: 'Clic en Nuevo',
		menuAGtextoG2: 'Clic en el icono',
		menuAGtextoG3: ' na lista opuesta.',
	},
	menuAGnovoPosto: {
		menuAGaddPosto: 'Puesto insertado',
		menuAGattPosto: 'Puesto actualizado',
		menuAGcadPosto: 'Nuevo Puesto',
		menuAGdescPosto: 'Descripción',
		menuAGeditPosto: 'Editar Puesto',
		menuAGtexto1: 'Clic en Nuevo',
		menuAGtexto2: 'Clic en el icono',
		menuAGtexto3: ' la lista opuesta.',
	},
	menuAGnovoUsuario: {
		menuAGacesso: 'Acceso al sistema',
		menuAGanac: 'Código ANAC',
		menuAGbairro: 'Barrio',
		menuAGbase: 'Base',
		menuAGbranco: 'En blanco mantener la misma contraseña.',
		menuAGcadUser: 'Nuevo Usuario',
		menuAGcadastroUsuario: 'Registro de usuarios',
		menuAGcargo: 'Cargo',
		menuAGcargo2: 'Cargo',
		menuAGcel1: 'Celular 1',
		menuAGcel2: 'Celular 2',
		menuAGcelular: 'Celular',
		menuAGcep: 'CEP',
		menuAGcidade: 'Ciudad',
		menuAGcomplemento: 'Complemento',
		menuAGcpf: 'Identidad',
		menuAGdadosCadastrais: 'Datos de Registro',
		menuAGdepto: 'Departamento',
		menuAGdesejaExcluir: '¿Desea EXCLUIR este usuario?',
		menuAGeditarUsuario: 'Editar usuario',
		menuAGemail: 'Correo electrónico',
		menuAGestado: 'DPTO',
		menuAGexcluir: 'Excluir usuario',
		menuAGguarnicao: '¿Forma parte de la guarnición?',
		menuAGguarnicao2: 'Guarnición',
		menuAGid: 'Identidad',
		menuAGlogin: 'Nombre de Usuario',
		menuAGlogradouro: 'Via Pública',
		menuAGmarcarTodos: 'Marcar Todos',
		menuAGmatricula: 'Matrícula',
		menuAGnao: 'No',
		menuAGnome: 'Nombre',
		menuAGnomeGuerra: 'Nombre de Guerra',
		menuAGnum: 'Número',
		menuAGnumOrdem: 'Número de Orden',
		menuAGorgao: 'Órgano',
		menuAGposto: 'Puesto/Graduación',
		menuAGprivilegio: 'Privilegios del Sistema',
		menuAGremover: 'Eliminar todos los privilegios',
		menuAGsenha: 'Contraseña',
		menuAGsim: 'Sí',
		menuAGsistema: '¿Tiene acceso al sistema?',
		menuAGtel1: 'Teléfono 1',
		menuAGtel2: 'Teléfono 2',
		menuAGtipo: 'Tipo',
		menuAGtipoCertificado: 'Tipo Certificado',
		menuAGusuarioAdicionado: 'Usuario agregado con éxito.',
		menuAGusuarioAtualizado: 'Usuario actualizado con éxito.',
		menuAGusuarioExcluido: 'Usuario eliminado con éxito.',
		menuAGvalidadeCertificado: 'Validez Certificado',
		msgPrivilegio: 'Añadir quiere más privilegios?',
		pClasse: '1era Clase',
		sClasse: '2da Clase',
		tClasse: '3ra Clase',
	},
	menuAGpermutas: {
		menuAGaeronave: 'Aeronave involucrada:',
		menuAGchefiaEspecial: 'Jefatura Especial del Área de Seguridad Pública – CAESP',
		menuAGcidade: 'Ciudad:',
		menuAGconclusao: 'Conclusión',
		menuAGdata: 'Fecha:',
		menuAGemail: 'Correo electrónico:',
		menuAGenvolvidos: 'Involucrados:',
		menuAGestado: 'DPTO:',
		menuAGfim: 'Fin',
		menuAGinicio: 'Inicio',
		menuAGlocal: 'Lugar:',
		menuAGnome: 'Nombre:',
		menuAGparecer: 'Parecer',
		menuAGresposta: 'Respuesta:',
		menuAGresposta2: 'Respuesta',
		menuAGsalvo: '¡Guardado con éxito!',
		menuAGsecretariaAlagoas: 'Secretaría de Estado de Seguridad Pública de Alagoas',
		menuAGsituacao: 'Situación:',
		menuAGsolicitado: 'Solicitado',
		menuAGtel: 'Teléfono:',
		menuAGtipo: 'Tipo:',
		menuAGtipo2: 'Tipo',
	},
	menuAGplanoManutencao: {
		boletins: 'Boletines',
		comprimentoDeBoletins: 'CUMPLIMIENTO DE BOLETINES DE AERONAVEGABILIDAD',
		comprimentodeBoletinsServico: 'CUMPLIMIENTO DE BOLETINES DE SERVICIOS',
		controleDeComponentesCeula: 'CONTROL DE COMPONENTES',
		controleDeComponentesMotor: 'CONTROL DE COMPONENTES',
		inspecoesAcessoriosMotor: 'INSPECCIONES PROGRAMADAS DE ACCESORIOS',
		inspecoesProgramadas: 'INSPECCIONES PROGRAMADAS',
		inspecoesProgramadasEquipamento: 'INSPECCIONES PROGRAMADAS DE EQUIPAMIENTOS',
		inspecoesProgramadasMotor: 'INSPECCIONES PROGRAMADAS',
		inspecoesRegulamentares: 'INSPECCIONES REGLAMENTARIAS',
		manuAGNenhumaEncontrada: 'No se encontraron inspecciones.',
		menuAGInspecaoAtualizada: 'Inspecciones actualizadas.',
		menuAGaddInspecao: 'Agregar Inspección al Plan',
		menuAGaddTodas: 'Agregar Todas',
		menuAGcelula: 'Célula',
		menuAGdetalhes: 'Detalles',
		menuAGinspDetalhe: 'Detalles de la Inspección',
		menuAGinspecao: 'Inspección',
		menuAGinspecoes: 'Inspección',
		menuAGmodelo: 'Modelo',
		menuAGmotor: 'Motor',
		menuAGpeca: 'Parte',
		menuAGperiodicidade: 'Periodicidad',
		menuAGplano: 'Plan de Mantenimiento',
		menuAGremoveTodas: 'Eliminar Todas',
		menuAGserie: 'Serie',
		revalidacoes: 'REVALIDACIONES Y CERTIFICACIONES',
	},
	menuAGprevencao: {
		menuAGNovaPrevencao: 'Nueva Prevención',
		menuAGaeronave: 'Aeronave:',
		menuAGaeronave2: 'Aeronave',
		menuAGcancelamento: 'Describa el motivo de la cancelación de este RELPREV',
		menuAGcancelar: 'Cancelar prevención',
		menuAGcidade: 'Ciudad:',
		menuAGcidade2: 'Ciudad',
		menuAGconcluir: 'Concluir prevención',
		menuAGconclusao: 'Descripción de la conclusión',
		menuAGdataOcorrencia: 'Fecha de la Ocurrencia:',
		menuAGdescricao: 'Descripción:',
		menuAGemail: 'Correo electrónico:',
		menuAGenvolvidos: 'Personal Involucrado:',
		menuAGlocal: 'Lugar de la Ocurrencia:',
		menuAGpPrevencao: 'Prevención',
		menuAGprevencaoCancelada: 'Prevención cancelada.',
		menuAGprevencaoConcluida: 'Prevención concluída.',
		menuAGrelato: 'Informe de Prevención',
		menuAGrelatoOcorrencia: 'El informe de la ocurrencia aquí presentada tiene como única finalidad el incentivo a la seguridad operacional por lo cual su uso se destina exclusivamente a la prevención de accidentes. NO ES NECESARIO FIRMAR O IDENTIFICARSE',
		menuAGrelator: 'Relator:',
		menuAGrelatorio: 'Informe de Prevención',
		menuAGrelatorioAdicionado: 'Informe agregado con éxito.',
	},
	menuAGstatus: {
		cadStatusTitulo: 'Registro de Estado',
		menuAGaddStatus: 'Estado  insertado',
		menuAGattStatus: 'Estado actualizado',
		menuAGcadStatus: 'Nuevo Estado',
		menuAGcadStatus2: 'Registrar estado',
		menuAGdescStatus: 'Descripción',
		menuAGdescStatus2: 'Descripción del estado',
		menuAGeditStatus: 'Editar estado',
		menuAGtexto1: 'Clic on Nuevo',
		menuAGtexto2: 'Clic en el ícono',
		menuAGtexto3: ' na lista opuesta.',
		obrigaStatus: 'Requieren la introducción de una nota al seleccionar este estado?',
	},
	menuAGtipoAfastamento: {
		cadAfastamentoTitulo: 'Aclaramiento de registro',
		menuAGaddAfastamento: 'Aclaramiento insertado',
		menuAGattAfastamento: 'Aclaramiento actualizado',
		menuAGcadAfastamento: 'Nuevo Aclaramiento',
		menuAGdescAfastamento: 'Descripción',
		menuAGdescAfastamento2: 'Descripción del aclaramiento',
		menuAGeditAfastamento: 'Editar Aclaramiento',
		menuAGtextoG1: 'Clic en Nuevo',
		menuAGtextoG2: 'Clic en el ícono',
		menuAGtextoG3: ' na lista opuesta.',
	},
	menuAGtipoGuarnicao: {
		cadGuarnicaoTitulo: 'Registro de Tipo de Guarnición',
		menuAGaddGuarnicao: 'Guarnición insertada',
		menuAGattGuarnicao: 'Guarnición actualizada',
		menuAGcadGuarnicao: 'Nueva Guarnición',
		menuAGdescGuarnicao: 'Descripción',
		menuAGdescGuarnicao2: 'Descripción de la guarnición',
		menuAGeditGuarnicao: 'Editar recorte',
		menuAGgOrdem: 'Orden',
		menuAGgSigla: 'Acrónimo',
		menuAGtexto1: 'Haga clic en Nuevo',
		menuAGtexto2: 'Haga clic en el icono',
		menuAGtexto3: ' en la lista al lado.',
	},
	menuAGtipoMissao: {
		cadMissaoTitulo: 'Registro de Tipo de Misión',
		menuAGaddMissao: 'Misión insertada',
		menuAGattMissao: 'Misión actualizada',
		menuAGcadMissao: 'Nueva Misión',
		menuAGdescMissao: 'Descripción',
		menuAGdescMissao2: 'Descripción de la misión',
		menuAGeditMissao: 'Editar Misión',
		menuAGtexto1: 'Clic en Nueva',
		menuAGtexto2: 'Clic en el ícono',
		menuAGtexto3: ' na lista opuesta.',
	},
	menuAGtipoNatureza: {
		cadNaturezaTitulo: 'La Naturaleza de Registro',
		menuAGaddNatureza: 'Naturaleza insertada',
		menuAGattNatureza: 'Naturaleza actualizada',
		menuAGcadNatureza: 'Nueva Naturaleza',
		menuAGdescNatureza: 'Descripción',
		menuAGdescNatureza2: 'Descripción de la naturaleza',
		menuAGeditNatureza: 'Editar Naturaleza',
		menuAGnSigla: 'Acrónimo',
		menuAGtexto1: 'Clic en Nueva',
		menuAGtexto2: 'Clic en el ícono',
		menuAGtexto3: ' na lista opuesta.',
	},
	menuAGtipoOcorrencia: {
		cadOcorrenciaTitulo: 'Registro de Tipo de Ocurrencia',
		menuAGaddOcorrencia: 'Ocurrencia insertada',
		menuAGattOcorrencia: 'Ocurrencia actualizada',
		menuAGcadOcorrencia: 'Nueva Ocurrencia',
		menuAGdescOcorrencia: 'Descripción',
		menuAGdescOcorrencia2: 'Descripción da ocurrencia',
		menuAGeditOcorrencia: 'Editar Ocurrencia',
		menuAGtexto1: 'Clic en Nova',
		menuAGtexto2: 'Clic en el ícono',
		menuAGtexto3: ' na lista opuesta.',
	},
	menuAGtipoPrioridade: {
		cadPrioridadeTitulo: 'Registro de Tipo de Prioridad',
		menuAGaddPrioridade: 'Prioridad insertada',
		menuAGattPrioridade: 'Prioridad actualizada',
		menuAGcadPrioridade: 'Nueva Prioridad',
		menuAGdescPrioridade: 'Descripción',
		menuAGdescPrioridade2: 'Descripción de Prioridad',
		menuAGeditPrioridade: 'Editar Prioridad',
		menuAGtexto1: 'Clic en Nueva',
		menuAGtexto2: 'Clic en el ícono',
		menuAGtexto3: ' na lista opuesta.',
	},
	menuAdicionarPerfil: {
		paraAdicionar: 'Para agregar un perfil',
		selecionePerfil: 'seleccione el perfil y haga clic en AGREGAR',
	},
	menuAfastamento: {
		menuAadicionado: 'Pedido agregado con éxito.',
		menuAaprovar: 'Aprobar',
		menuAatualizado: 'Pedido actualizado con éxito.',
		menuAreprovar: 'Reprobar',
		tipo: 'Tipo:',
	},
	menuArapiraca: {
		menuAescala: 'Cargando escala Arapicara',
		menuAnpg: 'Nombre- Post/Grad',
		menuAsalvo: 'Guardado',
	},
	menuCadCiv: {
		CivAtualizado: 'CIV actualizada',
		CivRemovida: 'CIV eliminada correctamente',
		CivSucesso: 'CIV insertada',
		cadCiv: 'Registro de CIV',
		pilotoParticipante: 'Piloto Participante',
	},
	menuCadHabilitacao: {
		EditarHabi: 'Editar Habilitación',
		HabiAtualizado: 'Habilitación Actualizado',
		HabiCliente: 'Clic en el Novo',
		HabiDescricao: 'Descripción',
		HabiSecretaria: 'Escuela de vuelo',
		HabiSucesso: 'Habilitación Insertado',
		HabiTexto1: 'clic en el ícono',
		HabiTexto2: 'na lista opuesta.',
		HabiTitulo: 'Habilitación',
		NovoHabi: 'Nuevo Habilitación',
	},
	menuCadPacote: {
		EditarPacote: 'Editar Paquete',
		NovoPacote: 'Nuevo Paquete',
		PacoteAtualizado: 'Paquete actualizado',
		PacoteCliente: 'Clic en el Novo',
		PacoteDescricao: 'Descripción',
		PacoteNumeroHoras: 'Carga Horario',
		PacotePratico: 'Práctico',
		PacoteSecretaria: 'Escuela de vuelo',
		PacoteSucesso: 'Paquete Insertado',
		PacoteTeorico: 'Teórico',
		PacoteTexto1: 'clic en el ícono',
		PacoteTexto2: 'na lista opuesta.',
		PacoteTitulo: 'Paquete',
		ValorPacote: 'Valor del Paquete',
	},
	menuConfiguracao: {
		emailAssunto: 'Asunto del correo electrónico',
		emailTexto: 'Texto de correo electrónico',
		pessoasNotificadas: 'Personas notificadas',
		sms: 'texto SMS',
	},
	menuDiscrepancia: {
		discrepanciaCancelada: 'Discrepancia cancelada',
	},
	menuEdicaoDiario: {
		horimetroFinal: 'Horas finales de vuelo',
		horimetroInicial: 'Horas iniciales de vuelo',
		nenhumEmpenhoAdicionado: 'Sin esfuerzo agregado',
		nenhumMotorAdicionado: 'Sin motor agregado',
		tempoDeVoo: 'Tiempo de vuelo',
	},
	menuErro: {
		menuEtitulo: '¡Ups!',
		menuEtitulo2: '¡Oh-o!',
		menuTextoErro: '¿Ocurrió algún error al intentar realizar esta acción?',
		menuTextoErro2: 'Algo me dice que no puede hacerlo.',
	},
	menuEscala: {
		copilotos: 'Copilotos',
		menuCarregaEscala: 'Cargando escala',
		menuElegenda: 'Subtítulo',
		menuElegenda1: 'Subtítulo',
		menuEnovaLegenda: 'Nuevo título',
		menuEtotalDia: 'Total de servicios por día',
		menuEvermelho: 'Corrija los campos en rojo.',
		menuRemover: 'Eliminar',
		menuSalvaEscala: 'Guardado',
		pilotoEcopiloto: 'Piloto y Copiloto',
		pilotos: 'Pilotos',
		radioOperador: 'Operador de radio',
		secaoManutencao: 'Sección de Mantenimiento',
		sessaoManutencao: 'Sesión de Mantenimiento',
		tripulanteArapiraca: 'Tripulante Arapiraca',
		tripulanteMaceio: 'Tripulante Maceió',
		tripulanteOperacional: 'Tripulante Operacional',
	},
	menuMaceio: {
		menuMmaceio: 'Cargando escala Maceió',
		menuMnpg: 'Nombre- Post/Grad',
		menuMsalvo: 'Guardado',
		menuMtripulante: 'Tripulante ya agregado',
	},
	menuMalha: {
		editarSemana: 'Editar semana',
		gestaoMalha: 'Gestión de malla',
		novaSemana: 'Agregar semana',
	},
	menuManutencao: {
		menuMapoio: 'Apoyo Suelo',
		menuMapu: 'APU',
		menuMasaFixa: 'Ciclo del motor',
		menuMatualizaManutencao: 'Actualizar Mantenimiento',
		menuMatualizada: 'Mantenimiento actualizado con éxito',
		menuMcelula: 'Célula',
		menuMciclon1: 'Ciclos N1',
		menuMciclon2: 'Ciclos N2',
		menuMciclosCSN: 'Ciclos CSN',
		menuMciclosNG: 'Ciclos NG',
		menuMciclosT1: 'Ciclos NF',
		menuMcodinome: 'Nombre código',
		menuMcontrolComp: 'Control de Componentes',
		menuMcontrolCompDE: 'Control de componentes de',
		menuMctm: 'C T M',
		menuMdataPrevista: 'Fecha Prevista',
		menuMdescricao: 'Descripción',
		menuMdetalhes: 'Actualizar',
		menuMdisponibilidade: 'Disponibilidad',
		menuMescolha: 'Escoja una opción',
		menuMeventos: 'Eventos',
		menuMf: 'V - VACACIONES',
		menuMhHomemHora: 'Hombres/Hora',
		menuMhelice: 'Hélice',
		menuMhorasAtuais: 'Horas Actuales',
		menuMhorasTotais: 'Horas Totales',
		menuMhrsAtuais: 'Horas Actuales',
		menuMinspProg: 'Inspecciones Programadas',
		menuMinspProgDE: 'Inspecciones programadas de',
		menuMinspProgEquip: 'Inspecciones Programadas de Equipamientos',
		menuMinspReg: 'Inspecciones Reglamentarias',
		menuMmodelo: 'Modelo',
		menuMmotor: 'Motor',
		menuMnumSerie: 'Número Serie',
		menuMpousosAtuais: 'Aterrizajes Actuales',
		menuMrevalidaC: 'Revalidaciones y Certificaciones',
		menuMtecnico: 'Técnico de mantenimiento',
		menuMtotal: 'Total',
		menuMx: 'X - ESTÁ ESCALADO',
		menuNivel: 'Nivel',
		menuTipo: 'Tipo',
		menuUltimaDataAtualizacao: 'Fecha de última actualización',
	},
	menuMatricula: {
		assinaturaAluno: 'FIRMA DEL ALUMNO(A)',
		atestadoBonsAntecedentes: 'Certificado de Boa Conduta',
		cadastroAPU: 'registro de APU',
		cadastroCombustiveis: 'Registro de combustible',
		cadastroConfigAeronave: 'Registro de configuración de aeronaves',
		candidadoEstrangeiro: 'Candidato Extranjero?',
		cartaoIdentidade: 'Tarjeta de Identidad',
		carteriaIdentidadeEstrangeirosValidade: 'Carnet de identidad para extranjeros con validez de permanencia',
		casoPossuaLicenca: 'Si tiene licencia',
		certidaoCapacidadeFisisca: 'Certificado de Capacidad Física',
		certidaoEscolaridade: 'Certificado de Escolaridad',
		cfg: 'Ajustes',
		copiaCertificadoEscolaridadeEstrangeiro: 'Copia del certificado de escolaridad (traducido oficialmente) de la enseñanza fundamental',
		copiaDocumentoViagem: 'Copia del documento de viaje',
		copiaLicencaAtividade: 'Copia de la licencia de la actividad específica o documento equivalente (traducido oficialmente)',
		cpf: 'RUC',
		declaracaoSubJudice: 'Declaración de la solicitud de que no se encuentra SUB-JUDICE',
		documentacaoApresentada: 'Documentación presentada (Candidatos)',
		documentacaoApresentadaEstrangeiros: 'Documentación presentada (Candidatos Extranjeros)',
		excluirPontoInteresse: 'BORRAR PUNTO DE INTERÉS',
		exibirMatricula: 'Ver la matrícula',
		farol: 'Faro',
		informacoesMatricula: 'Información sobre la inscripción',
		matriculaSalva: 'Matrícula ¡Salva con éxito!',
		naoSalva: 'No Salva',
		numeroMatricula: 'Número de matrícula',
		permissaoResidencia: 'Permiso de residencia',
		qtdDias: 'Cant. Días',
		requerimentoDoCantidado: 'Solicitud del Candidato',
		responsavelMatricula: 'RESPONSABLE DE LA MATRÍCULA',
		termoMatricula: 'Término de matrícula',
		termoTexto: 'DECLARACIÓN DE QUE ESTE(A) ALUMNO(A) ENCUENTRA MATRICULADO (A) EN ESTE TREINAMENTO A PARTIR DE <strong>{{dataMatricula}}</strong> MÁTRICULA <STRONG>{{matricula}}</strong> YA ESTO ENTREGAS LAS COPIAS DE LA DOCUMENTACIÓN EXIGIDA ACOMPAÑADAS DE <STRONG>{{qtd4x4}}</STRONG> RETRATOS 3X4.',
		tipos: 'Tipos',
		tituloEleitor: 'Título de elector',
		unidadeArmazenamento: 'Unidad de almacenamiento',
	},
	menuMoficina: {
		cadOficinaTitulo: 'Registro de Taller',
		menuMaddOficina: 'Taller insertada',
		menuMattOficina: 'Taller actualizada',
		menuMcadOficina: 'Nueva Taller',
		menuMeditOficina: 'Editar Taller',
		menuMresponsavel: 'Responsable',
		menuMtexto1: 'Clic en Nueva Taller',
		menuMtexto2: 'Clic en el ícono',
		menuMtexto3: ' na lista opuesta.',
	},
	menuMonitoramento: {
		horaDia: 'Hora/Día',
		horaMes: 'Hora/Mes',
		menuAeronaveNaoVoou: 'La aeronave aún no vuela hoy.',
		menuMonitora: 'Monitoreo',
		menuMonitoraAeronaves: 'Aeronaves',
		menuTempoReal: 'Tiempo Real',
		nenhumaManutencao: 'No hay mantenimientos programados.',
		totalCiclosVoadios: 'Total de ciclos volados',
		voosDia: 'Vuelos del día',
	},
	menuMsolicitaManutencao: {
		menuMsolicitaAdd: 'Solicitud de mantenimiento actualizada.',
		menuMsolicitaAtt: 'Solicitud de mantenimiento insertada.',
		menuMsolicitaCancelar: '¿Desea cancelar esta solicitud de mantenimiento?',
		menuMsolicitaDisponibilidade: 'Disponibilidad',
		menuMsolicitaEscolha: 'Elija las inspecciones abajo',
		menuMsolicitaEvento: 'Evento',
		menuMsolicitaHhora: 'Hombres Hora',
		menuMsolicitaHtotais: 'Horas Totales',
		menuMsolicitaInspecoes: 'Inspecciones',
		menuMsolicitaManutencoes: 'Solicitudes de mantenimiento',
		menuMsolicitaMesesDias: 'Meses / Días',
		menuMsolicitaModalidade: 'Modo',
		menuMsolicitaNivel: 'Nivel',
		menuMsolicitaProxInspecao: 'Siguiente inspección',
		menuMsolicitaReferente: 'Solicitudes de aeronave',
		menuMsolicitaSelecione: 'Seleccione una o varias inspecciones a continuación y haga clic en AGREGAR',
		menuMsolicitaTipo: 'Tipo',
	},
	menuOpRadio: {
		carregando: 'Cargando escala rádio operador',
	},
	menuOrdemMissao: {
		menuMissao: 'Misión',
		menuNova: 'Nueva',
		menuNovaOrdem: 'Nueva Orden',
		menuOrdem: 'Orden',
		menuOrdemEscolha: 'Elección',
		menuOrdemSolicitacao: 'Solicitud',
		menuOrdemmissao: 'Orden Misión:',
	},
	menuOrgaoApoiados: {
		orgao: 'Órgano',
		orgaoApoiados: 'Órgano Apoyado',
		orgaoCadastro: 'Registro de Órgano',
		orgaosApoiados: 'Órganos Apoyados',
	},
	menuRGestatisticaVoo: {
		menuAeronave: 'Aeronave',
	},
	menuRGhorasVoadas: {
		menuRGIntervalo: 'Intervalo',
		menuRGaeronave: 'Aeronave',
		menuRGdataFim: 'Fecha Fin',
		menuRGdataInicio: 'Fecha Inicio',
		menuRGhorasReportadas: 'Horas Reportadas',
		menuRGou: 'O',
		menuRGrelatorio: 'Este informe tiene fines operacionales pudiendo generar diferencias de más o de menos en el total de las horas voladas cuando se compara con la bitácora.',
	},
	menuRGoperacoes: {
		menuAeronave: 'Aeronave',
		menuRGcomb: 'Comb.',
		menuRGde: 'De',
		menuRGpara: 'Para',
		menuRGpartida: 'Partida',
		menuRGpax: 'Pasajeros',
		menuRGpousos: 'Aterrizajes',
		menuRGtdec: 'T Dec',
		menuRGtipo: 'Tipo',
		menuRGtvoo: 'T Vuelo',
		menuRelatorioOp: 'Informe de Operaciones',
		menuTipo: 'Tipo',
	},
	menuRGordemmissao: {
		menuOMadicionados: 'Agregados:',
		menuOMcargo: 'Cargo:',
		menuOMcoordenador: 'Coordinador:',
		menuOMdataInicio: 'El período de Orden de Misión debe estar entre el período de la Solicitud.',
		menuOMdataMaior: 'La fecha inicial no puede ser mayor que la fecha final.',
		menuOMemail: 'Correo electrónico:',
		menuOMenviar: 'Enviar y guardar',
		menuOMescolha: 'Elección',
		menuOMfim: 'Fin',
		menuOMguarnicao: 'Guarnición Aérea:',
		menuOMinicio: 'Inicio',
		menuOMlotacao: 'Capacidad:',
		menuOMmissao: 'Orden de Misión',
		menuOMnaoDisponivel: 'No disponible en este momento.',
		menuOMnome: 'Nombre:',
		menuOMoperacao: 'Operación:',
		menuOMordemAdicionada: 'Orden agregada con éxito.',
		menuOMordemAtualizada: 'Orden actualizada con éxito.',
		menuOMordemEncerrada: 'Orden terminada con éxito.',
		menuOMorgao: 'Organización:',
		menuOMprioridade: 'Prioridad:',
		menuOMsemdados: 'No se encuentran datos.',
		menuOMtelefone: 'Teléfono:',
		menuOMtripulantes: 'Tripulantes:',
	},
	menuRGsolicitacoes: {
		menuRGnome: 'Nombre:',
		menuRGoperacao: 'Operación:',
		menuRGorgao: 'Organización:',
		menuRGprioridade: 'Prioridad:',
		menuRGrSolicitacoes: 'Informe de Solicitudes',
		menuRGsemdados: 'No se encuentran datos.',
		menuRGsolicitacao: 'Solicitudes',
	},
	menuRastreamento: {
		menuRastrea: 'Seguimiento',
		menuRastreaAeronave: 'Aeronave',
		menuRmudar: 'Cambiar',
		menuRtotal: 'Total',
	},
	menuSegurancaOperacional: {
		acaoesMitigatorias: 'Acciones mitigantes',
		acaoesadicionaisMitigatorias: 'Información adicional sobre acciones mitigantes',
		acesso: 'Acceso',
		acionadoOrgaosExternos: 'Se han activado los órganos externos que forman parte de <PRE-XXX> y / o <PLEM-SXXX>?',
		acoesForamSuficienteFinal: 'Fueron suficientes acciones de mitigación?',
		acoesMitigadoras: 'Acciones mitigantes',
		acoesimplementadas: 'Acciones de mitigación implementadas',
		acoessuficientes: 'Las acciones de mitigación fueron suficientes',
		acsp: 'Actividad criminal o uso de sustancias prohibidas.',
		analiseEvento: 'Análisis de eventos',
		analiseExecucao: 'Análisis de eventos de ESO',
		analiseFinal: 'Análisis Finales',
		analiseInicial: 'Analisis inicial',
		ccf: 'Certificado de capacidad técnica - CCF',
		ceanac: 'Certificado emitido por ANAC',
		cht: 'Certificado de cualificación técnica - CHT',
		cliente: 'Cliente',
		codigo: 'Código',
		codigoControleInterno: 'Código de control interno',
		codigoESO: 'Código ESO',
		codigoOACI: 'Código de la OACI',
		comoFoiAcionado: 'Cómo se activó',
		condicoesEmQue: 'Condiciones bajo las cuales',
		coordenador: 'Coordinador Responsable',
		dataDoOcorrido: 'Fecha de ocurrencia',
		dataEso: 'Fecha',
		dataOcorrido: 'Fecha en que ocurrió',
		deficienciasIdentificadas: 'Deficiencias encontradas en la información',
		deficienciasPorFaltaRecursos: 'Deficiencias identificadas',
		descricao: 'Descripción',
		descricaoEvento: 'Descripción del evento.',
		descricaoSimplificada: 'Descripción simplificada',
		disponibilizacaoAcomodacoes: 'Se ha puesto a disposición de los miembros de la familia y del público en general?',
		documentoOrigem: 'Documento fuente',
		empresa: 'Empresa',
		encaminhado: 'Reenviado en',
		encaminharEso: 'Reenviar ESO a ANAC',
		enviarApreciacao: 'Enviar respuesta al resp. por agradecimiento',
		enviarRelator: 'Enviar respuesta al relator',
		evacuacaoTripulantes: 'Descripción de la evacuación de la tripulación / pasajeros.',
		eventoOperacionalRelatadoAspectos: 'El evento de seguridad operacional informado (ESO) involucra uno de los siguientes aspectos',
		executivo: 'Ejecutivo',
		exemplar: 'La copia ',
		existiaExemplar: 'Hubo una copia ',
		fase: 'Fase',
		faseApreciacao: 'Fase de Apreciación completada',
		faseExecucao: 'Fase de Ejecución completada',
		faseInclusao: 'Fase de inclusión completada',
		fatoresContribuintes: 'Factores contribuyentes',
		foramAdequados: ' fueron adecuados y suficientes para el desmantelamiento de la pista?',
		gestorSegurancaOperacional: 'Gerente de Seguridad Operacional',
		hora: 'Horas',
		horaDoOcorrido: 'Hora de ocurrencia',
		houveDerramamentoCombustivel: 'Se derramó combustible o aceite en la pista o ubicación?',
		identificacao: 'Identificación',
		identifiqueAsCargas: 'Identificar la carga peligrosa presente en el evento:',
		incidencia: 'Incidencias',
		informacoesAtenderam: 'La información satisfizo las necesidades?',
		informante: 'Quien reportó',
		localDoOcorrido: 'Ubicación',
		localEvento: 'Ubicación del evento',
		motivosAcoesNaoSuficiente: 'Razones de no suficiencia',
		nao: 'No',
		notificar: 'Notificar para su cumplimiento después de completar la evaluación',
		notificarCoordenador: 'Notificar al coordinador después de completar la inclusión',
		novo: 'Nuevo',
		numero: 'Número',
		numeroDocumentoOrigem: 'Documento fuente No.',
		opcoes: 'Opciones',
		organizacoesEnvolvidas: 'Organizaciones involucradas',
		orgaosEnvolvidos: 'Cuerpos externos involucrados',
		outrasInformacoes: 'Otras informaciones',
		paralisacaoOperacoes: 'Se detuvieron las operaciones?',
		pistaInterditada: 'Estaba bloqueada la pista?',
		prazoEnvia: 'Plazo de presentación ante la ANAC',
		quaisAcoesAdicionaisAdotadas: '¿Qué acciones adicionales se deben tomar?',
		questionarioGestorSegurancaOperacional: 'Sobre el gerente de seguridad operacional',
		recursosDisponiveis: 'Los recursos disponibles en ',
		remetente: 'Nombre del remitente',
		responasavelExecucoes: 'Responsable de las acciones',
		responsavelApreciacao: 'Responsable de Apreciación',
		respostaEnviadaAoRelator: 'Respuesta enviada al ponente?',
		setores: 'Sectores',
		setoresResponsaveis: 'Sectores responsables de mitigación',
		sim: 'Sí',
		situacao: 'Situación',
		situacaoRelatada: 'Situación reportada',
		tempoPistaInterditada: 'Tiempo de seguimiento bloqueado',
		tempoRetomadaOperacoes: 'Hora en que las operaciones volvieron a la normalidad',
		tipoSituacao: 'Tipo de situación',
	},
	menuSistema: {
		suporteTecnico: 'Apoyo técnico',
		usuarioSistema: 'Usuario del sistema',
	},
	menuSolicitaApoio: {
		apoioAereo: 'Apoyo aéreo',
		apoioAereoEmergencial: 'APOYO AÉREO DE EMERGENCIA',
		codigoPnapa: 'Código Pnapa',
		corrigirCampos: 'Por favor corrija los campos en rojo arriba.',
		dadosAtualizados: '¡Datos actualizados con éxito!',
		destino: 'Destino',
		escolhaArquivo: 'Escoja un archivo y haga clic en cargar.',
		escolherLocal: 'Debe escoger al menos un lugar.',
		menuCargo: 'Cargo',
		menuCoordenador: 'Coordinador Suelo',
		menuCoordenadorSolo: 'Coordinador Suelo',
		menuDataEfim: 'La fecha de inicio y fin son obligatorias',
		menuEscolha: 'Elección',
		menuFimOperacao: 'Fecha Fin Operación',
		menuGrauPrioridade: 'Grado de prioridad',
		menuInicioOperacao: 'Fecha Inicio Operación',
		menuLocalOperacao: 'Lugar de Operación',
		menuMissaoApoio: 'Misión de Apoyo',
		menuNomeOperacao: 'Nombre de la Operación',
		menuNovaSolicitacao: 'Nueva Solicitud',
		menuOrgaoSolicitante: 'Organización Solicitante',
		menuSolicitaNova: 'Nueva',
		menuSolicitacao: 'Solicitud',
		menuTipoOcorrencia: 'Tipo de Ocurrencia',
		naturezaEtipo: 'Ud. debe ingresar al menos una Naturaleza y Tipo.',
		novaOrdemMissao: 'Nueva Orden de Misión',
		ordemMissaoInserida: 'Nueva Orden de Misión insertada con éxito.',
		partida: 'Salida',
		removidos: 'Todos eliminados.',
		solicitaApoio: 'Solicitud',
		solicitacaoAdicionada: 'Solicitud agregada con éxito.',
		solicitacaoAtualizada: 'Solicitud actualizada con éxito.',
		statusAtualizado: 'Estado actualizado con éxito.',
	},
	menuTripOperacional: {
		carregando: 'Cargando escala operacional',
		escalaD: 'D - NORMAL',
		escalaE: 'E - EXPEDIENTE',
		escalaS: 'S - GUARDIA',
	},
	menuUsuarioANAC: {
		codigoAviacao: 'código ANAC',
	},
	menuVoo: {
		menuVaeronave: 'Aeronave:',
		menuVaerotatico: 'Ope. Aerotáctica/ Sup. Médico',
		menuVatualizaTrechos: 'Actualizar Tramos',
		menuVatualizaTrechos2: 'Al actualizar los tramos el sistema buscará todos los tramos del día y los incluirá en el informe de vuelo. Tramos alterados se mantendrán.',
		menuVbaseArapiraca: 'Base Arapiraca',
		menuVbaseMaceio: 'Base Maceió:4009-2040',
		menuVcaesp: 'CAESP',
		menuVchefeCaesp: 'Jefe de la CAESP',
		menuVchefeOp: 'Jefe de Operaciones',
		menuVcodigo: 'Código',
		menuVcomb: 'Comb.',
		menuVcontato: 'Contacto:',
		menuVcorte: 'Corte',
		menuVde: 'De',
		menuVerroVoos: 'Error al cargar los vuelos del mes.',
		menuVescolha: 'Escoja la aeronave para cargar los días volados.',
		menuVestadoAlagoas: 'Estado de Alagoas',
		menuVfechaRelatorio: 'Fecha Informe',
		menuVhistorico: 'Histórico de los extractos',
		menuVmapa: 'Mapas de los Tramos',
		menuVmissao: 'Misión',
		menuVmodelo: 'Modelo',
		menuVnaturezaVoo: 'Naturaleza del vuelo',
		menuVnum: 'N°',
		menuVnumRelatorio: 'Informe N°:',
		menuVnumTrecho: 'Tramos N°',
		menuVocorrencia: 'Ocurrencia:',
		menuVpara: 'Para',
		menuVpartida: 'Partida',
		menuVpax: 'Pax.',
		menuVpousos: 'Aterrizajes',
		menuVprefixo: 'Prefijo',
		menuVreabreRelatorio: 'Reabrir Informe',
		menuVrelatorio: 'Informe de Vuelo',
		menuVsemMapa: 'No se encuentra map.a',
		menuVssp: 'SSP',
		menuVtdec: 'T Vuelo Dec',
		menuVtdesc: 'T Vuelo Décimo',
		menuVtipoMissao: 'Tipo de Misión',
		menuVtotal: 'Total',
		menuVtrechos: 'Tramos',
		menuVtvoo: 'T Vuelo',
		menuVvoo: 'T Vuelo',
	},
	meses: {
		abril: 'Abril',
		agosto: 'Agosto',
		dezembro: 'Diciembre',
		fevereiro: 'Febrero',
		janeiro: 'Enero',
		julho: 'Julio',
		junho: 'Junio',
		maio: 'Puede',
		marco: 'Marzo',
		novembro: 'Noviembre',
		outubro: 'Octubre',
		setembro: 'Septiembre',
	},
	nomesMes: {
		abril: 'Abril',
		agosto: 'Agosto',
		dezembro: 'Diciembre',
		fevereiro: 'Febrero',
		janeiro: 'Enero',
		julho: 'Julio',
		junho: 'Junio',
		maio: 'Mayo',
		marco: 'Marzo',
		novembro: 'Noviembre',
		outubro: 'Octubre',
		setembro: 'Septiembre',
	},
	numeroMes: {
		1: 'Enero',
		2: 'Febrero',
		3: 'Marzo',
		4: 'Abril',
		5: 'Mayo',
		6: 'Junio',
		7: 'Julio',
		8: 'Agosto',
		9: 'Septiembre',
		10: 'Octubre',
		11: 'Noviembre',
		12: 'Diciembre',
	},
	pais: {
		alemao: 'alemán',
		brasil: 'Portugués',
		espanhol: 'Español',
		eua: 'Inglés',
		frances: 'francés',
		ingles: 'Inglés',
		italiano: 'Italiano',
		paraguai: 'Español',
		portugues: 'Portugués',
	},
	perfil: {
		PerfilInserido: 'Perfil insertado',
		clickEmNovo: 'Haga clic en Nuevo',
		editarPerfil: 'Editar Perfil',
		nomePerfil: 'Nombre de perfil',
		novoPerfil: 'Perfil nueva',
		paraAdicionar: 'agregar',
		perfilAtualizado: 'Perfil actualizado',
		perfilDoUsuario: 'Perfil de usuario',
	},
	rampa: {
		adicionar: 'Agregar',
		aeronaves: 'Aeronave',
		cabecalhoHtml: '<h3>MONITOREO DE</h3><h4 style=cursor: pointer>RAMPA</h4>',
		canac: 'CANAC',
		cpf: 'CPF',
		descricao: 'Descripción',
		digiteODesignativoDesejado: 'Escriba la designación deseada',
		digiteOQueDesejaPesquisar: 'Escriba lo que desea buscar',
		documentoComDataValida: 'El documento está dentro de la fecha de vencimiento',
		documentos: 'Documentos',
		filtrarPor: 'Filtrar por',
		menuHtml: '<div class=sub-text>MONITOREO DE</div><div class=sub-text>RAMPA</div>',
		naoExisteTripulantes: 'Use las opciones anteriores para filtrar la tripulación.',
		nenhumDesignativoEncontrado: 'No hay designaciones para mostrar',
		nenhumDocumentoEncontrado: 'No hay documentos para mostrar.',
		nenhumaAeronaveEncontrada: 'No hay aeronaves para mostrar.',
		publicacoes: 'Publicaciones',
		selecioneQuaisInformacoes: 'Seleccione qué información se mostrará',
		selecioneUmaAeronave: 'Seleccionar una aeronave',
		semDocumentosTripulante: 'No hay documentos adjuntos para esta tripulación.',
		status: 'Estado',
		tripulacao: 'Tripulación',
		tripulante: 'Tripulante',
		tripulantes: 'Tripulantes',
		ultimoDespachoDoVoo: 'Último dispacho do vuelo',
		validade: 'Validez',
		verificarDataDoDocumento: 'Compruebe la fecha de caducidad del documento',
		visualizarDiarioDeBordo: 'Ver libro de registro',
	},
	registroDadosVoo: {
		aceleracaoVertical: 'Aceleración vertical',
		altitudeAeronave: 'Aviones actitud',
		altitudeTerreno: 'Altitud Absoluta',
		altitudeVoo: 'Altitud de vuelo',
		alturaVoo: 'Altura del vuelo',
		pressaoDoOleoTurbina: 'Turbina de presión de aceite',
		pressaoOleo: 'La presión de aceite',
		proa: 'ARCO',
		torque: 'Torque',
		turbina: 'Turbina',
		variacaoTorque: 'Gama de par',
		variaveisDeMonitoramento: 'SEGUIMIENTO DE VARIABLE',
		velocidadeAeronave: 'Velocidad',
		visualizacaoGraficos: 'Gráficos de visualización',
		visualizacaoInstrumentos: 'Vista de instrumentos',
	},
	submenu: {
		ControleAtividadeAerea: 'Control de actividad aérea',
		ExtratoCompleto: 'Extracto Completo',
		aeronaves: 'Aeronaves',
		agruparTreinamentos: 'Entrenamientos grupales',
		areaDoAluno: 'Área de estudiantes',
		areaDoGestor: 'Área de Gerente',
		cadAcao: 'Tipo de acción de registro',
		cadAfastamento: 'Administrativo de declaración de registro',
		cadCargo: 'Posteriores a su registro',
		cadEscala: 'Registro de Escalas',
		cadEvento: 'Registro de eventos',
		cadPosto: 'Posteriores a su registro',
		cadPrevencao: 'Registro de Prevención',
		cadUser: 'Registro de Usuario',
		cadastroGrupoInspecao: 'Register Grupo de Inspección',
		comunicacaoESO: 'Gestión de riesgos',
		dataDeConclusao: 'Fecha de finalizacion',
		disciplina: 'Disciplina',
		escala: 'Escala',
		escalas: 'Balanza',
		estatisticaVoo: 'Estadística de Vuelo',
		eventoSegurancaOperacionalEso: 'Evento de seguridad operativa (ESO)',
		gestaoDeEnsino: 'Gestión docente',
		gestaoDeFrequenciaAvaliacao: 'Frecuencias y evaluaciones de gestión de clases',
		gestaoDoEnsino: 'Gestión de la Enseñanza',
		gestaoEscalas: 'Gestión de escala',
		horasRastreadas: 'Horas rastreadas',
		horasVoadas: 'Horas Voladas',
		inscricoesEMatricula: 'Inscripciones y matrículas',
		mostradores: 'Monitores',
		permutas: 'Intercambios Licencias Médicas y Liberaciones',
		prazoParaExecucao: 'Fecha límite para la ejecución',
		relatorioOperacoes: 'Informe de Operaciones',
		relatorioPrevencao: 'Informe de Prevención',
		relatorioSolicitacoes: 'Informe de solicitudes',
		relatorioVoo: 'Informe de Vuelo',
		segurancaOperacionalEso: 'Gestión de riesgos (ESO)',
		segurancaOperacionalRac: 'Informe de aviación civil (RAC)',
		segurancaOperacionalRelPrev: 'Informe de prevención (RelPrev)',
		segurancaOperacionalRire: 'Informe inicial de respuesta de emergencia (RIRE)',
		subAdministracao: 'Administración',
		subAtaConclusao: 'Acta de conclusión',
		subCertificadoConclusao: 'Certificado de finalización de la formación',
		subEnsino: 'Ensino',
		subEscolar: 'Escolar',
		subFichaDeAvaliacao: 'Formulario de evaluación de la performance de vuelo (FADV)',
		subFichaDeAvaliacaoTeorica: 'Ficha de Seguimiento del Desempeño Teórico (FADT)',
		subOrdem: 'de Misión',
		subPagamentos: 'Pagamentos',
		subRelatorio: 'Informes',
		subRelatorioOrdem: 'Informe Orden',
		subSolicitacoes: 'Solicitudes',
		subTurmas: 'Clases',
		telaCheia: 'Pantalla Completa',
		teoricoEPratico: 'Teórico y práctico',
		treinamento: 'Capacitación',
	},
	uploadfile: {
		arquivoRequired: 'Requerido para insertar un archivo',
		download: 'Descargar',
		erroMSG: 'No se permite este tipo de archivo',
		extPermitidas: 'Extensiones permitidas',
		foto: 'Foto',
		tituloForm: 'Anexar Archivo',
	},
}